// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file src/protos/learning_management/lms.assessment.teacher.apis.proto (package geneo.lms.assessment.teacher.apis, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64, Timestamp } from "@bufbuild/protobuf";
import { AssessmentEnum, AssignmentInfo, AttemptStats, AttemptTypeEnum, AttendanceInfo, ChapterIdsInfo, CloudUpload, MarkingSchemeEnum, ModeOfConductionEnum, MultiSubjectSection, MultiSubjectSectionTemplate, QpgSubsectionTypeEnum, QuestionModuleMap, QuestionPaperTemplate, QuestionSection, QuestionSectionMeta, QuestionTypeMarks, StudentPracticalResponse, SubmissionType, TaskCreationStatusEnum, TaskEnum, TaskMetaInfo, TaskResourceInfoMetaData, TimeStampWithKey } from "@protos/learning_management/lms.db_pb";
import { AssessmentListEnum, GilAttentionItem, GilClassSectionInfo, GilCodingActivity, GilCodingSummary, GilDataStatus, GilGalleryItem, GilLearningOutcomeScore, GilProgressMetrics, GilProjectInfo, GilProjectScore, GilProjectStatusEnum, GilTimeSpent, GilWeeklyPoint, MultiSubjectMetrics } from "@protos/learning_management/lms.assessment.student.apis_pb";
import { AssessmentTask } from "@protos/learning_management/lms.assessment.common.apis_pb";
import { BloomLevelEnum, DifficultyLevelEnum, Module_ModuleCategoryEnum, Question, Question_QuestionEnum, Resource_ResourceEnum, ResourceCategoryEnum } from "@protos/content_management/content.db_pb";
import { DifficutlyLevelQuestions, QuestionTypeCount, RequiredQuestionCountInfoForDifficultyLevel } from "@protos/learning_management/lms.hw.teacher.apis_pb";
import { ProfileRolesEnum } from "@protos/user_management/ums.db_pb";
import { Subject_SubjectEnum } from "@protos/common/common.db_pb";

/**
 * @generated from enum geneo.lms.assessment.teacher.apis.AssessmentCreationEnum
 */
export enum AssessmentCreationEnum {
  /**
   * @generated from enum value: ASSESSMENT_CREATION_UNDEFINED = 0;
   */
  ASSESSMENT_CREATION_UNDEFINED = 0,

  /**
   * @generated from enum value: ASSESSMENT_CREATION_HOMEWORK = 1;
   */
  ASSESSMENT_CREATION_HOMEWORK = 1,

  /**
   * @generated from enum value: ASSESSMENT_CREATION_FORMATIVE = 2;
   */
  ASSESSMENT_CREATION_FORMATIVE = 2,

  /**
   * @generated from enum value: ASSESSMENT_CREATION_QUESTION_PAPER = 4;
   */
  ASSESSMENT_CREATION_QUESTION_PAPER = 4,
}
// Retrieve enum metadata with: proto3.getEnumType(AssessmentCreationEnum)
proto3.util.setEnumType(AssessmentCreationEnum, "geneo.lms.assessment.teacher.apis.AssessmentCreationEnum", [
  { no: 0, name: "ASSESSMENT_CREATION_UNDEFINED" },
  { no: 1, name: "ASSESSMENT_CREATION_HOMEWORK" },
  { no: 2, name: "ASSESSMENT_CREATION_FORMATIVE" },
  { no: 4, name: "ASSESSMENT_CREATION_QUESTION_PAPER" },
]);

/**
 * @generated from enum geneo.lms.assessment.teacher.apis.PerformanceEnum
 */
export enum PerformanceEnum {
  /**
   * @generated from enum value: PERFORMANCE_UNDEFINED = 0;
   */
  PERFORMANCE_UNDEFINED = 0,

  /**
   * @generated from enum value: PERFORMANCE_LOW = 1;
   */
  PERFORMANCE_LOW = 1,

  /**
   * @generated from enum value: PERFORMANCE_AVERAGE = 2;
   */
  PERFORMANCE_AVERAGE = 2,

  /**
   * @generated from enum value: PERFORMANCE_EXCELLENT = 3;
   */
  PERFORMANCE_EXCELLENT = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(PerformanceEnum)
proto3.util.setEnumType(PerformanceEnum, "geneo.lms.assessment.teacher.apis.PerformanceEnum", [
  { no: 0, name: "PERFORMANCE_UNDEFINED" },
  { no: 1, name: "PERFORMANCE_LOW" },
  { no: 2, name: "PERFORMANCE_AVERAGE" },
  { no: 3, name: "PERFORMANCE_EXCELLENT" },
]);

/**
 * @generated from enum geneo.lms.assessment.teacher.apis.AiAssessmentEnum
 */
export enum AiAssessmentEnum {
  /**
   * @generated from enum value: ASSESSMENT_UNDEFINED = 0;
   */
  ASSESSMENT_UNDEFINED = 0,

  /**
   * @generated from enum value: ASSESSMENT_FORMATIVE_ASSESSMENT = 1;
   */
  ASSESSMENT_FORMATIVE_ASSESSMENT = 1,

  /**
   * @generated from enum value: ASSESSMENT_HOMEWORK = 2;
   */
  ASSESSMENT_HOMEWORK = 2,

  /**
   * @generated from enum value: ASSESSMENT_DIAGNOSTIC_ASSESSMENT = 3;
   */
  ASSESSMENT_DIAGNOSTIC_ASSESSMENT = 3,

  /**
   * @generated from enum value: ASSESSMENT_QUESTION_PAPER = 4;
   */
  ASSESSMENT_QUESTION_PAPER = 4,
}
// Retrieve enum metadata with: proto3.getEnumType(AiAssessmentEnum)
proto3.util.setEnumType(AiAssessmentEnum, "geneo.lms.assessment.teacher.apis.AiAssessmentEnum", [
  { no: 0, name: "ASSESSMENT_UNDEFINED" },
  { no: 1, name: "ASSESSMENT_FORMATIVE_ASSESSMENT" },
  { no: 2, name: "ASSESSMENT_HOMEWORK" },
  { no: 3, name: "ASSESSMENT_DIAGNOSTIC_ASSESSMENT" },
  { no: 4, name: "ASSESSMENT_QUESTION_PAPER" },
]);

/**
 * @generated from message geneo.lms.assessment.teacher.apis.GetTeacherAssessmentsListRequest
 */
export class GetTeacherAssessmentsListRequest extends Message<GetTeacherAssessmentsListRequest> {
  /**
   * ID of the teacher
   *
   * @generated from field: int64 teacher_id = 1;
   */
  teacherId = protoInt64.zero;

  /**
   * ID of the course (optional)
   *
   * @generated from field: optional int32 subject_id = 2;
   */
  subjectId?: number;

  /**
   * @generated from field: optional int64 section_id = 3;
   */
  sectionId?: bigint;

  /**
   * @generated from field: optional int32 page_number = 5;
   */
  pageNumber?: number;

  /**
   * @generated from field: optional int32 items_per_page = 6;
   */
  itemsPerPage?: number;

  /**
   * @generated from field: optional geneo.lms.db.AssessmentEnum assessment_type = 7;
   */
  assessmentType?: AssessmentEnum;

  /**
   * @generated from field: optional geneo.lms.assessment.student.apis.AssessmentListEnum assessment_list_type = 8;
   */
  assessmentListType?: AssessmentListEnum;

  /**
   * @generated from field: optional geneo.lms.db.ModeOfConductionEnum mode_of_conduction = 9;
   */
  modeOfConduction?: ModeOfConductionEnum;

  constructor(data?: PartialMessage<GetTeacherAssessmentsListRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.GetTeacherAssessmentsListRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "teacher_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "subject_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 3, name: "section_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 5, name: "page_number", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 6, name: "items_per_page", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 7, name: "assessment_type", kind: "enum", T: proto3.getEnumType(AssessmentEnum), opt: true },
    { no: 8, name: "assessment_list_type", kind: "enum", T: proto3.getEnumType(AssessmentListEnum), opt: true },
    { no: 9, name: "mode_of_conduction", kind: "enum", T: proto3.getEnumType(ModeOfConductionEnum), opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetTeacherAssessmentsListRequest {
    return new GetTeacherAssessmentsListRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetTeacherAssessmentsListRequest {
    return new GetTeacherAssessmentsListRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetTeacherAssessmentsListRequest {
    return new GetTeacherAssessmentsListRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetTeacherAssessmentsListRequest | PlainMessage<GetTeacherAssessmentsListRequest> | undefined, b: GetTeacherAssessmentsListRequest | PlainMessage<GetTeacherAssessmentsListRequest> | undefined): boolean {
    return proto3.util.equals(GetTeacherAssessmentsListRequest, a, b);
  }
}

/**
 * Response model for /teacher/homework/list
 *
 * @generated from message geneo.lms.assessment.teacher.apis.GetTeacherAssessmentsListResponse
 */
export class GetTeacherAssessmentsListResponse extends Message<GetTeacherAssessmentsListResponse> {
  /**
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * @generated from field: geneo.lms.assessment.teacher.apis.TeacherAssessmentsList assessment_list = 4;
   */
  assessmentList?: TeacherAssessmentsList;

  constructor(data?: PartialMessage<GetTeacherAssessmentsListResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.GetTeacherAssessmentsListResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "assessment_list", kind: "message", T: TeacherAssessmentsList },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetTeacherAssessmentsListResponse {
    return new GetTeacherAssessmentsListResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetTeacherAssessmentsListResponse {
    return new GetTeacherAssessmentsListResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetTeacherAssessmentsListResponse {
    return new GetTeacherAssessmentsListResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetTeacherAssessmentsListResponse | PlainMessage<GetTeacherAssessmentsListResponse> | undefined, b: GetTeacherAssessmentsListResponse | PlainMessage<GetTeacherAssessmentsListResponse> | undefined): boolean {
    return proto3.util.equals(GetTeacherAssessmentsListResponse, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.TeacherAssessmentsList
 */
export class TeacherAssessmentsList extends Message<TeacherAssessmentsList> {
  /**
   * @generated from field: int64 teacher_id = 1;
   */
  teacherId = protoInt64.zero;

  /**
   * @generated from field: optional int32 subject_id = 2;
   */
  subjectId?: number;

  /**
   * @generated from field: optional int64 section_id = 3;
   */
  sectionId?: bigint;

  /**
   * @generated from field: geneo.lms.assessment.teacher.apis.AssessmentList assessment_list = 6;
   */
  assessmentList?: AssessmentList;

  constructor(data?: PartialMessage<TeacherAssessmentsList>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.TeacherAssessmentsList";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "teacher_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "subject_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 3, name: "section_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 6, name: "assessment_list", kind: "message", T: AssessmentList },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TeacherAssessmentsList {
    return new TeacherAssessmentsList().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TeacherAssessmentsList {
    return new TeacherAssessmentsList().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TeacherAssessmentsList {
    return new TeacherAssessmentsList().fromJsonString(jsonString, options);
  }

  static equals(a: TeacherAssessmentsList | PlainMessage<TeacherAssessmentsList> | undefined, b: TeacherAssessmentsList | PlainMessage<TeacherAssessmentsList> | undefined): boolean {
    return proto3.util.equals(TeacherAssessmentsList, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.AssessmentList
 */
export class AssessmentList extends Message<AssessmentList> {
  /**
   * @generated from field: repeated geneo.lms.assessment.common.apis.AssessmentTask draft = 1;
   */
  draft: AssessmentTask[] = [];

  /**
   * @generated from field: repeated geneo.lms.assessment.common.apis.AssessmentTask assigned = 2;
   */
  assigned: AssessmentTask[] = [];

  /**
   * @generated from field: repeated geneo.lms.assessment.common.apis.AssessmentTask ended = 3;
   */
  ended: AssessmentTask[] = [];

  /**
   * @generated from field: optional geneo.lms.assessment.teacher.apis.AssessmentListCountInfo assesment_list_info = 4;
   */
  assesmentListInfo?: AssessmentListCountInfo;

  constructor(data?: PartialMessage<AssessmentList>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.AssessmentList";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "draft", kind: "message", T: AssessmentTask, repeated: true },
    { no: 2, name: "assigned", kind: "message", T: AssessmentTask, repeated: true },
    { no: 3, name: "ended", kind: "message", T: AssessmentTask, repeated: true },
    { no: 4, name: "assesment_list_info", kind: "message", T: AssessmentListCountInfo, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AssessmentList {
    return new AssessmentList().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AssessmentList {
    return new AssessmentList().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AssessmentList {
    return new AssessmentList().fromJsonString(jsonString, options);
  }

  static equals(a: AssessmentList | PlainMessage<AssessmentList> | undefined, b: AssessmentList | PlainMessage<AssessmentList> | undefined): boolean {
    return proto3.util.equals(AssessmentList, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.AssessmentListCountInfo
 */
export class AssessmentListCountInfo extends Message<AssessmentListCountInfo> {
  /**
   * @generated from field: int32 total_count = 1;
   */
  totalCount = 0;

  /**
   * @generated from field: int32 draft_count = 2;
   */
  draftCount = 0;

  /**
   * @generated from field: int32 active_count = 3;
   */
  activeCount = 0;

  /**
   * @generated from field: int32 ended_count = 4;
   */
  endedCount = 0;

  /**
   * @generated from field: int32 count_in_pagination = 5;
   */
  countInPagination = 0;

  /**
   * @generated from field: int32 clicker_assessments_count = 6;
   */
  clickerAssessmentsCount = 0;

  constructor(data?: PartialMessage<AssessmentListCountInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.AssessmentListCountInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "total_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "draft_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "active_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "ended_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "count_in_pagination", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "clicker_assessments_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AssessmentListCountInfo {
    return new AssessmentListCountInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AssessmentListCountInfo {
    return new AssessmentListCountInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AssessmentListCountInfo {
    return new AssessmentListCountInfo().fromJsonString(jsonString, options);
  }

  static equals(a: AssessmentListCountInfo | PlainMessage<AssessmentListCountInfo> | undefined, b: AssessmentListCountInfo | PlainMessage<AssessmentListCountInfo> | undefined): boolean {
    return proto3.util.equals(AssessmentListCountInfo, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.AssessmentCreationSubmitRequest
 */
export class AssessmentCreationSubmitRequest extends Message<AssessmentCreationSubmitRequest> {
  /**
   * ID of the teacher
   *
   * @generated from field: int64 teacher_id = 1;
   */
  teacherId = protoInt64.zero;

  /**
   * ID of the course
   *
   * @generated from field: int32 subject_id = 2;
   */
  subjectId = 0;

  /**
   * ID of the school class section
   *
   * @generated from field: int64 section_id = 3;
   */
  sectionId = protoInt64.zero;

  /**
   * Name of the task
   *
   * @generated from field: string task_name = 4;
   */
  taskName = "";

  /**
   * @generated from field: int32 module_id = 5;
   */
  moduleId = 0;

  /**
   * ID of the topic
   *
   * @generated from field: geneo.content.db.Module.ModuleCategoryEnum category = 6;
   */
  category = Module_ModuleCategoryEnum.MODULE_CATEGORY_UNDEFINED;

  /**
   * Information about selected tasks
   *
   * @generated from field: repeated geneo.lms.assessment.teacher.apis.TaskInfoModel selected_tasks_info = 7;
   */
  selectedTasksInfo: TaskInfoModel[] = [];

  /**
   * ID of the homework (optional)
   *
   * @generated from field: optional int64 assessment_id = 8;
   */
  assessmentId?: bigint;

  /**
   * Instructions for the homework (optional)
   *
   * @generated from field: repeated string instructions = 9;
   */
  instructions: string[] = [];

  /**
   * Status of the creation process
   *
   * @generated from field: geneo.lms.db.TaskCreationStatusEnum creation_status = 10;
   */
  creationStatus = TaskCreationStatusEnum.TASK_CREATION_STATUS_UNDEFINED;

  /**
   * @generated from field: geneo.lms.db.TaskEnum task_type = 11;
   */
  taskType = TaskEnum.TASK_UNDEFINED;

  /**
   * @generated from field: repeated geneo.lms.db.CloudUpload task_uploads = 12;
   */
  taskUploads: CloudUpload[] = [];

  /**
   * @generated from field: optional float max_marks = 13;
   */
  maxMarks?: number;

  /**
   * Only for teacher created CUSTOM hws
   *
   * @generated from field: optional geneo.lms.db.SubmissionType submission_type = 14;
   */
  submissionType?: SubmissionType;

  /**
   * @generated from field: optional int64 source_geneo_assessment_id = 15;
   */
  sourceGeneoAssessmentId?: bigint;

  /**
   * @generated from field: repeated geneo.lms.db.ChapterIdsInfo chapter_ids_info = 16;
   */
  chapterIdsInfo: ChapterIdsInfo[] = [];

  constructor(data?: PartialMessage<AssessmentCreationSubmitRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.AssessmentCreationSubmitRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "teacher_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "subject_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "section_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "task_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "module_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "category", kind: "enum", T: proto3.getEnumType(Module_ModuleCategoryEnum) },
    { no: 7, name: "selected_tasks_info", kind: "message", T: TaskInfoModel, repeated: true },
    { no: 8, name: "assessment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 9, name: "instructions", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 10, name: "creation_status", kind: "enum", T: proto3.getEnumType(TaskCreationStatusEnum) },
    { no: 11, name: "task_type", kind: "enum", T: proto3.getEnumType(TaskEnum) },
    { no: 12, name: "task_uploads", kind: "message", T: CloudUpload, repeated: true },
    { no: 13, name: "max_marks", kind: "scalar", T: 2 /* ScalarType.FLOAT */, opt: true },
    { no: 14, name: "submission_type", kind: "enum", T: proto3.getEnumType(SubmissionType), opt: true },
    { no: 15, name: "source_geneo_assessment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 16, name: "chapter_ids_info", kind: "message", T: ChapterIdsInfo, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AssessmentCreationSubmitRequest {
    return new AssessmentCreationSubmitRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AssessmentCreationSubmitRequest {
    return new AssessmentCreationSubmitRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AssessmentCreationSubmitRequest {
    return new AssessmentCreationSubmitRequest().fromJsonString(jsonString, options);
  }

  static equals(a: AssessmentCreationSubmitRequest | PlainMessage<AssessmentCreationSubmitRequest> | undefined, b: AssessmentCreationSubmitRequest | PlainMessage<AssessmentCreationSubmitRequest> | undefined): boolean {
    return proto3.util.equals(AssessmentCreationSubmitRequest, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.AssessmentCreationSubmitV2Request
 */
export class AssessmentCreationSubmitV2Request extends Message<AssessmentCreationSubmitV2Request> {
  /**
   * ID of the teacher
   *
   * @generated from field: int64 teacher_id = 1;
   */
  teacherId = protoInt64.zero;

  /**
   * ID of the course
   *
   * @generated from field: int32 subject_id = 2;
   */
  subjectId = 0;

  /**
   * ID of the school class section
   *
   * @generated from field: int64 section_id = 3;
   */
  sectionId = protoInt64.zero;

  /**
   * Name of the task
   *
   * @generated from field: string task_name = 4;
   */
  taskName = "";

  /**
   * @generated from field: optional int32 module_id = 5;
   */
  moduleId?: number;

  /**
   * ID of the topic
   *
   * @generated from field: geneo.content.db.Module.ModuleCategoryEnum category = 6;
   */
  category = Module_ModuleCategoryEnum.MODULE_CATEGORY_UNDEFINED;

  /**
   * Information about selected tasks
   *
   * @generated from field: repeated geneo.lms.assessment.teacher.apis.TaskInfoModel selected_tasks_info = 7;
   */
  selectedTasksInfo: TaskInfoModel[] = [];

  /**
   * ID of the homework (optional)
   *
   * @generated from field: optional int64 assessment_id = 8;
   */
  assessmentId?: bigint;

  /**
   * Instructions for the homework (optional)
   *
   * @generated from field: repeated string instructions = 9;
   */
  instructions: string[] = [];

  /**
   * Status of the creation process
   *
   * @generated from field: geneo.lms.db.TaskCreationStatusEnum creation_status = 10;
   */
  creationStatus = TaskCreationStatusEnum.TASK_CREATION_STATUS_UNDEFINED;

  /**
   * @generated from field: geneo.lms.db.TaskEnum task_type = 11;
   */
  taskType = TaskEnum.TASK_UNDEFINED;

  /**
   * @generated from field: repeated geneo.lms.db.CloudUpload task_uploads = 12;
   */
  taskUploads: CloudUpload[] = [];

  /**
   * @generated from field: optional float max_marks = 13;
   */
  maxMarks?: number;

  /**
   * Only for teacher created CUSTOM hws
   *
   * @generated from field: optional geneo.lms.db.SubmissionType submission_type = 14;
   */
  submissionType?: SubmissionType;

  /**
   * @generated from field: optional int64 source_geneo_assessment_id = 15;
   */
  sourceGeneoAssessmentId?: bigint;

  /**
   * @generated from field: repeated geneo.lms.db.ChapterIdsInfo chapter_ids_info = 16;
   */
  chapterIdsInfo: ChapterIdsInfo[] = [];

  /**
   * @generated from field: optional geneo.lms.db.ModeOfConductionEnum mode_of_conduction = 17;
   */
  modeOfConduction?: ModeOfConductionEnum;

  constructor(data?: PartialMessage<AssessmentCreationSubmitV2Request>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.AssessmentCreationSubmitV2Request";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "teacher_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "subject_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "section_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "task_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "module_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 6, name: "category", kind: "enum", T: proto3.getEnumType(Module_ModuleCategoryEnum) },
    { no: 7, name: "selected_tasks_info", kind: "message", T: TaskInfoModel, repeated: true },
    { no: 8, name: "assessment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 9, name: "instructions", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 10, name: "creation_status", kind: "enum", T: proto3.getEnumType(TaskCreationStatusEnum) },
    { no: 11, name: "task_type", kind: "enum", T: proto3.getEnumType(TaskEnum) },
    { no: 12, name: "task_uploads", kind: "message", T: CloudUpload, repeated: true },
    { no: 13, name: "max_marks", kind: "scalar", T: 2 /* ScalarType.FLOAT */, opt: true },
    { no: 14, name: "submission_type", kind: "enum", T: proto3.getEnumType(SubmissionType), opt: true },
    { no: 15, name: "source_geneo_assessment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 16, name: "chapter_ids_info", kind: "message", T: ChapterIdsInfo, repeated: true },
    { no: 17, name: "mode_of_conduction", kind: "enum", T: proto3.getEnumType(ModeOfConductionEnum), opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AssessmentCreationSubmitV2Request {
    return new AssessmentCreationSubmitV2Request().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AssessmentCreationSubmitV2Request {
    return new AssessmentCreationSubmitV2Request().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AssessmentCreationSubmitV2Request {
    return new AssessmentCreationSubmitV2Request().fromJsonString(jsonString, options);
  }

  static equals(a: AssessmentCreationSubmitV2Request | PlainMessage<AssessmentCreationSubmitV2Request> | undefined, b: AssessmentCreationSubmitV2Request | PlainMessage<AssessmentCreationSubmitV2Request> | undefined): boolean {
    return proto3.util.equals(AssessmentCreationSubmitV2Request, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.TaskInfoModel
 */
export class TaskInfoModel extends Message<TaskInfoModel> {
  /**
   * @generated from field: string question_id = 1;
   */
  questionId = "";

  /**
   * @generated from field: int32 sequence = 2;
   */
  sequence = 0;

  /**
   * @generated from field: optional float max_marks = 3;
   */
  maxMarks?: number;

  /**
   * @generated from field: optional int32 section_no = 4;
   */
  sectionNo?: number;

  constructor(data?: PartialMessage<TaskInfoModel>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.TaskInfoModel";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "question_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "sequence", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "max_marks", kind: "scalar", T: 2 /* ScalarType.FLOAT */, opt: true },
    { no: 4, name: "section_no", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TaskInfoModel {
    return new TaskInfoModel().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TaskInfoModel {
    return new TaskInfoModel().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TaskInfoModel {
    return new TaskInfoModel().fromJsonString(jsonString, options);
  }

  static equals(a: TaskInfoModel | PlainMessage<TaskInfoModel> | undefined, b: TaskInfoModel | PlainMessage<TaskInfoModel> | undefined): boolean {
    return proto3.util.equals(TaskInfoModel, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.AssessmentCreationSubmitResponse
 */
export class AssessmentCreationSubmitResponse extends Message<AssessmentCreationSubmitResponse> {
  /**
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * @generated from field: geneo.lms.assessment.teacher.apis.TeacherAssessmentCreationSubmit data = 4;
   */
  data?: TeacherAssessmentCreationSubmit;

  constructor(data?: PartialMessage<AssessmentCreationSubmitResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.AssessmentCreationSubmitResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "data", kind: "message", T: TeacherAssessmentCreationSubmit },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AssessmentCreationSubmitResponse {
    return new AssessmentCreationSubmitResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AssessmentCreationSubmitResponse {
    return new AssessmentCreationSubmitResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AssessmentCreationSubmitResponse {
    return new AssessmentCreationSubmitResponse().fromJsonString(jsonString, options);
  }

  static equals(a: AssessmentCreationSubmitResponse | PlainMessage<AssessmentCreationSubmitResponse> | undefined, b: AssessmentCreationSubmitResponse | PlainMessage<AssessmentCreationSubmitResponse> | undefined): boolean {
    return proto3.util.equals(AssessmentCreationSubmitResponse, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.TeacherAssessmentCreationSubmit
 */
export class TeacherAssessmentCreationSubmit extends Message<TeacherAssessmentCreationSubmit> {
  /**
   * @generated from field: geneo.lms.assessment.common.apis.AssessmentTask assessment = 1;
   */
  assessment?: AssessmentTask;

  constructor(data?: PartialMessage<TeacherAssessmentCreationSubmit>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.TeacherAssessmentCreationSubmit";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "assessment", kind: "message", T: AssessmentTask },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TeacherAssessmentCreationSubmit {
    return new TeacherAssessmentCreationSubmit().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TeacherAssessmentCreationSubmit {
    return new TeacherAssessmentCreationSubmit().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TeacherAssessmentCreationSubmit {
    return new TeacherAssessmentCreationSubmit().fromJsonString(jsonString, options);
  }

  static equals(a: TeacherAssessmentCreationSubmit | PlainMessage<TeacherAssessmentCreationSubmit> | undefined, b: TeacherAssessmentCreationSubmit | PlainMessage<TeacherAssessmentCreationSubmit> | undefined): boolean {
    return proto3.util.equals(TeacherAssessmentCreationSubmit, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.AssessmentAssignmentSubmitRequest
 */
export class AssessmentAssignmentSubmitRequest extends Message<AssessmentAssignmentSubmitRequest> {
  /**
   * @generated from field: int64 teacher_id = 1;
   */
  teacherId = protoInt64.zero;

  /**
   * @generated from field: int64 assessment_id = 2;
   */
  assessmentId = protoInt64.zero;

  /**
   * @generated from field: google.protobuf.Timestamp start_time = 3;
   */
  startTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp end_time = 4;
   */
  endTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp daily_reminder_time = 5;
   */
  dailyReminderTime?: Timestamp;

  /**
   * @generated from field: repeated string assessment_instructions = 6;
   */
  assessmentInstructions: string[] = [];

  /**
   * @generated from field: repeated int64 section_ids = 7;
   */
  sectionIds: bigint[] = [];

  /**
   * @generated from field: string assessment_name = 8;
   */
  assessmentName = "";

  /**
   * @generated from field: repeated geneo.lms.db.AssignmentInfo assignment_info = 9;
   */
  assignmentInfo: AssignmentInfo[] = [];

  /**
   * @generated from field: optional float time_duration_in_min = 10;
   */
  timeDurationInMin?: number;

  /**
   * @generated from field: optional geneo.lms.db.ModeOfConductionEnum mode_of_conduction = 11;
   */
  modeOfConduction?: ModeOfConductionEnum;

  /**
   * @generated from field: optional bool end_assessment_now = 12;
   */
  endAssessmentNow?: boolean;

  constructor(data?: PartialMessage<AssessmentAssignmentSubmitRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.AssessmentAssignmentSubmitRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "teacher_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "assessment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "start_time", kind: "message", T: Timestamp },
    { no: 4, name: "end_time", kind: "message", T: Timestamp },
    { no: 5, name: "daily_reminder_time", kind: "message", T: Timestamp },
    { no: 6, name: "assessment_instructions", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 7, name: "section_ids", kind: "scalar", T: 3 /* ScalarType.INT64 */, repeated: true },
    { no: 8, name: "assessment_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "assignment_info", kind: "message", T: AssignmentInfo, repeated: true },
    { no: 10, name: "time_duration_in_min", kind: "scalar", T: 2 /* ScalarType.FLOAT */, opt: true },
    { no: 11, name: "mode_of_conduction", kind: "enum", T: proto3.getEnumType(ModeOfConductionEnum), opt: true },
    { no: 12, name: "end_assessment_now", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AssessmentAssignmentSubmitRequest {
    return new AssessmentAssignmentSubmitRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AssessmentAssignmentSubmitRequest {
    return new AssessmentAssignmentSubmitRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AssessmentAssignmentSubmitRequest {
    return new AssessmentAssignmentSubmitRequest().fromJsonString(jsonString, options);
  }

  static equals(a: AssessmentAssignmentSubmitRequest | PlainMessage<AssessmentAssignmentSubmitRequest> | undefined, b: AssessmentAssignmentSubmitRequest | PlainMessage<AssessmentAssignmentSubmitRequest> | undefined): boolean {
    return proto3.util.equals(AssessmentAssignmentSubmitRequest, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.AssessmentAssignmentSubmitResponse
 */
export class AssessmentAssignmentSubmitResponse extends Message<AssessmentAssignmentSubmitResponse> {
  /**
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * @generated from field: geneo.lms.assessment.teacher.apis.TeacherAssessAssignmentSubmit data = 4;
   */
  data?: TeacherAssessAssignmentSubmit;

  constructor(data?: PartialMessage<AssessmentAssignmentSubmitResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.AssessmentAssignmentSubmitResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "data", kind: "message", T: TeacherAssessAssignmentSubmit },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AssessmentAssignmentSubmitResponse {
    return new AssessmentAssignmentSubmitResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AssessmentAssignmentSubmitResponse {
    return new AssessmentAssignmentSubmitResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AssessmentAssignmentSubmitResponse {
    return new AssessmentAssignmentSubmitResponse().fromJsonString(jsonString, options);
  }

  static equals(a: AssessmentAssignmentSubmitResponse | PlainMessage<AssessmentAssignmentSubmitResponse> | undefined, b: AssessmentAssignmentSubmitResponse | PlainMessage<AssessmentAssignmentSubmitResponse> | undefined): boolean {
    return proto3.util.equals(AssessmentAssignmentSubmitResponse, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.TeacherAssessAssignmentSubmit
 */
export class TeacherAssessAssignmentSubmit extends Message<TeacherAssessAssignmentSubmit> {
  /**
   * @generated from field: geneo.lms.assessment.common.apis.AssessmentTask updated_Assessment = 1;
   */
  updatedAssessment?: AssessmentTask;

  /**
   * @generated from field: repeated int64 section_ids = 2;
   */
  sectionIds: bigint[] = [];

  /**
   * Populated only when the request carried student_groups. Empty for every
   * existing assignment payload.
   *
   * @generated from field: repeated geneo.lms.assessment.teacher.apis.CollaborativeStudentGroupResult student_groups = 3;
   */
  studentGroups: CollaborativeStudentGroupResult[] = [];

  constructor(data?: PartialMessage<TeacherAssessAssignmentSubmit>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.TeacherAssessAssignmentSubmit";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "updated_Assessment", kind: "message", T: AssessmentTask },
    { no: 2, name: "section_ids", kind: "scalar", T: 3 /* ScalarType.INT64 */, repeated: true },
    { no: 3, name: "student_groups", kind: "message", T: CollaborativeStudentGroupResult, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TeacherAssessAssignmentSubmit {
    return new TeacherAssessAssignmentSubmit().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TeacherAssessAssignmentSubmit {
    return new TeacherAssessAssignmentSubmit().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TeacherAssessAssignmentSubmit {
    return new TeacherAssessAssignmentSubmit().fromJsonString(jsonString, options);
  }

  static equals(a: TeacherAssessAssignmentSubmit | PlainMessage<TeacherAssessAssignmentSubmit> | undefined, b: TeacherAssessAssignmentSubmit | PlainMessage<TeacherAssessAssignmentSubmit> | undefined): boolean {
    return proto3.util.equals(TeacherAssessAssignmentSubmit, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.GetModuleFilteredQuestionsRequest
 */
export class GetModuleFilteredQuestionsRequest extends Message<GetModuleFilteredQuestionsRequest> {
  /**
   * @generated from field: int64 teacher_id = 1;
   */
  teacherId = protoInt64.zero;

  /**
   * @generated from field: int32 subject_id = 2;
   */
  subjectId = 0;

  /**
   * @generated from field: repeated int32 module_ids = 3;
   */
  moduleIds: number[] = [];

  /**
   * @generated from field: repeated geneo.content.db.Question.QuestionEnum required_question_types = 4;
   */
  requiredQuestionTypes: Question_QuestionEnum[] = [];

  /**
   * @generated from field: repeated geneo.content.db.DifficultyLevelEnum required_difficulty_types = 5;
   */
  requiredDifficultyTypes: DifficultyLevelEnum[] = [];

  /**
   * @generated from field: optional geneo.lms.hw.teacher.apis.RequiredQuestionCountInfoForDifficultyLevel required_difficulty_levels_count_info = 6;
   */
  requiredDifficultyLevelsCountInfo?: RequiredQuestionCountInfoForDifficultyLevel;

  /**
   * @generated from field: repeated string qIdsToBeIgnored = 7;
   */
  qIdsToBeIgnored: string[] = [];

  /**
   * Filter by creator (teacher/admin/any user)
   *
   * @generated from field: optional int64 created_by_user_id = 8;
   */
  createdByUserId?: bigint;

  /**
   * Filter by school (null for Geneo content)
   *
   * @generated from field: optional int32 school_id = 9;
   */
  schoolId?: number;

  constructor(data?: PartialMessage<GetModuleFilteredQuestionsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.GetModuleFilteredQuestionsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "teacher_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "subject_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "module_ids", kind: "scalar", T: 5 /* ScalarType.INT32 */, repeated: true },
    { no: 4, name: "required_question_types", kind: "enum", T: proto3.getEnumType(Question_QuestionEnum), repeated: true },
    { no: 5, name: "required_difficulty_types", kind: "enum", T: proto3.getEnumType(DifficultyLevelEnum), repeated: true },
    { no: 6, name: "required_difficulty_levels_count_info", kind: "message", T: RequiredQuestionCountInfoForDifficultyLevel, opt: true },
    { no: 7, name: "qIdsToBeIgnored", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 8, name: "created_by_user_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 9, name: "school_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetModuleFilteredQuestionsRequest {
    return new GetModuleFilteredQuestionsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetModuleFilteredQuestionsRequest {
    return new GetModuleFilteredQuestionsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetModuleFilteredQuestionsRequest {
    return new GetModuleFilteredQuestionsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetModuleFilteredQuestionsRequest | PlainMessage<GetModuleFilteredQuestionsRequest> | undefined, b: GetModuleFilteredQuestionsRequest | PlainMessage<GetModuleFilteredQuestionsRequest> | undefined): boolean {
    return proto3.util.equals(GetModuleFilteredQuestionsRequest, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.GetModuleFilteredQuestionsResponse
 */
export class GetModuleFilteredQuestionsResponse extends Message<GetModuleFilteredQuestionsResponse> {
  /**
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * @generated from field: geneo.lms.assessment.teacher.apis.ModuleFilteredQuestions data = 4;
   */
  data?: ModuleFilteredQuestions;

  constructor(data?: PartialMessage<GetModuleFilteredQuestionsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.GetModuleFilteredQuestionsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "data", kind: "message", T: ModuleFilteredQuestions },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetModuleFilteredQuestionsResponse {
    return new GetModuleFilteredQuestionsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetModuleFilteredQuestionsResponse {
    return new GetModuleFilteredQuestionsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetModuleFilteredQuestionsResponse {
    return new GetModuleFilteredQuestionsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetModuleFilteredQuestionsResponse | PlainMessage<GetModuleFilteredQuestionsResponse> | undefined, b: GetModuleFilteredQuestionsResponse | PlainMessage<GetModuleFilteredQuestionsResponse> | undefined): boolean {
    return proto3.util.equals(GetModuleFilteredQuestionsResponse, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.ModuleFilteredQuestions
 */
export class ModuleFilteredQuestions extends Message<ModuleFilteredQuestions> {
  /**
   * @generated from field: repeated geneo.content.db.Question questions = 1;
   */
  questions: Question[] = [];

  /**
   * @generated from field: geneo.lms.db.TaskMetaInfo task_meta_info = 2;
   */
  taskMetaInfo?: TaskMetaInfo;

  /**
   * @generated from field: geneo.content.db.DifficultyLevelEnum avg_difficulty_level = 3;
   */
  avgDifficultyLevel = DifficultyLevelEnum.DIFFICULTY_LEVEL_UNDEFINED;

  /**
   * @generated from field: int32 approximate_time = 4;
   */
  approximateTime = 0;

  /**
   * @generated from field: optional geneo.lms.db.ModeOfConductionEnum mode_of_conduction = 5;
   */
  modeOfConduction?: ModeOfConductionEnum;

  /**
   * @generated from field: geneo.lms.assessment.teacher.apis.PaginationInfo pagination = 6;
   */
  pagination?: PaginationInfo;

  constructor(data?: PartialMessage<ModuleFilteredQuestions>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.ModuleFilteredQuestions";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "questions", kind: "message", T: Question, repeated: true },
    { no: 2, name: "task_meta_info", kind: "message", T: TaskMetaInfo },
    { no: 3, name: "avg_difficulty_level", kind: "enum", T: proto3.getEnumType(DifficultyLevelEnum) },
    { no: 4, name: "approximate_time", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "mode_of_conduction", kind: "enum", T: proto3.getEnumType(ModeOfConductionEnum), opt: true },
    { no: 6, name: "pagination", kind: "message", T: PaginationInfo },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ModuleFilteredQuestions {
    return new ModuleFilteredQuestions().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ModuleFilteredQuestions {
    return new ModuleFilteredQuestions().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ModuleFilteredQuestions {
    return new ModuleFilteredQuestions().fromJsonString(jsonString, options);
  }

  static equals(a: ModuleFilteredQuestions | PlainMessage<ModuleFilteredQuestions> | undefined, b: ModuleFilteredQuestions | PlainMessage<ModuleFilteredQuestions> | undefined): boolean {
    return proto3.util.equals(ModuleFilteredQuestions, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.PaginationInfo
 */
export class PaginationInfo extends Message<PaginationInfo> {
  /**
   * @generated from field: int32 current_page = 1;
   */
  currentPage = 0;

  /**
   * @generated from field: int32 items_per_page = 2;
   */
  itemsPerPage = 0;

  /**
   * @generated from field: int32 total_items = 3;
   */
  totalItems = 0;

  /**
   * @generated from field: int32 total_pages = 4;
   */
  totalPages = 0;

  constructor(data?: PartialMessage<PaginationInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.PaginationInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "current_page", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "items_per_page", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "total_items", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "total_pages", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PaginationInfo {
    return new PaginationInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PaginationInfo {
    return new PaginationInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PaginationInfo {
    return new PaginationInfo().fromJsonString(jsonString, options);
  }

  static equals(a: PaginationInfo | PlainMessage<PaginationInfo> | undefined, b: PaginationInfo | PlainMessage<PaginationInfo> | undefined): boolean {
    return proto3.util.equals(PaginationInfo, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.GetModuleFilteredQuestionsV2Request
 */
export class GetModuleFilteredQuestionsV2Request extends Message<GetModuleFilteredQuestionsV2Request> {
  /**
   * @generated from field: int64 teacher_id = 1;
   */
  teacherId = protoInt64.zero;

  /**
   * @generated from field: int32 subject_id = 2;
   */
  subjectId = 0;

  /**
   * @generated from field: repeated int32 module_ids = 3;
   */
  moduleIds: number[] = [];

  /**
   * @generated from field: repeated geneo.content.db.Question.QuestionEnum required_question_types = 4;
   */
  requiredQuestionTypes: Question_QuestionEnum[] = [];

  /**
   * @generated from field: repeated geneo.content.db.DifficultyLevelEnum required_difficulty_types = 5;
   */
  requiredDifficultyTypes: DifficultyLevelEnum[] = [];

  /**
   * @generated from field: optional geneo.lms.hw.teacher.apis.RequiredQuestionCountInfoForDifficultyLevel required_difficulty_levels_count_info = 6;
   */
  requiredDifficultyLevelsCountInfo?: RequiredQuestionCountInfoForDifficultyLevel;

  /**
   * @generated from field: repeated string qIdsToBeIgnored = 7;
   */
  qIdsToBeIgnored: string[] = [];

  /**
   * @generated from field: repeated geneo.content.db.BloomLevelEnum bloom_levels = 8;
   */
  bloomLevels: BloomLevelEnum[] = [];

  /**
   * @generated from field: optional int32 no_of_questions = 9;
   */
  noOfQuestions?: number;

  /**
   * @generated from field: optional int32 approximate_time = 10;
   */
  approximateTime?: number;

  /**
   * @generated from field: optional geneo.content.db.DifficultyLevelEnum avg_difficulty_level = 11;
   */
  avgDifficultyLevel?: DifficultyLevelEnum;

  /**
   * @generated from field: geneo.lms.assessment.teacher.apis.AssessmentCreationEnum assessment_creation_type = 12;
   */
  assessmentCreationType = AssessmentCreationEnum.ASSESSMENT_CREATION_UNDEFINED;

  /**
   * @generated from field: optional geneo.lms.db.ModeOfConductionEnum mode_of_conduction = 13;
   */
  modeOfConduction?: ModeOfConductionEnum;

  /**
   * @generated from field: optional int32 page_number = 14;
   */
  pageNumber?: number;

  constructor(data?: PartialMessage<GetModuleFilteredQuestionsV2Request>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.GetModuleFilteredQuestionsV2Request";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "teacher_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "subject_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "module_ids", kind: "scalar", T: 5 /* ScalarType.INT32 */, repeated: true },
    { no: 4, name: "required_question_types", kind: "enum", T: proto3.getEnumType(Question_QuestionEnum), repeated: true },
    { no: 5, name: "required_difficulty_types", kind: "enum", T: proto3.getEnumType(DifficultyLevelEnum), repeated: true },
    { no: 6, name: "required_difficulty_levels_count_info", kind: "message", T: RequiredQuestionCountInfoForDifficultyLevel, opt: true },
    { no: 7, name: "qIdsToBeIgnored", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 8, name: "bloom_levels", kind: "enum", T: proto3.getEnumType(BloomLevelEnum), repeated: true },
    { no: 9, name: "no_of_questions", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 10, name: "approximate_time", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 11, name: "avg_difficulty_level", kind: "enum", T: proto3.getEnumType(DifficultyLevelEnum), opt: true },
    { no: 12, name: "assessment_creation_type", kind: "enum", T: proto3.getEnumType(AssessmentCreationEnum) },
    { no: 13, name: "mode_of_conduction", kind: "enum", T: proto3.getEnumType(ModeOfConductionEnum), opt: true },
    { no: 14, name: "page_number", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetModuleFilteredQuestionsV2Request {
    return new GetModuleFilteredQuestionsV2Request().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetModuleFilteredQuestionsV2Request {
    return new GetModuleFilteredQuestionsV2Request().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetModuleFilteredQuestionsV2Request {
    return new GetModuleFilteredQuestionsV2Request().fromJsonString(jsonString, options);
  }

  static equals(a: GetModuleFilteredQuestionsV2Request | PlainMessage<GetModuleFilteredQuestionsV2Request> | undefined, b: GetModuleFilteredQuestionsV2Request | PlainMessage<GetModuleFilteredQuestionsV2Request> | undefined): boolean {
    return proto3.util.equals(GetModuleFilteredQuestionsV2Request, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.GetModuleFilteredQuestionsV2Response
 */
export class GetModuleFilteredQuestionsV2Response extends Message<GetModuleFilteredQuestionsV2Response> {
  /**
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * @generated from field: geneo.lms.assessment.teacher.apis.ModuleFilteredQuestions data = 4;
   */
  data?: ModuleFilteredQuestions;

  constructor(data?: PartialMessage<GetModuleFilteredQuestionsV2Response>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.GetModuleFilteredQuestionsV2Response";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "data", kind: "message", T: ModuleFilteredQuestions },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetModuleFilteredQuestionsV2Response {
    return new GetModuleFilteredQuestionsV2Response().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetModuleFilteredQuestionsV2Response {
    return new GetModuleFilteredQuestionsV2Response().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetModuleFilteredQuestionsV2Response {
    return new GetModuleFilteredQuestionsV2Response().fromJsonString(jsonString, options);
  }

  static equals(a: GetModuleFilteredQuestionsV2Response | PlainMessage<GetModuleFilteredQuestionsV2Response> | undefined, b: GetModuleFilteredQuestionsV2Response | PlainMessage<GetModuleFilteredQuestionsV2Response> | undefined): boolean {
    return proto3.util.equals(GetModuleFilteredQuestionsV2Response, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.GetModuleQuestionStatsV2Request
 */
export class GetModuleQuestionStatsV2Request extends Message<GetModuleQuestionStatsV2Request> {
  /**
   * @generated from field: int64 person_id = 1;
   */
  personId = protoInt64.zero;

  /**
   * @generated from field: geneo.ums.db.ProfileRolesEnum person_type = 2;
   */
  personType = ProfileRolesEnum.PROFILE_ROLE_UNDEFINED;

  /**
   * @generated from field: repeated int32 module_ids = 3;
   */
  moduleIds: number[] = [];

  /**
   * @generated from field: optional geneo.lms.db.ModeOfConductionEnum mode_of_conduction = 4;
   */
  modeOfConduction?: ModeOfConductionEnum;

  constructor(data?: PartialMessage<GetModuleQuestionStatsV2Request>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.GetModuleQuestionStatsV2Request";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "person_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "person_type", kind: "enum", T: proto3.getEnumType(ProfileRolesEnum) },
    { no: 3, name: "module_ids", kind: "scalar", T: 5 /* ScalarType.INT32 */, repeated: true },
    { no: 4, name: "mode_of_conduction", kind: "enum", T: proto3.getEnumType(ModeOfConductionEnum), opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetModuleQuestionStatsV2Request {
    return new GetModuleQuestionStatsV2Request().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetModuleQuestionStatsV2Request {
    return new GetModuleQuestionStatsV2Request().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetModuleQuestionStatsV2Request {
    return new GetModuleQuestionStatsV2Request().fromJsonString(jsonString, options);
  }

  static equals(a: GetModuleQuestionStatsV2Request | PlainMessage<GetModuleQuestionStatsV2Request> | undefined, b: GetModuleQuestionStatsV2Request | PlainMessage<GetModuleQuestionStatsV2Request> | undefined): boolean {
    return proto3.util.equals(GetModuleQuestionStatsV2Request, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.GetModuleQuestionStatsV2Response
 */
export class GetModuleQuestionStatsV2Response extends Message<GetModuleQuestionStatsV2Response> {
  /**
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * @generated from field: geneo.lms.assessment.teacher.apis.QuestionStatsList data = 4;
   */
  data?: QuestionStatsList;

  constructor(data?: PartialMessage<GetModuleQuestionStatsV2Response>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.GetModuleQuestionStatsV2Response";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "data", kind: "message", T: QuestionStatsList },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetModuleQuestionStatsV2Response {
    return new GetModuleQuestionStatsV2Response().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetModuleQuestionStatsV2Response {
    return new GetModuleQuestionStatsV2Response().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetModuleQuestionStatsV2Response {
    return new GetModuleQuestionStatsV2Response().fromJsonString(jsonString, options);
  }

  static equals(a: GetModuleQuestionStatsV2Response | PlainMessage<GetModuleQuestionStatsV2Response> | undefined, b: GetModuleQuestionStatsV2Response | PlainMessage<GetModuleQuestionStatsV2Response> | undefined): boolean {
    return proto3.util.equals(GetModuleQuestionStatsV2Response, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.QuestionStatsList
 */
export class QuestionStatsList extends Message<QuestionStatsList> {
  /**
   * @generated from field: int32 no_of_questions = 1;
   */
  noOfQuestions = 0;

  /**
   * @generated from field: geneo.lms.hw.teacher.apis.DifficutlyLevelQuestions question_difficulty_level = 2;
   */
  questionDifficultyLevel?: DifficutlyLevelQuestions;

  /**
   * @generated from field: geneo.lms.hw.teacher.apis.QuestionTypeCount question_types = 3;
   */
  questionTypes?: QuestionTypeCount;

  /**
   * @generated from field: repeated geneo.content.db.BloomLevelEnum bloom_levels = 4;
   */
  bloomLevels: BloomLevelEnum[] = [];

  /**
   * @generated from field: int32 approximate_time = 5;
   */
  approximateTime = 0;

  /**
   * @generated from field: geneo.content.db.DifficultyLevelEnum avg_difficulty_level = 6;
   */
  avgDifficultyLevel = DifficultyLevelEnum.DIFFICULTY_LEVEL_UNDEFINED;

  /**
   * @generated from field: optional geneo.lms.db.ModeOfConductionEnum mode_of_conduction = 7;
   */
  modeOfConduction?: ModeOfConductionEnum;

  constructor(data?: PartialMessage<QuestionStatsList>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.QuestionStatsList";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "no_of_questions", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "question_difficulty_level", kind: "message", T: DifficutlyLevelQuestions },
    { no: 3, name: "question_types", kind: "message", T: QuestionTypeCount },
    { no: 4, name: "bloom_levels", kind: "enum", T: proto3.getEnumType(BloomLevelEnum), repeated: true },
    { no: 5, name: "approximate_time", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "avg_difficulty_level", kind: "enum", T: proto3.getEnumType(DifficultyLevelEnum) },
    { no: 7, name: "mode_of_conduction", kind: "enum", T: proto3.getEnumType(ModeOfConductionEnum), opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): QuestionStatsList {
    return new QuestionStatsList().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): QuestionStatsList {
    return new QuestionStatsList().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): QuestionStatsList {
    return new QuestionStatsList().fromJsonString(jsonString, options);
  }

  static equals(a: QuestionStatsList | PlainMessage<QuestionStatsList> | undefined, b: QuestionStatsList | PlainMessage<QuestionStatsList> | undefined): boolean {
    return proto3.util.equals(QuestionStatsList, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.TeacherAssessmentClassStatsRequest
 */
export class TeacherAssessmentClassStatsRequest extends Message<TeacherAssessmentClassStatsRequest> {
  /**
   * @generated from field: int64 teacher_id = 1;
   */
  teacherId = protoInt64.zero;

  /**
   * @generated from field: int64 assessment_id = 2;
   */
  assessmentId = protoInt64.zero;

  constructor(data?: PartialMessage<TeacherAssessmentClassStatsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.TeacherAssessmentClassStatsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "teacher_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "assessment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TeacherAssessmentClassStatsRequest {
    return new TeacherAssessmentClassStatsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TeacherAssessmentClassStatsRequest {
    return new TeacherAssessmentClassStatsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TeacherAssessmentClassStatsRequest {
    return new TeacherAssessmentClassStatsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: TeacherAssessmentClassStatsRequest | PlainMessage<TeacherAssessmentClassStatsRequest> | undefined, b: TeacherAssessmentClassStatsRequest | PlainMessage<TeacherAssessmentClassStatsRequest> | undefined): boolean {
    return proto3.util.equals(TeacherAssessmentClassStatsRequest, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.StudentPerformanceInfo
 */
export class StudentPerformanceInfo extends Message<StudentPerformanceInfo> {
  /**
   * @generated from field: int64 student_id = 1;
   */
  studentId = protoInt64.zero;

  /**
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * @generated from field: string profile_img_url = 3;
   */
  profileImgUrl = "";

  /**
   * @generated from field: float score_percent = 4;
   */
  scorePercent = 0;

  /**
   * @generated from field: float response_score = 5;
   */
  responseScore = 0;

  /**
   * @generated from field: optional bool is_submitted = 6;
   */
  isSubmitted?: boolean;

  /**
   * @generated from field: optional bool is_evaluated = 7;
   */
  isEvaluated?: boolean;

  /**
   * @generated from field: repeated geneo.lms.db.AttemptStats attempt_info = 8;
   */
  attemptInfo: AttemptStats[] = [];

  /**
   * @generated from field: optional int32 section_no = 9;
   */
  sectionNo?: number;

  /**
   * Client/server clock mismatches detected at session start (sent regardless
   * of whether proctoring is enabled). timestamp = server time, key = info.
   *
   * @generated from field: repeated geneo.lms.db.TimeStampWithKey time_mismatches = 10;
   */
  timeMismatches: TimeStampWithKey[] = [];

  constructor(data?: PartialMessage<StudentPerformanceInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.StudentPerformanceInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "student_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "profile_img_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "score_percent", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 5, name: "response_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 6, name: "is_submitted", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 7, name: "is_evaluated", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 8, name: "attempt_info", kind: "message", T: AttemptStats, repeated: true },
    { no: 9, name: "section_no", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 10, name: "time_mismatches", kind: "message", T: TimeStampWithKey, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StudentPerformanceInfo {
    return new StudentPerformanceInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StudentPerformanceInfo {
    return new StudentPerformanceInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StudentPerformanceInfo {
    return new StudentPerformanceInfo().fromJsonString(jsonString, options);
  }

  static equals(a: StudentPerformanceInfo | PlainMessage<StudentPerformanceInfo> | undefined, b: StudentPerformanceInfo | PlainMessage<StudentPerformanceInfo> | undefined): boolean {
    return proto3.util.equals(StudentPerformanceInfo, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.TeacherAssessmentClassStatsResponse
 */
export class TeacherAssessmentClassStatsResponse extends Message<TeacherAssessmentClassStatsResponse> {
  /**
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * @generated from field: geneo.lms.assessment.teacher.apis.TeacherAssessmentClassStats data = 4;
   */
  data?: TeacherAssessmentClassStats;

  constructor(data?: PartialMessage<TeacherAssessmentClassStatsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.TeacherAssessmentClassStatsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "data", kind: "message", T: TeacherAssessmentClassStats },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TeacherAssessmentClassStatsResponse {
    return new TeacherAssessmentClassStatsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TeacherAssessmentClassStatsResponse {
    return new TeacherAssessmentClassStatsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TeacherAssessmentClassStatsResponse {
    return new TeacherAssessmentClassStatsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: TeacherAssessmentClassStatsResponse | PlainMessage<TeacherAssessmentClassStatsResponse> | undefined, b: TeacherAssessmentClassStatsResponse | PlainMessage<TeacherAssessmentClassStatsResponse> | undefined): boolean {
    return proto3.util.equals(TeacherAssessmentClassStatsResponse, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.TeacherAssessmentClassStats
 */
export class TeacherAssessmentClassStats extends Message<TeacherAssessmentClassStats> {
  /**
   * @generated from field: geneo.lms.assessment.common.apis.AssessmentTask assessment = 1;
   */
  assessment?: AssessmentTask;

  /**
   * @generated from field: repeated geneo.lms.assessment.teacher.apis.StudentPerformanceInfo student_performance_info = 2;
   */
  studentPerformanceInfo: StudentPerformanceInfo[] = [];

  /**
   * @generated from field: int32 assigned_students_count = 3;
   */
  assignedStudentsCount = 0;

  /**
   * @generated from field: int32 students_submission_count = 4;
   */
  studentsSubmissionCount = 0;

  constructor(data?: PartialMessage<TeacherAssessmentClassStats>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.TeacherAssessmentClassStats";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "assessment", kind: "message", T: AssessmentTask },
    { no: 2, name: "student_performance_info", kind: "message", T: StudentPerformanceInfo, repeated: true },
    { no: 3, name: "assigned_students_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "students_submission_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TeacherAssessmentClassStats {
    return new TeacherAssessmentClassStats().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TeacherAssessmentClassStats {
    return new TeacherAssessmentClassStats().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TeacherAssessmentClassStats {
    return new TeacherAssessmentClassStats().fromJsonString(jsonString, options);
  }

  static equals(a: TeacherAssessmentClassStats | PlainMessage<TeacherAssessmentClassStats> | undefined, b: TeacherAssessmentClassStats | PlainMessage<TeacherAssessmentClassStats> | undefined): boolean {
    return proto3.util.equals(TeacherAssessmentClassStats, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.DeleteTeacherCreatedAssessmentRequest
 */
export class DeleteTeacherCreatedAssessmentRequest extends Message<DeleteTeacherCreatedAssessmentRequest> {
  /**
   * @generated from field: int64 teacher_id = 1;
   */
  teacherId = protoInt64.zero;

  /**
   * @generated from field: int64 assessment_id = 2;
   */
  assessmentId = protoInt64.zero;

  constructor(data?: PartialMessage<DeleteTeacherCreatedAssessmentRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.DeleteTeacherCreatedAssessmentRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "teacher_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "assessment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteTeacherCreatedAssessmentRequest {
    return new DeleteTeacherCreatedAssessmentRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteTeacherCreatedAssessmentRequest {
    return new DeleteTeacherCreatedAssessmentRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteTeacherCreatedAssessmentRequest {
    return new DeleteTeacherCreatedAssessmentRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteTeacherCreatedAssessmentRequest | PlainMessage<DeleteTeacherCreatedAssessmentRequest> | undefined, b: DeleteTeacherCreatedAssessmentRequest | PlainMessage<DeleteTeacherCreatedAssessmentRequest> | undefined): boolean {
    return proto3.util.equals(DeleteTeacherCreatedAssessmentRequest, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.DeleteTeacherCreatedAssessmentResponse
 */
export class DeleteTeacherCreatedAssessmentResponse extends Message<DeleteTeacherCreatedAssessmentResponse> {
  /**
   * @generated from field: string status = 1;
   */
  status = "";

  constructor(data?: PartialMessage<DeleteTeacherCreatedAssessmentResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.DeleteTeacherCreatedAssessmentResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteTeacherCreatedAssessmentResponse {
    return new DeleteTeacherCreatedAssessmentResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteTeacherCreatedAssessmentResponse {
    return new DeleteTeacherCreatedAssessmentResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteTeacherCreatedAssessmentResponse {
    return new DeleteTeacherCreatedAssessmentResponse().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteTeacherCreatedAssessmentResponse | PlainMessage<DeleteTeacherCreatedAssessmentResponse> | undefined, b: DeleteTeacherCreatedAssessmentResponse | PlainMessage<DeleteTeacherCreatedAssessmentResponse> | undefined): boolean {
    return proto3.util.equals(DeleteTeacherCreatedAssessmentResponse, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.TeacherAssessmentClassStatsV2Request
 */
export class TeacherAssessmentClassStatsV2Request extends Message<TeacherAssessmentClassStatsV2Request> {
  /**
   * @generated from field: int64 teacher_id = 1;
   */
  teacherId = protoInt64.zero;

  /**
   * @generated from field: int64 assessment_id = 2;
   */
  assessmentId = protoInt64.zero;

  /**
   * @generated from field: optional int32 attempt_number = 3;
   */
  attemptNumber?: number;

  /**
   * @generated from field: optional geneo.lms.db.AttemptTypeEnum attempt_type = 4;
   */
  attemptType?: AttemptTypeEnum;

  constructor(data?: PartialMessage<TeacherAssessmentClassStatsV2Request>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.TeacherAssessmentClassStatsV2Request";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "teacher_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "assessment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "attempt_number", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 4, name: "attempt_type", kind: "enum", T: proto3.getEnumType(AttemptTypeEnum), opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TeacherAssessmentClassStatsV2Request {
    return new TeacherAssessmentClassStatsV2Request().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TeacherAssessmentClassStatsV2Request {
    return new TeacherAssessmentClassStatsV2Request().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TeacherAssessmentClassStatsV2Request {
    return new TeacherAssessmentClassStatsV2Request().fromJsonString(jsonString, options);
  }

  static equals(a: TeacherAssessmentClassStatsV2Request | PlainMessage<TeacherAssessmentClassStatsV2Request> | undefined, b: TeacherAssessmentClassStatsV2Request | PlainMessage<TeacherAssessmentClassStatsV2Request> | undefined): boolean {
    return proto3.util.equals(TeacherAssessmentClassStatsV2Request, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.TeacherAssessmentClassStatsV2Response
 */
export class TeacherAssessmentClassStatsV2Response extends Message<TeacherAssessmentClassStatsV2Response> {
  /**
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * @generated from field: geneo.lms.assessment.teacher.apis.TeacherAssessmentClassStatsV2 data = 4;
   */
  data?: TeacherAssessmentClassStatsV2;

  constructor(data?: PartialMessage<TeacherAssessmentClassStatsV2Response>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.TeacherAssessmentClassStatsV2Response";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "data", kind: "message", T: TeacherAssessmentClassStatsV2 },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TeacherAssessmentClassStatsV2Response {
    return new TeacherAssessmentClassStatsV2Response().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TeacherAssessmentClassStatsV2Response {
    return new TeacherAssessmentClassStatsV2Response().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TeacherAssessmentClassStatsV2Response {
    return new TeacherAssessmentClassStatsV2Response().fromJsonString(jsonString, options);
  }

  static equals(a: TeacherAssessmentClassStatsV2Response | PlainMessage<TeacherAssessmentClassStatsV2Response> | undefined, b: TeacherAssessmentClassStatsV2Response | PlainMessage<TeacherAssessmentClassStatsV2Response> | undefined): boolean {
    return proto3.util.equals(TeacherAssessmentClassStatsV2Response, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.TeacherAssessmentClassStatsV2
 */
export class TeacherAssessmentClassStatsV2 extends Message<TeacherAssessmentClassStatsV2> {
  /**
   * @generated from field: geneo.lms.assessment.common.apis.AssessmentTask assessment = 1;
   */
  assessment?: AssessmentTask;

  /**
   * @generated from field: repeated geneo.lms.assessment.teacher.apis.StudentPerformanceInfo student_performance_info = 2;
   */
  studentPerformanceInfo: StudentPerformanceInfo[] = [];

  /**
   * @generated from field: int32 assigned_students_count = 3;
   */
  assignedStudentsCount = 0;

  /**
   * @generated from field: int32 students_submission_count = 4;
   */
  studentsSubmissionCount = 0;

  /**
   * @generated from field: geneo.lms.assessment.teacher.apis.AssessmentReportInfo assessment_report_info = 5;
   */
  assessmentReportInfo?: AssessmentReportInfo;

  /**
   * @generated from field: repeated geneo.lms.db.AttemptStats attempt_info = 6;
   */
  attemptInfo: AttemptStats[] = [];

  constructor(data?: PartialMessage<TeacherAssessmentClassStatsV2>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.TeacherAssessmentClassStatsV2";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "assessment", kind: "message", T: AssessmentTask },
    { no: 2, name: "student_performance_info", kind: "message", T: StudentPerformanceInfo, repeated: true },
    { no: 3, name: "assigned_students_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "students_submission_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "assessment_report_info", kind: "message", T: AssessmentReportInfo },
    { no: 6, name: "attempt_info", kind: "message", T: AttemptStats, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TeacherAssessmentClassStatsV2 {
    return new TeacherAssessmentClassStatsV2().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TeacherAssessmentClassStatsV2 {
    return new TeacherAssessmentClassStatsV2().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TeacherAssessmentClassStatsV2 {
    return new TeacherAssessmentClassStatsV2().fromJsonString(jsonString, options);
  }

  static equals(a: TeacherAssessmentClassStatsV2 | PlainMessage<TeacherAssessmentClassStatsV2> | undefined, b: TeacherAssessmentClassStatsV2 | PlainMessage<TeacherAssessmentClassStatsV2> | undefined): boolean {
    return proto3.util.equals(TeacherAssessmentClassStatsV2, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.AssessmentReportInfo
 */
export class AssessmentReportInfo extends Message<AssessmentReportInfo> {
  /**
   * @generated from field: geneo.lms.assessment.teacher.apis.BloomLevelBreackdown bloom_level_breackdown = 1;
   */
  bloomLevelBreackdown?: BloomLevelBreackdown;

  /**
   * @generated from field: geneo.lms.assessment.teacher.apis.StrengthAndWeakness strengths_and_weaknessess = 2;
   */
  strengthsAndWeaknessess?: StrengthAndWeakness;

  constructor(data?: PartialMessage<AssessmentReportInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.AssessmentReportInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "bloom_level_breackdown", kind: "message", T: BloomLevelBreackdown },
    { no: 2, name: "strengths_and_weaknessess", kind: "message", T: StrengthAndWeakness },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AssessmentReportInfo {
    return new AssessmentReportInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AssessmentReportInfo {
    return new AssessmentReportInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AssessmentReportInfo {
    return new AssessmentReportInfo().fromJsonString(jsonString, options);
  }

  static equals(a: AssessmentReportInfo | PlainMessage<AssessmentReportInfo> | undefined, b: AssessmentReportInfo | PlainMessage<AssessmentReportInfo> | undefined): boolean {
    return proto3.util.equals(AssessmentReportInfo, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.BloomLevelBreackdown
 */
export class BloomLevelBreackdown extends Message<BloomLevelBreackdown> {
  /**
   * @generated from field: int32 creation_score = 1;
   */
  creationScore = 0;

  /**
   * @generated from field: int32 evaluation_score = 2;
   */
  evaluationScore = 0;

  /**
   * @generated from field: int32 application_score = 3;
   */
  applicationScore = 0;

  /**
   * @generated from field: int32 analysis_score = 4;
   */
  analysisScore = 0;

  /**
   * @generated from field: int32 comprehension_score = 5;
   */
  comprehensionScore = 0;

  /**
   * @generated from field: int32 retentionScore = 6;
   */
  retentionScore = 0;

  /**
   * @generated from field: string overallStatement = 7;
   */
  overallStatement = "";

  constructor(data?: PartialMessage<BloomLevelBreackdown>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.BloomLevelBreackdown";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "creation_score", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "evaluation_score", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "application_score", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "analysis_score", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "comprehension_score", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "retentionScore", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "overallStatement", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): BloomLevelBreackdown {
    return new BloomLevelBreackdown().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): BloomLevelBreackdown {
    return new BloomLevelBreackdown().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): BloomLevelBreackdown {
    return new BloomLevelBreackdown().fromJsonString(jsonString, options);
  }

  static equals(a: BloomLevelBreackdown | PlainMessage<BloomLevelBreackdown> | undefined, b: BloomLevelBreackdown | PlainMessage<BloomLevelBreackdown> | undefined): boolean {
    return proto3.util.equals(BloomLevelBreackdown, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.StrengthAndWeakness
 */
export class StrengthAndWeakness extends Message<StrengthAndWeakness> {
  /**
   * @generated from field: repeated string strength = 1;
   */
  strength: string[] = [];

  /**
   * @generated from field: repeated string weakness = 2;
   */
  weakness: string[] = [];

  constructor(data?: PartialMessage<StrengthAndWeakness>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.StrengthAndWeakness";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "strength", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "weakness", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StrengthAndWeakness {
    return new StrengthAndWeakness().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StrengthAndWeakness {
    return new StrengthAndWeakness().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StrengthAndWeakness {
    return new StrengthAndWeakness().fromJsonString(jsonString, options);
  }

  static equals(a: StrengthAndWeakness | PlainMessage<StrengthAndWeakness> | undefined, b: StrengthAndWeakness | PlainMessage<StrengthAndWeakness> | undefined): boolean {
    return proto3.util.equals(StrengthAndWeakness, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.ClassLevelPerformanceInfo
 */
export class ClassLevelPerformanceInfo extends Message<ClassLevelPerformanceInfo> {
  /**
   * @generated from field: geneo.lms.assessment.teacher.apis.PerformanceEnum performance_type = 1;
   */
  performanceType = PerformanceEnum.PERFORMANCE_UNDEFINED;

  /**
   * @generated from field: int32 no_of_students = 2;
   */
  noOfStudents = 0;

  /**
   * @generated from field: int32 percentage_of_students = 3;
   */
  percentageOfStudents = 0;

  constructor(data?: PartialMessage<ClassLevelPerformanceInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.ClassLevelPerformanceInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "performance_type", kind: "enum", T: proto3.getEnumType(PerformanceEnum) },
    { no: 2, name: "no_of_students", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "percentage_of_students", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ClassLevelPerformanceInfo {
    return new ClassLevelPerformanceInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ClassLevelPerformanceInfo {
    return new ClassLevelPerformanceInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ClassLevelPerformanceInfo {
    return new ClassLevelPerformanceInfo().fromJsonString(jsonString, options);
  }

  static equals(a: ClassLevelPerformanceInfo | PlainMessage<ClassLevelPerformanceInfo> | undefined, b: ClassLevelPerformanceInfo | PlainMessage<ClassLevelPerformanceInfo> | undefined): boolean {
    return proto3.util.equals(ClassLevelPerformanceInfo, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.FetchTeacherAssessmentReportsRequest
 */
export class FetchTeacherAssessmentReportsRequest extends Message<FetchTeacherAssessmentReportsRequest> {
  /**
   * @generated from field: int64 teacher_id = 1;
   */
  teacherId = protoInt64.zero;

  /**
   * ID of the course (optional)
   *
   * @generated from field: optional int32 subject_id = 2;
   */
  subjectId?: number;

  /**
   * @generated from field: optional int64 section_id = 3;
   */
  sectionId?: bigint;

  /**
   * @generated from field: optional int32 page_number = 4;
   */
  pageNumber?: number;

  /**
   * @generated from field: optional int32 items_per_page = 5;
   */
  itemsPerPage?: number;

  /**
   * @generated from field: optional string search_key = 6;
   */
  searchKey?: string;

  /**
   * @generated from field: optional int32 chapter_id = 7;
   */
  chapterId?: number;

  /**
   * @generated from field: optional int32 topic_id = 8;
   */
  topicId?: number;

  /**
   * @generated from field: optional geneo.lms.db.AssessmentEnum assessment_type = 9;
   */
  assessmentType?: AssessmentEnum;

  constructor(data?: PartialMessage<FetchTeacherAssessmentReportsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.FetchTeacherAssessmentReportsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "teacher_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "subject_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 3, name: "section_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 4, name: "page_number", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 5, name: "items_per_page", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 6, name: "search_key", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 7, name: "chapter_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 8, name: "topic_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 9, name: "assessment_type", kind: "enum", T: proto3.getEnumType(AssessmentEnum), opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FetchTeacherAssessmentReportsRequest {
    return new FetchTeacherAssessmentReportsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FetchTeacherAssessmentReportsRequest {
    return new FetchTeacherAssessmentReportsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FetchTeacherAssessmentReportsRequest {
    return new FetchTeacherAssessmentReportsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: FetchTeacherAssessmentReportsRequest | PlainMessage<FetchTeacherAssessmentReportsRequest> | undefined, b: FetchTeacherAssessmentReportsRequest | PlainMessage<FetchTeacherAssessmentReportsRequest> | undefined): boolean {
    return proto3.util.equals(FetchTeacherAssessmentReportsRequest, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.FetchTeacherAssessmentReportsResponse
 */
export class FetchTeacherAssessmentReportsResponse extends Message<FetchTeacherAssessmentReportsResponse> {
  /**
   * Response status
   *
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * Response code
   *
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * Response message
   *
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * @generated from field: geneo.lms.assessment.teacher.apis.TeacherAssessmentReportData data = 4;
   */
  data?: TeacherAssessmentReportData;

  constructor(data?: PartialMessage<FetchTeacherAssessmentReportsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.FetchTeacherAssessmentReportsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "data", kind: "message", T: TeacherAssessmentReportData },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FetchTeacherAssessmentReportsResponse {
    return new FetchTeacherAssessmentReportsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FetchTeacherAssessmentReportsResponse {
    return new FetchTeacherAssessmentReportsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FetchTeacherAssessmentReportsResponse {
    return new FetchTeacherAssessmentReportsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: FetchTeacherAssessmentReportsResponse | PlainMessage<FetchTeacherAssessmentReportsResponse> | undefined, b: FetchTeacherAssessmentReportsResponse | PlainMessage<FetchTeacherAssessmentReportsResponse> | undefined): boolean {
    return proto3.util.equals(FetchTeacherAssessmentReportsResponse, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.TeacherAssessmentReportData
 */
export class TeacherAssessmentReportData extends Message<TeacherAssessmentReportData> {
  /**
   * @generated from field: int64 teacher_id = 1;
   */
  teacherId = protoInt64.zero;

  /**
   * @generated from field: repeated geneo.lms.assessment.teacher.apis.TeacherReportCenterData teacher_reports = 2;
   */
  teacherReports: TeacherReportCenterData[] = [];

  /**
   * @generated from field: optional geneo.lms.assessment.teacher.apis.ReportCountInfo teacher_reports_info = 3;
   */
  teacherReportsInfo?: ReportCountInfo;

  constructor(data?: PartialMessage<TeacherAssessmentReportData>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.TeacherAssessmentReportData";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "teacher_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "teacher_reports", kind: "message", T: TeacherReportCenterData, repeated: true },
    { no: 3, name: "teacher_reports_info", kind: "message", T: ReportCountInfo, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TeacherAssessmentReportData {
    return new TeacherAssessmentReportData().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TeacherAssessmentReportData {
    return new TeacherAssessmentReportData().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TeacherAssessmentReportData {
    return new TeacherAssessmentReportData().fromJsonString(jsonString, options);
  }

  static equals(a: TeacherAssessmentReportData | PlainMessage<TeacherAssessmentReportData> | undefined, b: TeacherAssessmentReportData | PlainMessage<TeacherAssessmentReportData> | undefined): boolean {
    return proto3.util.equals(TeacherAssessmentReportData, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.TeacherReportCenterData
 */
export class TeacherReportCenterData extends Message<TeacherReportCenterData> {
  /**
   * @generated from field: optional string assessment_name = 1;
   */
  assessmentName?: string;

  /**
   * @generated from field: optional string assessment_id = 2;
   */
  assessmentId?: string;

  /**
   * @generated from field: optional geneo.lms.db.AssessmentEnum assessment_type = 3;
   */
  assessmentType?: AssessmentEnum;

  /**
   * @generated from field: optional google.protobuf.Timestamp assigned_date = 4;
   */
  assignedDate?: Timestamp;

  /**
   * @generated from field: string class = 5;
   */
  class = "";

  /**
   * @generated from field: string section = 6;
   */
  section = "";

  /**
   * @generated from field: string subject = 7;
   */
  subject = "";

  /**
   * @generated from field: geneo.lms.db.TaskMetaInfo task_meta_info = 8;
   */
  taskMetaInfo?: TaskMetaInfo;

  /**
   * ID of the module the homework belongs to
   *
   * @generated from field: optional int32 module_id = 9;
   */
  moduleId?: number;

  /**
   * ID of the module
   *
   * @generated from field: geneo.content.db.Module.ModuleCategoryEnum module_category = 10;
   */
  moduleCategory = Module_ModuleCategoryEnum.MODULE_CATEGORY_UNDEFINED;

  /**
   * @generated from field: optional string module_name = 11;
   */
  moduleName?: string;

  /**
   * URL of the homework poster image
   *
   * @generated from field: string assessment_poster_img_url = 12;
   */
  assessmentPosterImgUrl = "";

  /**
   * @generated from field: optional string report_url = 13;
   */
  reportUrl?: string;

  /**
   * @generated from field: optional int32 report_id = 14;
   */
  reportId?: number;

  /**
   * @generated from field: optional int32 total_assignments = 15;
   */
  totalAssignments?: number;

  /**
   * @generated from field: optional int32 total_submissions = 16;
   */
  totalSubmissions?: number;

  constructor(data?: PartialMessage<TeacherReportCenterData>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.TeacherReportCenterData";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "assessment_name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 2, name: "assessment_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "assessment_type", kind: "enum", T: proto3.getEnumType(AssessmentEnum), opt: true },
    { no: 4, name: "assigned_date", kind: "message", T: Timestamp, opt: true },
    { no: 5, name: "class", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "section", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "subject", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "task_meta_info", kind: "message", T: TaskMetaInfo },
    { no: 9, name: "module_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 10, name: "module_category", kind: "enum", T: proto3.getEnumType(Module_ModuleCategoryEnum) },
    { no: 11, name: "module_name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 12, name: "assessment_poster_img_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "report_url", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 14, name: "report_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 15, name: "total_assignments", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 16, name: "total_submissions", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TeacherReportCenterData {
    return new TeacherReportCenterData().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TeacherReportCenterData {
    return new TeacherReportCenterData().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TeacherReportCenterData {
    return new TeacherReportCenterData().fromJsonString(jsonString, options);
  }

  static equals(a: TeacherReportCenterData | PlainMessage<TeacherReportCenterData> | undefined, b: TeacherReportCenterData | PlainMessage<TeacherReportCenterData> | undefined): boolean {
    return proto3.util.equals(TeacherReportCenterData, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.ReportCountInfo
 */
export class ReportCountInfo extends Message<ReportCountInfo> {
  /**
   * @generated from field: int32 report_count = 1;
   */
  reportCount = 0;

  /**
   * @generated from field: int32 count_in_pagination = 2;
   */
  countInPagination = 0;

  constructor(data?: PartialMessage<ReportCountInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.ReportCountInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "report_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "count_in_pagination", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ReportCountInfo {
    return new ReportCountInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ReportCountInfo {
    return new ReportCountInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ReportCountInfo {
    return new ReportCountInfo().fromJsonString(jsonString, options);
  }

  static equals(a: ReportCountInfo | PlainMessage<ReportCountInfo> | undefined, b: ReportCountInfo | PlainMessage<ReportCountInfo> | undefined): boolean {
    return proto3.util.equals(ReportCountInfo, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.GetModuleFilteredQuestionsV3Request
 */
export class GetModuleFilteredQuestionsV3Request extends Message<GetModuleFilteredQuestionsV3Request> {
  /**
   * @generated from field: int64 teacher_id = 1;
   */
  teacherId = protoInt64.zero;

  /**
   * @generated from field: int32 subject_id = 2;
   */
  subjectId = 0;

  /**
   * @generated from field: repeated int32 module_ids = 3;
   */
  moduleIds: number[] = [];

  /**
   * @generated from field: repeated geneo.content.db.Question.QuestionEnum required_question_types = 4;
   */
  requiredQuestionTypes: Question_QuestionEnum[] = [];

  /**
   * @generated from field: repeated geneo.content.db.DifficultyLevelEnum required_difficulty_types = 5;
   */
  requiredDifficultyTypes: DifficultyLevelEnum[] = [];

  /**
   * @generated from field: optional geneo.lms.hw.teacher.apis.RequiredQuestionCountInfoForDifficultyLevel required_difficulty_levels_count_info = 6;
   */
  requiredDifficultyLevelsCountInfo?: RequiredQuestionCountInfoForDifficultyLevel;

  /**
   * @generated from field: repeated string qIdsToBeIgnored = 7;
   */
  qIdsToBeIgnored: string[] = [];

  /**
   * @generated from field: repeated geneo.content.db.BloomLevelEnum bloom_levels = 8;
   */
  bloomLevels: BloomLevelEnum[] = [];

  /**
   * @generated from field: optional int32 no_of_questions = 9;
   */
  noOfQuestions?: number;

  /**
   * @generated from field: optional int32 approximate_time = 10;
   */
  approximateTime?: number;

  /**
   * @generated from field: optional geneo.content.db.DifficultyLevelEnum avg_difficulty_level = 11;
   */
  avgDifficultyLevel?: DifficultyLevelEnum;

  /**
   * @generated from field: geneo.lms.assessment.teacher.apis.AssessmentCreationEnum assessment_creation_type = 12;
   */
  assessmentCreationType = AssessmentCreationEnum.ASSESSMENT_CREATION_UNDEFINED;

  /**
   * @generated from field: optional geneo.lms.db.ModeOfConductionEnum mode_of_conduction = 13;
   */
  modeOfConduction?: ModeOfConductionEnum;

  /**
   * @generated from field: optional int32 page_number = 14;
   */
  pageNumber?: number;

  /**
   * @generated from field: repeated geneo.lms.db.QuestionSection question_section_info = 15;
   */
  questionSectionInfo: QuestionSection[] = [];

  /**
   * @generated from field: repeated string ai_question_prompts = 16;
   */
  aiQuestionPrompts: string[] = [];

  /**
   * @generated from field: bool allow_ai_questions = 17;
   */
  allowAiQuestions = false;

  /**
   * @generated from field: optional string current_question_id = 18;
   */
  currentQuestionId?: string;

  constructor(data?: PartialMessage<GetModuleFilteredQuestionsV3Request>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.GetModuleFilteredQuestionsV3Request";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "teacher_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "subject_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "module_ids", kind: "scalar", T: 5 /* ScalarType.INT32 */, repeated: true },
    { no: 4, name: "required_question_types", kind: "enum", T: proto3.getEnumType(Question_QuestionEnum), repeated: true },
    { no: 5, name: "required_difficulty_types", kind: "enum", T: proto3.getEnumType(DifficultyLevelEnum), repeated: true },
    { no: 6, name: "required_difficulty_levels_count_info", kind: "message", T: RequiredQuestionCountInfoForDifficultyLevel, opt: true },
    { no: 7, name: "qIdsToBeIgnored", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 8, name: "bloom_levels", kind: "enum", T: proto3.getEnumType(BloomLevelEnum), repeated: true },
    { no: 9, name: "no_of_questions", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 10, name: "approximate_time", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 11, name: "avg_difficulty_level", kind: "enum", T: proto3.getEnumType(DifficultyLevelEnum), opt: true },
    { no: 12, name: "assessment_creation_type", kind: "enum", T: proto3.getEnumType(AssessmentCreationEnum) },
    { no: 13, name: "mode_of_conduction", kind: "enum", T: proto3.getEnumType(ModeOfConductionEnum), opt: true },
    { no: 14, name: "page_number", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 15, name: "question_section_info", kind: "message", T: QuestionSection, repeated: true },
    { no: 16, name: "ai_question_prompts", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 17, name: "allow_ai_questions", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 18, name: "current_question_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetModuleFilteredQuestionsV3Request {
    return new GetModuleFilteredQuestionsV3Request().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetModuleFilteredQuestionsV3Request {
    return new GetModuleFilteredQuestionsV3Request().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetModuleFilteredQuestionsV3Request {
    return new GetModuleFilteredQuestionsV3Request().fromJsonString(jsonString, options);
  }

  static equals(a: GetModuleFilteredQuestionsV3Request | PlainMessage<GetModuleFilteredQuestionsV3Request> | undefined, b: GetModuleFilteredQuestionsV3Request | PlainMessage<GetModuleFilteredQuestionsV3Request> | undefined): boolean {
    return proto3.util.equals(GetModuleFilteredQuestionsV3Request, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.ModuleFilteredQuestionsV2
 */
export class ModuleFilteredQuestionsV2 extends Message<ModuleFilteredQuestionsV2> {
  /**
   * @generated from field: repeated geneo.content.db.Question questions = 1;
   */
  questions: Question[] = [];

  /**
   * @generated from field: geneo.lms.db.TaskMetaInfo task_meta_info = 2;
   */
  taskMetaInfo?: TaskMetaInfo;

  /**
   * @generated from field: geneo.content.db.DifficultyLevelEnum avg_difficulty_level = 3;
   */
  avgDifficultyLevel = DifficultyLevelEnum.DIFFICULTY_LEVEL_UNDEFINED;

  /**
   * @generated from field: int32 approximate_time = 4;
   */
  approximateTime = 0;

  /**
   * @generated from field: optional geneo.lms.db.ModeOfConductionEnum mode_of_conduction = 5;
   */
  modeOfConduction?: ModeOfConductionEnum;

  /**
   * @generated from field: geneo.lms.assessment.teacher.apis.PaginationInfo pagination = 6;
   */
  pagination?: PaginationInfo;

  /**
   * @generated from field: repeated geneo.lms.db.QuestionSectionMeta question_section_meta_info = 7;
   */
  questionSectionMetaInfo: QuestionSectionMeta[] = [];

  /**
   * @generated from field: repeated geneo.lms.db.QuestionModuleMap question_module_map = 8;
   */
  questionModuleMap: QuestionModuleMap[] = [];

  constructor(data?: PartialMessage<ModuleFilteredQuestionsV2>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.ModuleFilteredQuestionsV2";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "questions", kind: "message", T: Question, repeated: true },
    { no: 2, name: "task_meta_info", kind: "message", T: TaskMetaInfo },
    { no: 3, name: "avg_difficulty_level", kind: "enum", T: proto3.getEnumType(DifficultyLevelEnum) },
    { no: 4, name: "approximate_time", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "mode_of_conduction", kind: "enum", T: proto3.getEnumType(ModeOfConductionEnum), opt: true },
    { no: 6, name: "pagination", kind: "message", T: PaginationInfo },
    { no: 7, name: "question_section_meta_info", kind: "message", T: QuestionSectionMeta, repeated: true },
    { no: 8, name: "question_module_map", kind: "message", T: QuestionModuleMap, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ModuleFilteredQuestionsV2 {
    return new ModuleFilteredQuestionsV2().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ModuleFilteredQuestionsV2 {
    return new ModuleFilteredQuestionsV2().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ModuleFilteredQuestionsV2 {
    return new ModuleFilteredQuestionsV2().fromJsonString(jsonString, options);
  }

  static equals(a: ModuleFilteredQuestionsV2 | PlainMessage<ModuleFilteredQuestionsV2> | undefined, b: ModuleFilteredQuestionsV2 | PlainMessage<ModuleFilteredQuestionsV2> | undefined): boolean {
    return proto3.util.equals(ModuleFilteredQuestionsV2, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.GetModuleFilteredQuestionsV3Response
 */
export class GetModuleFilteredQuestionsV3Response extends Message<GetModuleFilteredQuestionsV3Response> {
  /**
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * @generated from field: geneo.lms.assessment.teacher.apis.ModuleFilteredQuestionsV2 data = 4;
   */
  data?: ModuleFilteredQuestionsV2;

  constructor(data?: PartialMessage<GetModuleFilteredQuestionsV3Response>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.GetModuleFilteredQuestionsV3Response";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "data", kind: "message", T: ModuleFilteredQuestionsV2 },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetModuleFilteredQuestionsV3Response {
    return new GetModuleFilteredQuestionsV3Response().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetModuleFilteredQuestionsV3Response {
    return new GetModuleFilteredQuestionsV3Response().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetModuleFilteredQuestionsV3Response {
    return new GetModuleFilteredQuestionsV3Response().fromJsonString(jsonString, options);
  }

  static equals(a: GetModuleFilteredQuestionsV3Response | PlainMessage<GetModuleFilteredQuestionsV3Response> | undefined, b: GetModuleFilteredQuestionsV3Response | PlainMessage<GetModuleFilteredQuestionsV3Response> | undefined): boolean {
    return proto3.util.equals(GetModuleFilteredQuestionsV3Response, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.AssessmentCreationSubmitV3Request
 */
export class AssessmentCreationSubmitV3Request extends Message<AssessmentCreationSubmitV3Request> {
  /**
   * ID of the teacher
   *
   * @generated from field: int64 teacher_id = 1;
   */
  teacherId = protoInt64.zero;

  /**
   * ID of the course
   *
   * @generated from field: int32 subject_id = 2;
   */
  subjectId = 0;

  /**
   * ID of the school class section
   *
   * @generated from field: int64 section_id = 3;
   */
  sectionId = protoInt64.zero;

  /**
   * Name of the task
   *
   * @generated from field: string task_name = 4;
   */
  taskName = "";

  /**
   * @generated from field: optional int32 module_id = 5;
   */
  moduleId?: number;

  /**
   * ID of the topic
   *
   * @generated from field: geneo.content.db.Module.ModuleCategoryEnum category = 6;
   */
  category = Module_ModuleCategoryEnum.MODULE_CATEGORY_UNDEFINED;

  /**
   * Information about selected tasks
   *
   * @generated from field: repeated geneo.lms.assessment.teacher.apis.TaskInfoModel selected_tasks_info = 7;
   */
  selectedTasksInfo: TaskInfoModel[] = [];

  /**
   * ID of the homework (optional)
   *
   * @generated from field: optional int64 assessment_id = 8;
   */
  assessmentId?: bigint;

  /**
   * Instructions for the homework (optional)
   *
   * @generated from field: repeated string instructions = 9;
   */
  instructions: string[] = [];

  /**
   * Status of the creation process
   *
   * @generated from field: geneo.lms.db.TaskCreationStatusEnum creation_status = 10;
   */
  creationStatus = TaskCreationStatusEnum.TASK_CREATION_STATUS_UNDEFINED;

  /**
   * @generated from field: geneo.lms.db.TaskEnum task_type = 11;
   */
  taskType = TaskEnum.TASK_UNDEFINED;

  /**
   * @generated from field: repeated geneo.lms.db.CloudUpload task_uploads = 12;
   */
  taskUploads: CloudUpload[] = [];

  /**
   * @generated from field: optional float max_marks = 13;
   */
  maxMarks?: number;

  /**
   * Only for teacher created CUSTOM hws
   *
   * @generated from field: optional geneo.lms.db.SubmissionType submission_type = 14;
   */
  submissionType?: SubmissionType;

  /**
   * @generated from field: optional int64 source_geneo_assessment_id = 15;
   */
  sourceGeneoAssessmentId?: bigint;

  /**
   * @generated from field: repeated geneo.lms.db.ChapterIdsInfo chapter_ids_info = 16;
   */
  chapterIdsInfo: ChapterIdsInfo[] = [];

  /**
   * @generated from field: optional geneo.lms.db.ModeOfConductionEnum mode_of_conduction = 17;
   */
  modeOfConduction?: ModeOfConductionEnum;

  /**
   * @generated from field: repeated geneo.lms.db.QuestionSectionMeta question_section_meta_info = 18;
   */
  questionSectionMetaInfo: QuestionSectionMeta[] = [];

  /**
   * @generated from field: optional geneo.lms.db.MarkingSchemeEnum marking_scheme_type = 19;
   */
  markingSchemeType?: MarkingSchemeEnum;

  constructor(data?: PartialMessage<AssessmentCreationSubmitV3Request>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.AssessmentCreationSubmitV3Request";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "teacher_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "subject_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "section_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "task_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "module_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 6, name: "category", kind: "enum", T: proto3.getEnumType(Module_ModuleCategoryEnum) },
    { no: 7, name: "selected_tasks_info", kind: "message", T: TaskInfoModel, repeated: true },
    { no: 8, name: "assessment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 9, name: "instructions", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 10, name: "creation_status", kind: "enum", T: proto3.getEnumType(TaskCreationStatusEnum) },
    { no: 11, name: "task_type", kind: "enum", T: proto3.getEnumType(TaskEnum) },
    { no: 12, name: "task_uploads", kind: "message", T: CloudUpload, repeated: true },
    { no: 13, name: "max_marks", kind: "scalar", T: 2 /* ScalarType.FLOAT */, opt: true },
    { no: 14, name: "submission_type", kind: "enum", T: proto3.getEnumType(SubmissionType), opt: true },
    { no: 15, name: "source_geneo_assessment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 16, name: "chapter_ids_info", kind: "message", T: ChapterIdsInfo, repeated: true },
    { no: 17, name: "mode_of_conduction", kind: "enum", T: proto3.getEnumType(ModeOfConductionEnum), opt: true },
    { no: 18, name: "question_section_meta_info", kind: "message", T: QuestionSectionMeta, repeated: true },
    { no: 19, name: "marking_scheme_type", kind: "enum", T: proto3.getEnumType(MarkingSchemeEnum), opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AssessmentCreationSubmitV3Request {
    return new AssessmentCreationSubmitV3Request().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AssessmentCreationSubmitV3Request {
    return new AssessmentCreationSubmitV3Request().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AssessmentCreationSubmitV3Request {
    return new AssessmentCreationSubmitV3Request().fromJsonString(jsonString, options);
  }

  static equals(a: AssessmentCreationSubmitV3Request | PlainMessage<AssessmentCreationSubmitV3Request> | undefined, b: AssessmentCreationSubmitV3Request | PlainMessage<AssessmentCreationSubmitV3Request> | undefined): boolean {
    return proto3.util.equals(AssessmentCreationSubmitV3Request, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.AssessmentCreationSubmitV4Request
 */
export class AssessmentCreationSubmitV4Request extends Message<AssessmentCreationSubmitV4Request> {
  /**
   * ID of the teacher
   *
   * @generated from field: int64 teacher_id = 1;
   */
  teacherId = protoInt64.zero;

  /**
   * ID of the course
   *
   * @generated from field: int32 subject_id = 2;
   */
  subjectId = 0;

  /**
   * ID of the school class section
   *
   * @generated from field: int64 section_id = 3;
   */
  sectionId = protoInt64.zero;

  /**
   * Name of the task
   *
   * @generated from field: string task_name = 4;
   */
  taskName = "";

  /**
   * @generated from field: optional int32 module_id = 5;
   */
  moduleId?: number;

  /**
   * ID of the topic
   *
   * @generated from field: geneo.content.db.Module.ModuleCategoryEnum category = 6;
   */
  category = Module_ModuleCategoryEnum.MODULE_CATEGORY_UNDEFINED;

  /**
   * Information about selected tasks
   *
   * @generated from field: repeated geneo.lms.assessment.teacher.apis.TaskInfoModel selected_tasks_info = 7;
   */
  selectedTasksInfo: TaskInfoModel[] = [];

  /**
   * ID of the homework (optional)
   *
   * @generated from field: optional int64 assessment_id = 8;
   */
  assessmentId?: bigint;

  /**
   * Instructions for the homework (optional)
   *
   * @generated from field: repeated string instructions = 9;
   */
  instructions: string[] = [];

  /**
   * Status of the creation process
   *
   * @generated from field: geneo.lms.db.TaskCreationStatusEnum creation_status = 10;
   */
  creationStatus = TaskCreationStatusEnum.TASK_CREATION_STATUS_UNDEFINED;

  /**
   * @generated from field: geneo.lms.db.TaskEnum task_type = 11;
   */
  taskType = TaskEnum.TASK_UNDEFINED;

  /**
   * @generated from field: repeated geneo.lms.db.CloudUpload task_uploads = 12;
   */
  taskUploads: CloudUpload[] = [];

  /**
   * @generated from field: optional float max_marks = 13;
   */
  maxMarks?: number;

  /**
   * Only for teacher created CUSTOM hws
   *
   * @generated from field: optional geneo.lms.db.SubmissionType submission_type = 14;
   */
  submissionType?: SubmissionType;

  /**
   * @generated from field: optional int64 source_geneo_assessment_id = 15;
   */
  sourceGeneoAssessmentId?: bigint;

  /**
   * @generated from field: repeated geneo.lms.db.ChapterIdsInfo chapter_ids_info = 16;
   */
  chapterIdsInfo: ChapterIdsInfo[] = [];

  /**
   * @generated from field: optional geneo.lms.db.ModeOfConductionEnum mode_of_conduction = 17;
   */
  modeOfConduction?: ModeOfConductionEnum;

  /**
   * @generated from field: repeated geneo.lms.db.QuestionSectionMeta question_section_meta_info = 18;
   */
  questionSectionMetaInfo: QuestionSectionMeta[] = [];

  /**
   * @generated from field: optional geneo.lms.db.MarkingSchemeEnum marking_scheme_type = 19;
   */
  markingSchemeType?: MarkingSchemeEnum;

  /**
   * @generated from field: repeated geneo.lms.db.QuestionModuleMap question_module_map = 20;
   */
  questionModuleMap: QuestionModuleMap[] = [];

  /**
   * @generated from field: repeated geneo.lms.db.QuestionTypeMarks question_type_and_marks = 21;
   */
  questionTypeAndMarks: QuestionTypeMarks[] = [];

  /**
   * @generated from field: optional bool is_ai_assessment = 22;
   */
  isAiAssessment?: boolean;

  constructor(data?: PartialMessage<AssessmentCreationSubmitV4Request>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.AssessmentCreationSubmitV4Request";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "teacher_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "subject_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "section_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "task_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "module_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 6, name: "category", kind: "enum", T: proto3.getEnumType(Module_ModuleCategoryEnum) },
    { no: 7, name: "selected_tasks_info", kind: "message", T: TaskInfoModel, repeated: true },
    { no: 8, name: "assessment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 9, name: "instructions", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 10, name: "creation_status", kind: "enum", T: proto3.getEnumType(TaskCreationStatusEnum) },
    { no: 11, name: "task_type", kind: "enum", T: proto3.getEnumType(TaskEnum) },
    { no: 12, name: "task_uploads", kind: "message", T: CloudUpload, repeated: true },
    { no: 13, name: "max_marks", kind: "scalar", T: 2 /* ScalarType.FLOAT */, opt: true },
    { no: 14, name: "submission_type", kind: "enum", T: proto3.getEnumType(SubmissionType), opt: true },
    { no: 15, name: "source_geneo_assessment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 16, name: "chapter_ids_info", kind: "message", T: ChapterIdsInfo, repeated: true },
    { no: 17, name: "mode_of_conduction", kind: "enum", T: proto3.getEnumType(ModeOfConductionEnum), opt: true },
    { no: 18, name: "question_section_meta_info", kind: "message", T: QuestionSectionMeta, repeated: true },
    { no: 19, name: "marking_scheme_type", kind: "enum", T: proto3.getEnumType(MarkingSchemeEnum), opt: true },
    { no: 20, name: "question_module_map", kind: "message", T: QuestionModuleMap, repeated: true },
    { no: 21, name: "question_type_and_marks", kind: "message", T: QuestionTypeMarks, repeated: true },
    { no: 22, name: "is_ai_assessment", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AssessmentCreationSubmitV4Request {
    return new AssessmentCreationSubmitV4Request().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AssessmentCreationSubmitV4Request {
    return new AssessmentCreationSubmitV4Request().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AssessmentCreationSubmitV4Request {
    return new AssessmentCreationSubmitV4Request().fromJsonString(jsonString, options);
  }

  static equals(a: AssessmentCreationSubmitV4Request | PlainMessage<AssessmentCreationSubmitV4Request> | undefined, b: AssessmentCreationSubmitV4Request | PlainMessage<AssessmentCreationSubmitV4Request> | undefined): boolean {
    return proto3.util.equals(AssessmentCreationSubmitV4Request, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.CreateQuestionPaperTemplateRequest
 */
export class CreateQuestionPaperTemplateRequest extends Message<CreateQuestionPaperTemplateRequest> {
  /**
   * @generated from field: string template_title = 1;
   */
  templateTitle = "";

  /**
   * @generated from field: repeated geneo.lms.db.QuestionSection question_section_info = 2;
   */
  questionSectionInfo: QuestionSection[] = [];

  /**
   * @generated from field: int64 teacher_id = 3;
   */
  teacherId = protoInt64.zero;

  /**
   * @generated from field: optional int32 subject_id = 4;
   */
  subjectId?: number;

  /**
   * @generated from field: bool include_ai_questions = 5;
   */
  includeAiQuestions = false;

  constructor(data?: PartialMessage<CreateQuestionPaperTemplateRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.CreateQuestionPaperTemplateRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "template_title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "question_section_info", kind: "message", T: QuestionSection, repeated: true },
    { no: 3, name: "teacher_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "subject_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 5, name: "include_ai_questions", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateQuestionPaperTemplateRequest {
    return new CreateQuestionPaperTemplateRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateQuestionPaperTemplateRequest {
    return new CreateQuestionPaperTemplateRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateQuestionPaperTemplateRequest {
    return new CreateQuestionPaperTemplateRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateQuestionPaperTemplateRequest | PlainMessage<CreateQuestionPaperTemplateRequest> | undefined, b: CreateQuestionPaperTemplateRequest | PlainMessage<CreateQuestionPaperTemplateRequest> | undefined): boolean {
    return proto3.util.equals(CreateQuestionPaperTemplateRequest, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.CreateQuestionPaperTemplateResponse
 */
export class CreateQuestionPaperTemplateResponse extends Message<CreateQuestionPaperTemplateResponse> {
  /**
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * @generated from field: int64 question_paper_template_id = 4;
   */
  questionPaperTemplateId = protoInt64.zero;

  constructor(data?: PartialMessage<CreateQuestionPaperTemplateResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.CreateQuestionPaperTemplateResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "question_paper_template_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateQuestionPaperTemplateResponse {
    return new CreateQuestionPaperTemplateResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateQuestionPaperTemplateResponse {
    return new CreateQuestionPaperTemplateResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateQuestionPaperTemplateResponse {
    return new CreateQuestionPaperTemplateResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateQuestionPaperTemplateResponse | PlainMessage<CreateQuestionPaperTemplateResponse> | undefined, b: CreateQuestionPaperTemplateResponse | PlainMessage<CreateQuestionPaperTemplateResponse> | undefined): boolean {
    return proto3.util.equals(CreateQuestionPaperTemplateResponse, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.GetQuestionPaperTemplateRequest
 */
export class GetQuestionPaperTemplateRequest extends Message<GetQuestionPaperTemplateRequest> {
  /**
   * @generated from field: int64 person_id = 1;
   */
  personId = protoInt64.zero;

  /**
   * @generated from field: geneo.ums.db.ProfileRolesEnum person_type = 2;
   */
  personType = ProfileRolesEnum.PROFILE_ROLE_UNDEFINED;

  /**
   * @generated from field: optional int32 subject_id = 3;
   */
  subjectId?: number;

  constructor(data?: PartialMessage<GetQuestionPaperTemplateRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.GetQuestionPaperTemplateRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "person_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "person_type", kind: "enum", T: proto3.getEnumType(ProfileRolesEnum) },
    { no: 3, name: "subject_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetQuestionPaperTemplateRequest {
    return new GetQuestionPaperTemplateRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetQuestionPaperTemplateRequest {
    return new GetQuestionPaperTemplateRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetQuestionPaperTemplateRequest {
    return new GetQuestionPaperTemplateRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetQuestionPaperTemplateRequest | PlainMessage<GetQuestionPaperTemplateRequest> | undefined, b: GetQuestionPaperTemplateRequest | PlainMessage<GetQuestionPaperTemplateRequest> | undefined): boolean {
    return proto3.util.equals(GetQuestionPaperTemplateRequest, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.GetQuestionPaperTemplateResponse
 */
export class GetQuestionPaperTemplateResponse extends Message<GetQuestionPaperTemplateResponse> {
  /**
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * @generated from field: repeated geneo.lms.db.QuestionPaperTemplate question_paper_templates = 4;
   */
  questionPaperTemplates: QuestionPaperTemplate[] = [];

  constructor(data?: PartialMessage<GetQuestionPaperTemplateResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.GetQuestionPaperTemplateResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "question_paper_templates", kind: "message", T: QuestionPaperTemplate, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetQuestionPaperTemplateResponse {
    return new GetQuestionPaperTemplateResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetQuestionPaperTemplateResponse {
    return new GetQuestionPaperTemplateResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetQuestionPaperTemplateResponse {
    return new GetQuestionPaperTemplateResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetQuestionPaperTemplateResponse | PlainMessage<GetQuestionPaperTemplateResponse> | undefined, b: GetQuestionPaperTemplateResponse | PlainMessage<GetQuestionPaperTemplateResponse> | undefined): boolean {
    return proto3.util.equals(GetQuestionPaperTemplateResponse, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.QuestionStatsListV2
 */
export class QuestionStatsListV2 extends Message<QuestionStatsListV2> {
  /**
   * @generated from field: int32 no_of_questions = 1;
   */
  noOfQuestions = 0;

  /**
   * @generated from field: geneo.lms.hw.teacher.apis.DifficutlyLevelQuestions question_difficulty_level = 2;
   */
  questionDifficultyLevel?: DifficutlyLevelQuestions;

  /**
   * @generated from field: geneo.lms.hw.teacher.apis.QuestionTypeCount question_types = 3;
   */
  questionTypes?: QuestionTypeCount;

  /**
   * @generated from field: repeated geneo.content.db.BloomLevelEnum bloom_levels = 4;
   */
  bloomLevels: BloomLevelEnum[] = [];

  /**
   * @generated from field: int32 approximate_time = 5;
   */
  approximateTime = 0;

  /**
   * @generated from field: geneo.content.db.DifficultyLevelEnum avg_difficulty_level = 6;
   */
  avgDifficultyLevel = DifficultyLevelEnum.DIFFICULTY_LEVEL_UNDEFINED;

  /**
   * @generated from field: optional geneo.lms.db.ModeOfConductionEnum mode_of_conduction = 7;
   */
  modeOfConduction?: ModeOfConductionEnum;

  /**
   * @generated from field: repeated geneo.lms.db.QuestionTypeMarks question_type_and_marks = 8;
   */
  questionTypeAndMarks: QuestionTypeMarks[] = [];

  constructor(data?: PartialMessage<QuestionStatsListV2>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.QuestionStatsListV2";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "no_of_questions", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "question_difficulty_level", kind: "message", T: DifficutlyLevelQuestions },
    { no: 3, name: "question_types", kind: "message", T: QuestionTypeCount },
    { no: 4, name: "bloom_levels", kind: "enum", T: proto3.getEnumType(BloomLevelEnum), repeated: true },
    { no: 5, name: "approximate_time", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "avg_difficulty_level", kind: "enum", T: proto3.getEnumType(DifficultyLevelEnum) },
    { no: 7, name: "mode_of_conduction", kind: "enum", T: proto3.getEnumType(ModeOfConductionEnum), opt: true },
    { no: 8, name: "question_type_and_marks", kind: "message", T: QuestionTypeMarks, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): QuestionStatsListV2 {
    return new QuestionStatsListV2().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): QuestionStatsListV2 {
    return new QuestionStatsListV2().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): QuestionStatsListV2 {
    return new QuestionStatsListV2().fromJsonString(jsonString, options);
  }

  static equals(a: QuestionStatsListV2 | PlainMessage<QuestionStatsListV2> | undefined, b: QuestionStatsListV2 | PlainMessage<QuestionStatsListV2> | undefined): boolean {
    return proto3.util.equals(QuestionStatsListV2, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.GetModuleQuestionStatsV3Request
 */
export class GetModuleQuestionStatsV3Request extends Message<GetModuleQuestionStatsV3Request> {
  /**
   * @generated from field: int64 person_id = 1;
   */
  personId = protoInt64.zero;

  /**
   * @generated from field: geneo.ums.db.ProfileRolesEnum person_type = 2;
   */
  personType = ProfileRolesEnum.PROFILE_ROLE_UNDEFINED;

  /**
   * @generated from field: repeated int32 module_ids = 3;
   */
  moduleIds: number[] = [];

  /**
   * @generated from field: optional geneo.lms.db.ModeOfConductionEnum mode_of_conduction = 4;
   */
  modeOfConduction?: ModeOfConductionEnum;

  /**
   * @generated from field: repeated geneo.content.db.BloomLevelEnum bloom_levels = 5;
   */
  bloomLevels: BloomLevelEnum[] = [];

  /**
   * @generated from field: repeated string qIdsToBeIgnored = 6;
   */
  qIdsToBeIgnored: string[] = [];

  /**
   * @generated from field: optional geneo.lms.assessment.teacher.apis.AssessmentCreationEnum assessment_creation_type = 7;
   */
  assessmentCreationType?: AssessmentCreationEnum;

  /**
   * @generated from field: optional int32 subject_id = 8;
   */
  subjectId?: number;

  constructor(data?: PartialMessage<GetModuleQuestionStatsV3Request>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.GetModuleQuestionStatsV3Request";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "person_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "person_type", kind: "enum", T: proto3.getEnumType(ProfileRolesEnum) },
    { no: 3, name: "module_ids", kind: "scalar", T: 5 /* ScalarType.INT32 */, repeated: true },
    { no: 4, name: "mode_of_conduction", kind: "enum", T: proto3.getEnumType(ModeOfConductionEnum), opt: true },
    { no: 5, name: "bloom_levels", kind: "enum", T: proto3.getEnumType(BloomLevelEnum), repeated: true },
    { no: 6, name: "qIdsToBeIgnored", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 7, name: "assessment_creation_type", kind: "enum", T: proto3.getEnumType(AssessmentCreationEnum), opt: true },
    { no: 8, name: "subject_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetModuleQuestionStatsV3Request {
    return new GetModuleQuestionStatsV3Request().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetModuleQuestionStatsV3Request {
    return new GetModuleQuestionStatsV3Request().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetModuleQuestionStatsV3Request {
    return new GetModuleQuestionStatsV3Request().fromJsonString(jsonString, options);
  }

  static equals(a: GetModuleQuestionStatsV3Request | PlainMessage<GetModuleQuestionStatsV3Request> | undefined, b: GetModuleQuestionStatsV3Request | PlainMessage<GetModuleQuestionStatsV3Request> | undefined): boolean {
    return proto3.util.equals(GetModuleQuestionStatsV3Request, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.GetModuleQuestionStatsV3Response
 */
export class GetModuleQuestionStatsV3Response extends Message<GetModuleQuestionStatsV3Response> {
  /**
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * @generated from field: geneo.lms.assessment.teacher.apis.QuestionStatsListV2 data = 4;
   */
  data?: QuestionStatsListV2;

  constructor(data?: PartialMessage<GetModuleQuestionStatsV3Response>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.GetModuleQuestionStatsV3Response";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "data", kind: "message", T: QuestionStatsListV2 },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetModuleQuestionStatsV3Response {
    return new GetModuleQuestionStatsV3Response().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetModuleQuestionStatsV3Response {
    return new GetModuleQuestionStatsV3Response().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetModuleQuestionStatsV3Response {
    return new GetModuleQuestionStatsV3Response().fromJsonString(jsonString, options);
  }

  static equals(a: GetModuleQuestionStatsV3Response | PlainMessage<GetModuleQuestionStatsV3Response> | undefined, b: GetModuleQuestionStatsV3Response | PlainMessage<GetModuleQuestionStatsV3Response> | undefined): boolean {
    return proto3.util.equals(GetModuleQuestionStatsV3Response, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.FetchSectionStudentsRequest
 */
export class FetchSectionStudentsRequest extends Message<FetchSectionStudentsRequest> {
  /**
   * @generated from field: int64 person_id = 1;
   */
  personId = protoInt64.zero;

  /**
   * @generated from field: int32 class_id = 2;
   */
  classId = 0;

  /**
   * @generated from field: int32 subject_id = 3;
   */
  subjectId = 0;

  /**
   * @generated from field: repeated int32 section_ids = 4;
   */
  sectionIds: number[] = [];

  constructor(data?: PartialMessage<FetchSectionStudentsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.FetchSectionStudentsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "person_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "class_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "subject_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "section_ids", kind: "scalar", T: 5 /* ScalarType.INT32 */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FetchSectionStudentsRequest {
    return new FetchSectionStudentsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FetchSectionStudentsRequest {
    return new FetchSectionStudentsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FetchSectionStudentsRequest {
    return new FetchSectionStudentsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: FetchSectionStudentsRequest | PlainMessage<FetchSectionStudentsRequest> | undefined, b: FetchSectionStudentsRequest | PlainMessage<FetchSectionStudentsRequest> | undefined): boolean {
    return proto3.util.equals(FetchSectionStudentsRequest, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.FetchSectionStudentsResponse
 */
export class FetchSectionStudentsResponse extends Message<FetchSectionStudentsResponse> {
  /**
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * @generated from field: repeated geneo.lms.assessment.teacher.apis.SectionStudentInfo section_students_info = 4;
   */
  sectionStudentsInfo: SectionStudentInfo[] = [];

  constructor(data?: PartialMessage<FetchSectionStudentsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.FetchSectionStudentsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "section_students_info", kind: "message", T: SectionStudentInfo, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FetchSectionStudentsResponse {
    return new FetchSectionStudentsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FetchSectionStudentsResponse {
    return new FetchSectionStudentsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FetchSectionStudentsResponse {
    return new FetchSectionStudentsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: FetchSectionStudentsResponse | PlainMessage<FetchSectionStudentsResponse> | undefined, b: FetchSectionStudentsResponse | PlainMessage<FetchSectionStudentsResponse> | undefined): boolean {
    return proto3.util.equals(FetchSectionStudentsResponse, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.SectionStudentInfo
 */
export class SectionStudentInfo extends Message<SectionStudentInfo> {
  /**
   * @generated from field: int64 student_id = 1;
   */
  studentId = protoInt64.zero;

  /**
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * @generated from field: string roll_number = 3;
   */
  rollNumber = "";

  /**
   * @generated from field: string class = 4;
   */
  class = "";

  /**
   * @generated from field: int32 class_id = 5;
   */
  classId = 0;

  /**
   * @generated from field: string section_name = 6;
   */
  sectionName = "";

  /**
   * @generated from field: int64 section_id = 7;
   */
  sectionId = protoInt64.zero;

  /**
   * @generated from field: string profile_pic_url = 8;
   */
  profilePicUrl = "";

  constructor(data?: PartialMessage<SectionStudentInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.SectionStudentInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "student_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "roll_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "class", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "class_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "section_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "section_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 8, name: "profile_pic_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SectionStudentInfo {
    return new SectionStudentInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SectionStudentInfo {
    return new SectionStudentInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SectionStudentInfo {
    return new SectionStudentInfo().fromJsonString(jsonString, options);
  }

  static equals(a: SectionStudentInfo | PlainMessage<SectionStudentInfo> | undefined, b: SectionStudentInfo | PlainMessage<SectionStudentInfo> | undefined): boolean {
    return proto3.util.equals(SectionStudentInfo, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.AssessmentAssignmentSubmitV2Request
 */
export class AssessmentAssignmentSubmitV2Request extends Message<AssessmentAssignmentSubmitV2Request> {
  /**
   * @generated from field: int64 teacher_id = 1;
   */
  teacherId = protoInt64.zero;

  /**
   * @generated from field: int64 assessment_id = 2;
   */
  assessmentId = protoInt64.zero;

  /**
   * @generated from field: google.protobuf.Timestamp start_time = 3;
   */
  startTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp end_time = 4;
   */
  endTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp daily_reminder_time = 5;
   */
  dailyReminderTime?: Timestamp;

  /**
   * @generated from field: repeated string assessment_instructions = 6;
   */
  assessmentInstructions: string[] = [];

  /**
   * @generated from field: repeated int64 section_ids = 7;
   */
  sectionIds: bigint[] = [];

  /**
   * @generated from field: string assessment_name = 8;
   */
  assessmentName = "";

  /**
   * @generated from field: repeated geneo.lms.db.AssignmentInfo assignment_info = 9;
   */
  assignmentInfo: AssignmentInfo[] = [];

  /**
   * @generated from field: optional float time_duration_in_min = 10;
   */
  timeDurationInMin?: number;

  /**
   * @generated from field: optional geneo.lms.db.ModeOfConductionEnum mode_of_conduction = 11;
   */
  modeOfConduction?: ModeOfConductionEnum;

  /**
   * @generated from field: optional bool end_assessment_now = 12;
   */
  endAssessmentNow?: boolean;

  /**
   * @generated from field: repeated geneo.lms.assessment.teacher.apis.SectionStudent section_students_info = 13;
   */
  sectionStudentsInfo: SectionStudent[] = [];

  /**
   * @generated from field: optional geneo.lms.db.MarkingSchemeEnum marking_scheme_type = 14;
   */
  markingSchemeType?: MarkingSchemeEnum;

  /**
   * @generated from field: optional int32 defaultQuestionTimeInSec = 15;
   */
  defaultQuestionTimeInSec?: number;

  /**
   * @generated from field: optional int32 number_of_set = 16;
   */
  numberOfSet?: number;

  /**
   * Collaboration groups for a Project assessment. Leave empty for every other
   * task type - an empty list runs the existing single-group assignment path
   * unchanged. When present, one student_group is created per entry IN ADDITION
   * to the section-wide group that task_group_assignment keeps pointing at.
   *
   * @generated from field: repeated geneo.lms.assessment.teacher.apis.CollaborativeStudentGroupInput student_groups = 17;
   */
  studentGroups: CollaborativeStudentGroupInput[] = [];

  /**
   * @generated from field: optional float max_marks = 18;
   */
  maxMarks?: number;

  constructor(data?: PartialMessage<AssessmentAssignmentSubmitV2Request>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.AssessmentAssignmentSubmitV2Request";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "teacher_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "assessment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "start_time", kind: "message", T: Timestamp },
    { no: 4, name: "end_time", kind: "message", T: Timestamp },
    { no: 5, name: "daily_reminder_time", kind: "message", T: Timestamp },
    { no: 6, name: "assessment_instructions", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 7, name: "section_ids", kind: "scalar", T: 3 /* ScalarType.INT64 */, repeated: true },
    { no: 8, name: "assessment_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "assignment_info", kind: "message", T: AssignmentInfo, repeated: true },
    { no: 10, name: "time_duration_in_min", kind: "scalar", T: 2 /* ScalarType.FLOAT */, opt: true },
    { no: 11, name: "mode_of_conduction", kind: "enum", T: proto3.getEnumType(ModeOfConductionEnum), opt: true },
    { no: 12, name: "end_assessment_now", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 13, name: "section_students_info", kind: "message", T: SectionStudent, repeated: true },
    { no: 14, name: "marking_scheme_type", kind: "enum", T: proto3.getEnumType(MarkingSchemeEnum), opt: true },
    { no: 15, name: "defaultQuestionTimeInSec", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 16, name: "number_of_set", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 17, name: "student_groups", kind: "message", T: CollaborativeStudentGroupInput, repeated: true },
    { no: 18, name: "max_marks", kind: "scalar", T: 2 /* ScalarType.FLOAT */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AssessmentAssignmentSubmitV2Request {
    return new AssessmentAssignmentSubmitV2Request().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AssessmentAssignmentSubmitV2Request {
    return new AssessmentAssignmentSubmitV2Request().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AssessmentAssignmentSubmitV2Request {
    return new AssessmentAssignmentSubmitV2Request().fromJsonString(jsonString, options);
  }

  static equals(a: AssessmentAssignmentSubmitV2Request | PlainMessage<AssessmentAssignmentSubmitV2Request> | undefined, b: AssessmentAssignmentSubmitV2Request | PlainMessage<AssessmentAssignmentSubmitV2Request> | undefined): boolean {
    return proto3.util.equals(AssessmentAssignmentSubmitV2Request, a, b);
  }
}

/**
 * One collaboration group requested by the teacher for a Project assessment.
 *
 * @generated from message geneo.lms.assessment.teacher.apis.CollaborativeStudentGroupInput
 */
export class CollaborativeStudentGroupInput extends Message<CollaborativeStudentGroupInput> {
  /**
   * Client-supplied correlation id, echoed back in the response so the client
   * can map its local group to the created student_group_id. Not persisted -
   * a re-submitted assignment is matched to its stored group by group_name.
   *
   * @generated from field: string client_group_id = 1;
   */
  clientGroupId = "";

  /**
   * Must be unique within the assessment: it is what identifies a group across
   * a re-submitted assignment. "studentGroup" is reserved.
   *
   * @generated from field: string group_name = 2;
   */
  groupName = "";

  /**
   * @generated from field: int64 section_id = 3;
   */
  sectionId = protoInt64.zero;

  /**
   * @generated from field: repeated int64 student_ids = 4;
   */
  studentIds: bigint[] = [];

  constructor(data?: PartialMessage<CollaborativeStudentGroupInput>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.CollaborativeStudentGroupInput";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "client_group_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "group_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "section_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "student_ids", kind: "scalar", T: 3 /* ScalarType.INT64 */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CollaborativeStudentGroupInput {
    return new CollaborativeStudentGroupInput().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CollaborativeStudentGroupInput {
    return new CollaborativeStudentGroupInput().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CollaborativeStudentGroupInput {
    return new CollaborativeStudentGroupInput().fromJsonString(jsonString, options);
  }

  static equals(a: CollaborativeStudentGroupInput | PlainMessage<CollaborativeStudentGroupInput> | undefined, b: CollaborativeStudentGroupInput | PlainMessage<CollaborativeStudentGroupInput> | undefined): boolean {
    return proto3.util.equals(CollaborativeStudentGroupInput, a, b);
  }
}

/**
 * Server-assigned identity of a created collaboration group, echoed back so the
 * client can reconcile its client_group_id with the real student_group_id.
 *
 * @generated from message geneo.lms.assessment.teacher.apis.CollaborativeStudentGroupResult
 */
export class CollaborativeStudentGroupResult extends Message<CollaborativeStudentGroupResult> {
  /**
   * @generated from field: string client_group_id = 1;
   */
  clientGroupId = "";

  /**
   * @generated from field: int64 student_group_id = 2;
   */
  studentGroupId = protoInt64.zero;

  /**
   * @generated from field: string group_name = 3;
   */
  groupName = "";

  /**
   * @generated from field: int64 section_id = 4;
   */
  sectionId = protoInt64.zero;

  /**
   * @generated from field: repeated int64 student_ids = 5;
   */
  studentIds: bigint[] = [];

  constructor(data?: PartialMessage<CollaborativeStudentGroupResult>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.CollaborativeStudentGroupResult";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "client_group_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "student_group_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "group_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "section_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "student_ids", kind: "scalar", T: 3 /* ScalarType.INT64 */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CollaborativeStudentGroupResult {
    return new CollaborativeStudentGroupResult().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CollaborativeStudentGroupResult {
    return new CollaborativeStudentGroupResult().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CollaborativeStudentGroupResult {
    return new CollaborativeStudentGroupResult().fromJsonString(jsonString, options);
  }

  static equals(a: CollaborativeStudentGroupResult | PlainMessage<CollaborativeStudentGroupResult> | undefined, b: CollaborativeStudentGroupResult | PlainMessage<CollaborativeStudentGroupResult> | undefined): boolean {
    return proto3.util.equals(CollaborativeStudentGroupResult, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.SectionStudent
 */
export class SectionStudent extends Message<SectionStudent> {
  /**
   * @generated from field: int64 section_id = 1;
   */
  sectionId = protoInt64.zero;

  /**
   * @generated from field: int64 student_id = 2;
   */
  studentId = protoInt64.zero;

  constructor(data?: PartialMessage<SectionStudent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.SectionStudent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "section_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "student_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SectionStudent {
    return new SectionStudent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SectionStudent {
    return new SectionStudent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SectionStudent {
    return new SectionStudent().fromJsonString(jsonString, options);
  }

  static equals(a: SectionStudent | PlainMessage<SectionStudent> | undefined, b: SectionStudent | PlainMessage<SectionStudent> | undefined): boolean {
    return proto3.util.equals(SectionStudent, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.GetAttendanceRequest
 */
export class GetAttendanceRequest extends Message<GetAttendanceRequest> {
  /**
   * @generated from field: int64 teacher_id = 1;
   */
  teacherId = protoInt64.zero;

  /**
   * @generated from field: int64 assessment_id = 2;
   */
  assessmentId = protoInt64.zero;

  constructor(data?: PartialMessage<GetAttendanceRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.GetAttendanceRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "teacher_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "assessment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetAttendanceRequest {
    return new GetAttendanceRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetAttendanceRequest {
    return new GetAttendanceRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetAttendanceRequest {
    return new GetAttendanceRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetAttendanceRequest | PlainMessage<GetAttendanceRequest> | undefined, b: GetAttendanceRequest | PlainMessage<GetAttendanceRequest> | undefined): boolean {
    return proto3.util.equals(GetAttendanceRequest, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.StudentAttendanceRecord
 */
export class StudentAttendanceRecord extends Message<StudentAttendanceRecord> {
  /**
   * @generated from field: int64 student_id = 1;
   */
  studentId = protoInt64.zero;

  /**
   * @generated from field: string student_name = 2;
   */
  studentName = "";

  /**
   * @generated from field: int64 section_id = 3;
   */
  sectionId = protoInt64.zero;

  /**
   * @generated from field: bool is_marked = 4;
   */
  isMarked = false;

  /**
   * @generated from field: bool is_present = 5;
   */
  isPresent = false;

  /**
   * @generated from field: string roll_number = 6;
   */
  rollNumber = "";

  /**
   * @generated from field: string class = 7;
   */
  class = "";

  /**
   * @generated from field: int32 class_id = 8;
   */
  classId = 0;

  /**
   * @generated from field: string section_name = 9;
   */
  sectionName = "";

  /**
   * @generated from field: string profile_pic_url = 10;
   */
  profilePicUrl = "";

  constructor(data?: PartialMessage<StudentAttendanceRecord>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.StudentAttendanceRecord";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "student_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "student_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "section_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "is_marked", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "is_present", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "roll_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "class", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "class_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "section_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "profile_pic_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StudentAttendanceRecord {
    return new StudentAttendanceRecord().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StudentAttendanceRecord {
    return new StudentAttendanceRecord().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StudentAttendanceRecord {
    return new StudentAttendanceRecord().fromJsonString(jsonString, options);
  }

  static equals(a: StudentAttendanceRecord | PlainMessage<StudentAttendanceRecord> | undefined, b: StudentAttendanceRecord | PlainMessage<StudentAttendanceRecord> | undefined): boolean {
    return proto3.util.equals(StudentAttendanceRecord, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.GetAttendanceResponse
 */
export class GetAttendanceResponse extends Message<GetAttendanceResponse> {
  /**
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * @generated from field: geneo.lms.assessment.teacher.apis.GetAttendanceData data = 4;
   */
  data?: GetAttendanceData;

  constructor(data?: PartialMessage<GetAttendanceResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.GetAttendanceResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "data", kind: "message", T: GetAttendanceData },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetAttendanceResponse {
    return new GetAttendanceResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetAttendanceResponse {
    return new GetAttendanceResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetAttendanceResponse {
    return new GetAttendanceResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetAttendanceResponse | PlainMessage<GetAttendanceResponse> | undefined, b: GetAttendanceResponse | PlainMessage<GetAttendanceResponse> | undefined): boolean {
    return proto3.util.equals(GetAttendanceResponse, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.GetAttendanceData
 */
export class GetAttendanceData extends Message<GetAttendanceData> {
  /**
   * @generated from field: bool is_required = 1;
   */
  isRequired = false;

  /**
   * @generated from field: repeated geneo.lms.assessment.teacher.apis.StudentAttendanceRecord students = 2;
   */
  students: StudentAttendanceRecord[] = [];

  constructor(data?: PartialMessage<GetAttendanceData>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.GetAttendanceData";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "is_required", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "students", kind: "message", T: StudentAttendanceRecord, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetAttendanceData {
    return new GetAttendanceData().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetAttendanceData {
    return new GetAttendanceData().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetAttendanceData {
    return new GetAttendanceData().fromJsonString(jsonString, options);
  }

  static equals(a: GetAttendanceData | PlainMessage<GetAttendanceData> | undefined, b: GetAttendanceData | PlainMessage<GetAttendanceData> | undefined): boolean {
    return proto3.util.equals(GetAttendanceData, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.StudentAttendanceInput
 */
export class StudentAttendanceInput extends Message<StudentAttendanceInput> {
  /**
   * @generated from field: int64 student_id = 1;
   */
  studentId = protoInt64.zero;

  /**
   * @generated from field: bool is_present = 2;
   */
  isPresent = false;

  constructor(data?: PartialMessage<StudentAttendanceInput>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.StudentAttendanceInput";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "student_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "is_present", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StudentAttendanceInput {
    return new StudentAttendanceInput().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StudentAttendanceInput {
    return new StudentAttendanceInput().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StudentAttendanceInput {
    return new StudentAttendanceInput().fromJsonString(jsonString, options);
  }

  static equals(a: StudentAttendanceInput | PlainMessage<StudentAttendanceInput> | undefined, b: StudentAttendanceInput | PlainMessage<StudentAttendanceInput> | undefined): boolean {
    return proto3.util.equals(StudentAttendanceInput, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.MarkAttendanceRequest
 */
export class MarkAttendanceRequest extends Message<MarkAttendanceRequest> {
  /**
   * @generated from field: int64 teacher_id = 1;
   */
  teacherId = protoInt64.zero;

  /**
   * @generated from field: int64 assessment_id = 2;
   */
  assessmentId = protoInt64.zero;

  /**
   * @generated from field: repeated geneo.lms.assessment.teacher.apis.StudentAttendanceInput attendance = 3;
   */
  attendance: StudentAttendanceInput[] = [];

  constructor(data?: PartialMessage<MarkAttendanceRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.MarkAttendanceRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "teacher_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "assessment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "attendance", kind: "message", T: StudentAttendanceInput, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MarkAttendanceRequest {
    return new MarkAttendanceRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MarkAttendanceRequest {
    return new MarkAttendanceRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MarkAttendanceRequest {
    return new MarkAttendanceRequest().fromJsonString(jsonString, options);
  }

  static equals(a: MarkAttendanceRequest | PlainMessage<MarkAttendanceRequest> | undefined, b: MarkAttendanceRequest | PlainMessage<MarkAttendanceRequest> | undefined): boolean {
    return proto3.util.equals(MarkAttendanceRequest, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.MarkAttendanceResponse
 */
export class MarkAttendanceResponse extends Message<MarkAttendanceResponse> {
  /**
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * @generated from field: geneo.lms.db.AttendanceInfo data = 4;
   */
  data?: AttendanceInfo;

  constructor(data?: PartialMessage<MarkAttendanceResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.MarkAttendanceResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "data", kind: "message", T: AttendanceInfo },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MarkAttendanceResponse {
    return new MarkAttendanceResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MarkAttendanceResponse {
    return new MarkAttendanceResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MarkAttendanceResponse {
    return new MarkAttendanceResponse().fromJsonString(jsonString, options);
  }

  static equals(a: MarkAttendanceResponse | PlainMessage<MarkAttendanceResponse> | undefined, b: MarkAttendanceResponse | PlainMessage<MarkAttendanceResponse> | undefined): boolean {
    return proto3.util.equals(MarkAttendanceResponse, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.TopicData
 */
export class TopicData extends Message<TopicData> {
  /**
   * @generated from field: string topic_name = 1;
   */
  topicName = "";

  /**
   * @generated from field: int32 topic_id = 2;
   */
  topicId = 0;

  constructor(data?: PartialMessage<TopicData>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.TopicData";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "topic_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "topic_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TopicData {
    return new TopicData().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TopicData {
    return new TopicData().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TopicData {
    return new TopicData().fromJsonString(jsonString, options);
  }

  static equals(a: TopicData | PlainMessage<TopicData> | undefined, b: TopicData | PlainMessage<TopicData> | undefined): boolean {
    return proto3.util.equals(TopicData, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.ChapterTopicData
 */
export class ChapterTopicData extends Message<ChapterTopicData> {
  /**
   * @generated from field: string chapter_name = 1;
   */
  chapterName = "";

  /**
   * @generated from field: int32 chapter_id = 2;
   */
  chapterId = 0;

  /**
   * @generated from field: repeated geneo.lms.assessment.teacher.apis.TopicData topics = 3;
   */
  topics: TopicData[] = [];

  constructor(data?: PartialMessage<ChapterTopicData>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.ChapterTopicData";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "chapter_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "chapter_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "topics", kind: "message", T: TopicData, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ChapterTopicData {
    return new ChapterTopicData().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ChapterTopicData {
    return new ChapterTopicData().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ChapterTopicData {
    return new ChapterTopicData().fromJsonString(jsonString, options);
  }

  static equals(a: ChapterTopicData | PlainMessage<ChapterTopicData> | undefined, b: ChapterTopicData | PlainMessage<ChapterTopicData> | undefined): boolean {
    return proto3.util.equals(ChapterTopicData, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.EducationalHierarchy
 */
export class EducationalHierarchy extends Message<EducationalHierarchy> {
  /**
   * @generated from field: string board = 1;
   */
  board = "";

  /**
   * @generated from field: optional string curriculum = 2;
   */
  curriculum?: string;

  /**
   * @generated from field: optional int32 grade = 3;
   */
  grade?: number;

  /**
   * @generated from field: optional string subject = 4;
   */
  subject?: string;

  /**
   * @generated from field: optional int32 subject_id = 5;
   */
  subjectId?: number;

  /**
   * @generated from field: repeated geneo.lms.assessment.teacher.apis.ChapterTopicData chapter_topics = 6;
   */
  chapterTopics: ChapterTopicData[] = [];

  constructor(data?: PartialMessage<EducationalHierarchy>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.EducationalHierarchy";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "board", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "curriculum", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "grade", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 4, name: "subject", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "subject_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 6, name: "chapter_topics", kind: "message", T: ChapterTopicData, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): EducationalHierarchy {
    return new EducationalHierarchy().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): EducationalHierarchy {
    return new EducationalHierarchy().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): EducationalHierarchy {
    return new EducationalHierarchy().fromJsonString(jsonString, options);
  }

  static equals(a: EducationalHierarchy | PlainMessage<EducationalHierarchy> | undefined, b: EducationalHierarchy | PlainMessage<EducationalHierarchy> | undefined): boolean {
    return proto3.util.equals(EducationalHierarchy, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.AiQuestionSectionInfo
 */
export class AiQuestionSectionInfo extends Message<AiQuestionSectionInfo> {
  /**
   * @generated from field: geneo.content.db.Question.QuestionEnum question_type = 1;
   */
  questionType = Question_QuestionEnum.QUESTION_TYPE_UNDEFINED;

  /**
   * @generated from field: int32 no_of_questions = 2;
   */
  noOfQuestions = 0;

  /**
   * @generated from field: optional int32 marks = 3;
   */
  marks?: number;

  /**
   * @generated from field: optional int32 total_marks = 4;
   */
  totalMarks?: number;

  /**
   * @generated from field: geneo.content.db.DifficultyLevelEnum difficulty_level = 5;
   */
  difficultyLevel = DifficultyLevelEnum.DIFFICULTY_LEVEL_UNDEFINED;

  /**
   * @generated from field: repeated geneo.content.db.BloomLevelEnum bloom_levels = 6;
   */
  bloomLevels: BloomLevelEnum[] = [];

  /**
   * @generated from field: optional string section_instruction = 7;
   */
  sectionInstruction?: string;

  /**
   * @generated from field: optional int32 time_to_solve = 8;
   */
  timeToSolve?: number;

  /**
   * @generated from field: bool is_alternate_enable = 9;
   */
  isAlternateEnable = false;

  constructor(data?: PartialMessage<AiQuestionSectionInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.AiQuestionSectionInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "question_type", kind: "enum", T: proto3.getEnumType(Question_QuestionEnum) },
    { no: 2, name: "no_of_questions", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "marks", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 4, name: "total_marks", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 5, name: "difficulty_level", kind: "enum", T: proto3.getEnumType(DifficultyLevelEnum) },
    { no: 6, name: "bloom_levels", kind: "enum", T: proto3.getEnumType(BloomLevelEnum), repeated: true },
    { no: 7, name: "section_instruction", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 8, name: "time_to_solve", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 9, name: "is_alternate_enable", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AiQuestionSectionInfo {
    return new AiQuestionSectionInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AiQuestionSectionInfo {
    return new AiQuestionSectionInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AiQuestionSectionInfo {
    return new AiQuestionSectionInfo().fromJsonString(jsonString, options);
  }

  static equals(a: AiQuestionSectionInfo | PlainMessage<AiQuestionSectionInfo> | undefined, b: AiQuestionSectionInfo | PlainMessage<AiQuestionSectionInfo> | undefined): boolean {
    return proto3.util.equals(AiQuestionSectionInfo, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.QuestionConfiguration
 */
export class QuestionConfiguration extends Message<QuestionConfiguration> {
  /**
   * @generated from field: bool include_explanations = 1;
   */
  includeExplanations = false;

  /**
   * @generated from field: bool include_hints = 2;
   */
  includeHints = false;

  /**
   * @generated from field: bool include_worked_solutions = 3;
   */
  includeWorkedSolutions = false;

  /**
   * @generated from field: bool include_common_mistakes = 4;
   */
  includeCommonMistakes = false;

  /**
   * @generated from field: bool randomize_options = 5;
   */
  randomizeOptions = false;

  /**
   * @generated from field: int32 max_options_per_mcq = 6;
   */
  maxOptionsPerMcq = 0;

  constructor(data?: PartialMessage<QuestionConfiguration>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.QuestionConfiguration";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "include_explanations", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "include_hints", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "include_worked_solutions", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "include_common_mistakes", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "randomize_options", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "max_options_per_mcq", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): QuestionConfiguration {
    return new QuestionConfiguration().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): QuestionConfiguration {
    return new QuestionConfiguration().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): QuestionConfiguration {
    return new QuestionConfiguration().fromJsonString(jsonString, options);
  }

  static equals(a: QuestionConfiguration | PlainMessage<QuestionConfiguration> | undefined, b: QuestionConfiguration | PlainMessage<QuestionConfiguration> | undefined): boolean {
    return proto3.util.equals(QuestionConfiguration, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.GenerateQuestionsRequest
 */
export class GenerateQuestionsRequest extends Message<GenerateQuestionsRequest> {
  /**
   * @generated from field: geneo.lms.assessment.teacher.apis.EducationalHierarchy educational_context = 1;
   */
  educationalContext?: EducationalHierarchy;

  /**
   * @generated from field: repeated geneo.lms.assessment.teacher.apis.AiQuestionSectionInfo question_sections = 2;
   */
  questionSections: AiQuestionSectionInfo[] = [];

  /**
   * @generated from field: geneo.lms.assessment.teacher.apis.QuestionConfiguration question_config = 3;
   */
  questionConfig?: QuestionConfiguration;

  /**
   * @generated from field: geneo.content.db.DifficultyLevelEnum difficulty_level = 4;
   */
  difficultyLevel = DifficultyLevelEnum.DIFFICULTY_LEVEL_UNDEFINED;

  /**
   * @generated from field: repeated geneo.content.db.BloomLevelEnum bloom_levels = 5;
   */
  bloomLevels: BloomLevelEnum[] = [];

  /**
   * @generated from field: repeated string custom_prompt = 6;
   */
  customPrompt: string[] = [];

  /**
   * @generated from field: repeated string special_instructions = 7;
   */
  specialInstructions: string[] = [];

  /**
   * @generated from field: geneo.lms.assessment.teacher.apis.AiAssessmentEnum assessment_type = 8;
   */
  assessmentType = AiAssessmentEnum.ASSESSMENT_UNDEFINED;

  /**
   * @generated from field: optional string current_question_id = 9;
   */
  currentQuestionId?: string;

  /**
   * @generated from field: int64 teacher_id = 10;
   */
  teacherId = protoInt64.zero;

  /**
   * @generated from field: repeated geneo.content.db.Question.QuestionEnum required_question_types = 11;
   */
  requiredQuestionTypes: Question_QuestionEnum[] = [];

  /**
   * @generated from field: repeated geneo.content.db.DifficultyLevelEnum required_difficulty_types = 12;
   */
  requiredDifficultyTypes: DifficultyLevelEnum[] = [];

  constructor(data?: PartialMessage<GenerateQuestionsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.GenerateQuestionsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "educational_context", kind: "message", T: EducationalHierarchy },
    { no: 2, name: "question_sections", kind: "message", T: AiQuestionSectionInfo, repeated: true },
    { no: 3, name: "question_config", kind: "message", T: QuestionConfiguration },
    { no: 4, name: "difficulty_level", kind: "enum", T: proto3.getEnumType(DifficultyLevelEnum) },
    { no: 5, name: "bloom_levels", kind: "enum", T: proto3.getEnumType(BloomLevelEnum), repeated: true },
    { no: 6, name: "custom_prompt", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 7, name: "special_instructions", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 8, name: "assessment_type", kind: "enum", T: proto3.getEnumType(AiAssessmentEnum) },
    { no: 9, name: "current_question_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 10, name: "teacher_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 11, name: "required_question_types", kind: "enum", T: proto3.getEnumType(Question_QuestionEnum), repeated: true },
    { no: 12, name: "required_difficulty_types", kind: "enum", T: proto3.getEnumType(DifficultyLevelEnum), repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GenerateQuestionsRequest {
    return new GenerateQuestionsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GenerateQuestionsRequest {
    return new GenerateQuestionsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GenerateQuestionsRequest {
    return new GenerateQuestionsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GenerateQuestionsRequest | PlainMessage<GenerateQuestionsRequest> | undefined, b: GenerateQuestionsRequest | PlainMessage<GenerateQuestionsRequest> | undefined): boolean {
    return proto3.util.equals(GenerateQuestionsRequest, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.GetModuleFilteredQuestionsV4Request
 */
export class GetModuleFilteredQuestionsV4Request extends Message<GetModuleFilteredQuestionsV4Request> {
  /**
   * @generated from field: int64 teacher_id = 1;
   */
  teacherId = protoInt64.zero;

  /**
   * @generated from field: int32 subject_id = 2;
   */
  subjectId = 0;

  /**
   * @generated from field: repeated int32 module_ids = 3;
   */
  moduleIds: number[] = [];

  /**
   * @generated from field: repeated geneo.content.db.Question.QuestionEnum required_question_types = 4;
   */
  requiredQuestionTypes: Question_QuestionEnum[] = [];

  /**
   * @generated from field: repeated geneo.content.db.DifficultyLevelEnum required_difficulty_types = 5;
   */
  requiredDifficultyTypes: DifficultyLevelEnum[] = [];

  /**
   * @generated from field: optional geneo.lms.hw.teacher.apis.RequiredQuestionCountInfoForDifficultyLevel required_difficulty_levels_count_info = 6;
   */
  requiredDifficultyLevelsCountInfo?: RequiredQuestionCountInfoForDifficultyLevel;

  /**
   * @generated from field: repeated string qIdsToBeIgnored = 7;
   */
  qIdsToBeIgnored: string[] = [];

  /**
   * @generated from field: repeated geneo.content.db.BloomLevelEnum bloom_levels = 8;
   */
  bloomLevels: BloomLevelEnum[] = [];

  /**
   * @generated from field: optional int32 no_of_questions = 9;
   */
  noOfQuestions?: number;

  /**
   * @generated from field: optional int32 approximate_time = 10;
   */
  approximateTime?: number;

  /**
   * @generated from field: optional geneo.content.db.DifficultyLevelEnum avg_difficulty_level = 11;
   */
  avgDifficultyLevel?: DifficultyLevelEnum;

  /**
   * @generated from field: geneo.lms.assessment.teacher.apis.AssessmentCreationEnum assessment_creation_type = 12;
   */
  assessmentCreationType = AssessmentCreationEnum.ASSESSMENT_CREATION_UNDEFINED;

  /**
   * @generated from field: optional geneo.lms.db.ModeOfConductionEnum mode_of_conduction = 13;
   */
  modeOfConduction?: ModeOfConductionEnum;

  /**
   * @generated from field: optional int32 page_number = 14;
   */
  pageNumber?: number;

  /**
   * @generated from field: repeated geneo.lms.db.QuestionSection question_section_info = 15;
   */
  questionSectionInfo: QuestionSection[] = [];

  /**
   * @generated from field: repeated string ai_question_prompts = 16;
   */
  aiQuestionPrompts: string[] = [];

  /**
   * @generated from field: bool allow_ai_questions = 17;
   */
  allowAiQuestions = false;

  /**
   * @generated from field: optional string current_question_id = 18;
   */
  currentQuestionId?: string;

  /**
   * @generated from field: optional bool is_ai_assessment = 19;
   */
  isAiAssessment?: boolean;

  constructor(data?: PartialMessage<GetModuleFilteredQuestionsV4Request>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.GetModuleFilteredQuestionsV4Request";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "teacher_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "subject_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "module_ids", kind: "scalar", T: 5 /* ScalarType.INT32 */, repeated: true },
    { no: 4, name: "required_question_types", kind: "enum", T: proto3.getEnumType(Question_QuestionEnum), repeated: true },
    { no: 5, name: "required_difficulty_types", kind: "enum", T: proto3.getEnumType(DifficultyLevelEnum), repeated: true },
    { no: 6, name: "required_difficulty_levels_count_info", kind: "message", T: RequiredQuestionCountInfoForDifficultyLevel, opt: true },
    { no: 7, name: "qIdsToBeIgnored", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 8, name: "bloom_levels", kind: "enum", T: proto3.getEnumType(BloomLevelEnum), repeated: true },
    { no: 9, name: "no_of_questions", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 10, name: "approximate_time", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 11, name: "avg_difficulty_level", kind: "enum", T: proto3.getEnumType(DifficultyLevelEnum), opt: true },
    { no: 12, name: "assessment_creation_type", kind: "enum", T: proto3.getEnumType(AssessmentCreationEnum) },
    { no: 13, name: "mode_of_conduction", kind: "enum", T: proto3.getEnumType(ModeOfConductionEnum), opt: true },
    { no: 14, name: "page_number", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 15, name: "question_section_info", kind: "message", T: QuestionSection, repeated: true },
    { no: 16, name: "ai_question_prompts", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 17, name: "allow_ai_questions", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 18, name: "current_question_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 19, name: "is_ai_assessment", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetModuleFilteredQuestionsV4Request {
    return new GetModuleFilteredQuestionsV4Request().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetModuleFilteredQuestionsV4Request {
    return new GetModuleFilteredQuestionsV4Request().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetModuleFilteredQuestionsV4Request {
    return new GetModuleFilteredQuestionsV4Request().fromJsonString(jsonString, options);
  }

  static equals(a: GetModuleFilteredQuestionsV4Request | PlainMessage<GetModuleFilteredQuestionsV4Request> | undefined, b: GetModuleFilteredQuestionsV4Request | PlainMessage<GetModuleFilteredQuestionsV4Request> | undefined): boolean {
    return proto3.util.equals(GetModuleFilteredQuestionsV4Request, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.GetModuleFilteredQuestionsV5Request
 */
export class GetModuleFilteredQuestionsV5Request extends Message<GetModuleFilteredQuestionsV5Request> {
  /**
   * @generated from field: int64 teacher_id = 1;
   */
  teacherId = protoInt64.zero;

  /**
   * @generated from field: int32 subject_id = 2;
   */
  subjectId = 0;

  /**
   * @generated from field: repeated int32 module_ids = 3;
   */
  moduleIds: number[] = [];

  /**
   * @generated from field: repeated geneo.content.db.Question.QuestionEnum required_question_types = 4;
   */
  requiredQuestionTypes: Question_QuestionEnum[] = [];

  /**
   * @generated from field: repeated geneo.content.db.DifficultyLevelEnum required_difficulty_types = 5;
   */
  requiredDifficultyTypes: DifficultyLevelEnum[] = [];

  /**
   * @generated from field: optional geneo.lms.hw.teacher.apis.RequiredQuestionCountInfoForDifficultyLevel required_difficulty_levels_count_info = 6;
   */
  requiredDifficultyLevelsCountInfo?: RequiredQuestionCountInfoForDifficultyLevel;

  /**
   * @generated from field: repeated string qIdsToBeIgnored = 7;
   */
  qIdsToBeIgnored: string[] = [];

  /**
   * @generated from field: repeated geneo.content.db.BloomLevelEnum bloom_levels = 8;
   */
  bloomLevels: BloomLevelEnum[] = [];

  /**
   * @generated from field: optional int32 no_of_questions = 9;
   */
  noOfQuestions?: number;

  /**
   * @generated from field: optional int32 approximate_time = 10;
   */
  approximateTime?: number;

  /**
   * @generated from field: optional geneo.content.db.DifficultyLevelEnum avg_difficulty_level = 11;
   */
  avgDifficultyLevel?: DifficultyLevelEnum;

  /**
   * @generated from field: geneo.lms.assessment.teacher.apis.AssessmentCreationEnum assessment_creation_type = 12;
   */
  assessmentCreationType = AssessmentCreationEnum.ASSESSMENT_CREATION_UNDEFINED;

  /**
   * @generated from field: optional geneo.lms.db.ModeOfConductionEnum mode_of_conduction = 13;
   */
  modeOfConduction?: ModeOfConductionEnum;

  /**
   * @generated from field: optional int32 page_number = 14;
   */
  pageNumber?: number;

  /**
   * @generated from field: repeated geneo.lms.db.QuestionSection question_section_info = 15;
   */
  questionSectionInfo: QuestionSection[] = [];

  /**
   * @generated from field: repeated string ai_question_prompts = 16;
   */
  aiQuestionPrompts: string[] = [];

  /**
   * @generated from field: bool allow_ai_questions = 17;
   */
  allowAiQuestions = false;

  /**
   * @generated from field: optional string current_question_id = 18;
   */
  currentQuestionId?: string;

  /**
   * @generated from field: optional bool is_ai_assessment = 19;
   */
  isAiAssessment?: boolean;

  /**
   * @generated from field: optional int64 created_by_user_id = 20;
   */
  createdByUserId?: bigint;

  /**
   * @generated from field: optional int32 school_id = 21;
   */
  schoolId?: number;

  constructor(data?: PartialMessage<GetModuleFilteredQuestionsV5Request>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.GetModuleFilteredQuestionsV5Request";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "teacher_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "subject_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "module_ids", kind: "scalar", T: 5 /* ScalarType.INT32 */, repeated: true },
    { no: 4, name: "required_question_types", kind: "enum", T: proto3.getEnumType(Question_QuestionEnum), repeated: true },
    { no: 5, name: "required_difficulty_types", kind: "enum", T: proto3.getEnumType(DifficultyLevelEnum), repeated: true },
    { no: 6, name: "required_difficulty_levels_count_info", kind: "message", T: RequiredQuestionCountInfoForDifficultyLevel, opt: true },
    { no: 7, name: "qIdsToBeIgnored", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 8, name: "bloom_levels", kind: "enum", T: proto3.getEnumType(BloomLevelEnum), repeated: true },
    { no: 9, name: "no_of_questions", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 10, name: "approximate_time", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 11, name: "avg_difficulty_level", kind: "enum", T: proto3.getEnumType(DifficultyLevelEnum), opt: true },
    { no: 12, name: "assessment_creation_type", kind: "enum", T: proto3.getEnumType(AssessmentCreationEnum) },
    { no: 13, name: "mode_of_conduction", kind: "enum", T: proto3.getEnumType(ModeOfConductionEnum), opt: true },
    { no: 14, name: "page_number", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 15, name: "question_section_info", kind: "message", T: QuestionSection, repeated: true },
    { no: 16, name: "ai_question_prompts", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 17, name: "allow_ai_questions", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 18, name: "current_question_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 19, name: "is_ai_assessment", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 20, name: "created_by_user_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 21, name: "school_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetModuleFilteredQuestionsV5Request {
    return new GetModuleFilteredQuestionsV5Request().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetModuleFilteredQuestionsV5Request {
    return new GetModuleFilteredQuestionsV5Request().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetModuleFilteredQuestionsV5Request {
    return new GetModuleFilteredQuestionsV5Request().fromJsonString(jsonString, options);
  }

  static equals(a: GetModuleFilteredQuestionsV5Request | PlainMessage<GetModuleFilteredQuestionsV5Request> | undefined, b: GetModuleFilteredQuestionsV5Request | PlainMessage<GetModuleFilteredQuestionsV5Request> | undefined): boolean {
    return proto3.util.equals(GetModuleFilteredQuestionsV5Request, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.SubSectionType
 */
export class SubSectionType extends Message<SubSectionType> {
  /**
   * @generated from field: string sub_section_name = 1;
   */
  subSectionName = "";

  /**
   * @generated from field: int32 section_number = 2;
   */
  sectionNumber = 0;

  /**
   * @generated from field: repeated geneo.lms.assessment.teacher.apis.SubSectionQuestionType sub_section_questions = 3;
   */
  subSectionQuestions: SubSectionQuestionType[] = [];

  constructor(data?: PartialMessage<SubSectionType>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.SubSectionType";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "sub_section_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "section_number", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "sub_section_questions", kind: "message", T: SubSectionQuestionType, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SubSectionType {
    return new SubSectionType().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SubSectionType {
    return new SubSectionType().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SubSectionType {
    return new SubSectionType().fromJsonString(jsonString, options);
  }

  static equals(a: SubSectionType | PlainMessage<SubSectionType> | undefined, b: SubSectionType | PlainMessage<SubSectionType> | undefined): boolean {
    return proto3.util.equals(SubSectionType, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.SubSectionQuestionType
 */
export class SubSectionQuestionType extends Message<SubSectionQuestionType> {
  /**
   * @generated from field: geneo.content.db.Question.QuestionEnum question_type = 2;
   */
  questionType = Question_QuestionEnum.QUESTION_TYPE_UNDEFINED;

  /**
   * @generated from field: int32 no_of_question = 3;
   */
  noOfQuestion = 0;

  /**
   * @generated from field: optional float marks = 4;
   */
  marks?: number;

  /**
   * @generated from field: bool is_alternate_enable = 5;
   */
  isAlternateEnable = false;

  /**
   * @generated from field: optional bool is_grouped = 6;
   */
  isGrouped?: boolean;

  /**
   * @generated from field: optional string group_question_heading = 7;
   */
  groupQuestionHeading?: string;

  /**
   * @generated from field: optional int32 group_question_attempted_any = 8;
   */
  groupQuestionAttemptedAny?: number;

  constructor(data?: PartialMessage<SubSectionQuestionType>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.SubSectionQuestionType";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 2, name: "question_type", kind: "enum", T: proto3.getEnumType(Question_QuestionEnum) },
    { no: 3, name: "no_of_question", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "marks", kind: "scalar", T: 2 /* ScalarType.FLOAT */, opt: true },
    { no: 5, name: "is_alternate_enable", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "is_grouped", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 7, name: "group_question_heading", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 8, name: "group_question_attempted_any", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SubSectionQuestionType {
    return new SubSectionQuestionType().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SubSectionQuestionType {
    return new SubSectionQuestionType().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SubSectionQuestionType {
    return new SubSectionQuestionType().fromJsonString(jsonString, options);
  }

  static equals(a: SubSectionQuestionType | PlainMessage<SubSectionQuestionType> | undefined, b: SubSectionQuestionType | PlainMessage<SubSectionQuestionType> | undefined): boolean {
    return proto3.util.equals(SubSectionQuestionType, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.GetModuleFilteredQuestionsV6Request
 */
export class GetModuleFilteredQuestionsV6Request extends Message<GetModuleFilteredQuestionsV6Request> {
  /**
   * @generated from field: int64 teacher_id = 1;
   */
  teacherId = protoInt64.zero;

  /**
   * @generated from field: int32 subject_id = 2;
   */
  subjectId = 0;

  /**
   * @generated from field: repeated int32 module_ids = 3;
   */
  moduleIds: number[] = [];

  /**
   * @generated from field: repeated geneo.content.db.Question.QuestionEnum required_question_types = 4;
   */
  requiredQuestionTypes: Question_QuestionEnum[] = [];

  /**
   * @generated from field: repeated geneo.content.db.DifficultyLevelEnum required_difficulty_types = 5;
   */
  requiredDifficultyTypes: DifficultyLevelEnum[] = [];

  /**
   * @generated from field: optional geneo.lms.hw.teacher.apis.RequiredQuestionCountInfoForDifficultyLevel required_difficulty_levels_count_info = 6;
   */
  requiredDifficultyLevelsCountInfo?: RequiredQuestionCountInfoForDifficultyLevel;

  /**
   * @generated from field: repeated string qIdsToBeIgnored = 7;
   */
  qIdsToBeIgnored: string[] = [];

  /**
   * @generated from field: repeated geneo.content.db.BloomLevelEnum bloom_levels = 8;
   */
  bloomLevels: BloomLevelEnum[] = [];

  /**
   * @generated from field: optional int32 no_of_questions = 9;
   */
  noOfQuestions?: number;

  /**
   * @generated from field: optional int32 approximate_time = 10;
   */
  approximateTime?: number;

  /**
   * @generated from field: optional geneo.content.db.DifficultyLevelEnum avg_difficulty_level = 11;
   */
  avgDifficultyLevel?: DifficultyLevelEnum;

  /**
   * @generated from field: geneo.lms.assessment.teacher.apis.AssessmentCreationEnum assessment_creation_type = 12;
   */
  assessmentCreationType = AssessmentCreationEnum.ASSESSMENT_CREATION_UNDEFINED;

  /**
   * @generated from field: optional geneo.lms.db.ModeOfConductionEnum mode_of_conduction = 13;
   */
  modeOfConduction?: ModeOfConductionEnum;

  /**
   * @generated from field: optional int32 page_number = 14;
   */
  pageNumber?: number;

  /**
   * @generated from field: repeated geneo.lms.db.QuestionSection question_section_info = 15;
   */
  questionSectionInfo: QuestionSection[] = [];

  /**
   * @generated from field: repeated string ai_question_prompts = 16;
   */
  aiQuestionPrompts: string[] = [];

  /**
   * @generated from field: bool allow_ai_questions = 17;
   */
  allowAiQuestions = false;

  /**
   * @generated from field: optional string current_question_id = 18;
   */
  currentQuestionId?: string;

  /**
   * @generated from field: optional bool is_ai_assessment = 19;
   */
  isAiAssessment?: boolean;

  /**
   * @generated from field: optional int64 created_by_user_id = 20;
   */
  createdByUserId?: bigint;

  /**
   * @generated from field: optional int32 school_id = 21;
   */
  schoolId?: number;

  /**
   * @generated from field: repeated geneo.lms.assessment.teacher.apis.SubSectionType sub_section_request = 22;
   */
  subSectionRequest: SubSectionType[] = [];

  /**
   * @generated from field: optional int32 subject_section_no = 23;
   */
  subjectSectionNo?: number;

  /**
   * @generated from field: optional int64 section_id = 24;
   */
  sectionId?: bigint;

  /**
   * true -> only textbook questions, false -> exclude textbook questions, unset -> all questions
   *
   * @generated from field: optional bool textbook_questions = 25;
   */
  textbookQuestions?: boolean;

  constructor(data?: PartialMessage<GetModuleFilteredQuestionsV6Request>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.GetModuleFilteredQuestionsV6Request";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "teacher_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "subject_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "module_ids", kind: "scalar", T: 5 /* ScalarType.INT32 */, repeated: true },
    { no: 4, name: "required_question_types", kind: "enum", T: proto3.getEnumType(Question_QuestionEnum), repeated: true },
    { no: 5, name: "required_difficulty_types", kind: "enum", T: proto3.getEnumType(DifficultyLevelEnum), repeated: true },
    { no: 6, name: "required_difficulty_levels_count_info", kind: "message", T: RequiredQuestionCountInfoForDifficultyLevel, opt: true },
    { no: 7, name: "qIdsToBeIgnored", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 8, name: "bloom_levels", kind: "enum", T: proto3.getEnumType(BloomLevelEnum), repeated: true },
    { no: 9, name: "no_of_questions", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 10, name: "approximate_time", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 11, name: "avg_difficulty_level", kind: "enum", T: proto3.getEnumType(DifficultyLevelEnum), opt: true },
    { no: 12, name: "assessment_creation_type", kind: "enum", T: proto3.getEnumType(AssessmentCreationEnum) },
    { no: 13, name: "mode_of_conduction", kind: "enum", T: proto3.getEnumType(ModeOfConductionEnum), opt: true },
    { no: 14, name: "page_number", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 15, name: "question_section_info", kind: "message", T: QuestionSection, repeated: true },
    { no: 16, name: "ai_question_prompts", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 17, name: "allow_ai_questions", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 18, name: "current_question_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 19, name: "is_ai_assessment", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 20, name: "created_by_user_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 21, name: "school_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 22, name: "sub_section_request", kind: "message", T: SubSectionType, repeated: true },
    { no: 23, name: "subject_section_no", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 24, name: "section_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 25, name: "textbook_questions", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetModuleFilteredQuestionsV6Request {
    return new GetModuleFilteredQuestionsV6Request().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetModuleFilteredQuestionsV6Request {
    return new GetModuleFilteredQuestionsV6Request().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetModuleFilteredQuestionsV6Request {
    return new GetModuleFilteredQuestionsV6Request().fromJsonString(jsonString, options);
  }

  static equals(a: GetModuleFilteredQuestionsV6Request | PlainMessage<GetModuleFilteredQuestionsV6Request> | undefined, b: GetModuleFilteredQuestionsV6Request | PlainMessage<GetModuleFilteredQuestionsV6Request> | undefined): boolean {
    return proto3.util.equals(GetModuleFilteredQuestionsV6Request, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.CheckValidPromptRequest
 */
export class CheckValidPromptRequest extends Message<CheckValidPromptRequest> {
  /**
   * Core identification fields
   *
   * @generated from field: string subject = 1;
   */
  subject = "";

  /**
   * @generated from field: repeated int32 module_ids = 2;
   */
  moduleIds: number[] = [];

  /**
   * @generated from field: repeated geneo.content.db.BloomLevelEnum bloom_levels = 3;
   */
  bloomLevels: BloomLevelEnum[] = [];

  /**
   * @generated from field: optional geneo.content.db.DifficultyLevelEnum avg_difficulty_level = 4;
   */
  avgDifficultyLevel?: DifficultyLevelEnum;

  /**
   * @generated from field: string custom_prompt = 5;
   */
  customPrompt = "";

  /**
   * @generated from field: int64 teacher_id = 6;
   */
  teacherId = protoInt64.zero;

  /**
   * @generated from field: geneo.lms.assessment.teacher.apis.AssessmentCreationEnum assessment_creation_type = 7;
   */
  assessmentCreationType = AssessmentCreationEnum.ASSESSMENT_CREATION_UNDEFINED;

  /**
   * @generated from field: repeated geneo.lms.db.QuestionSection question_section_info = 8;
   */
  questionSectionInfo: QuestionSection[] = [];

  constructor(data?: PartialMessage<CheckValidPromptRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.CheckValidPromptRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "subject", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "module_ids", kind: "scalar", T: 5 /* ScalarType.INT32 */, repeated: true },
    { no: 3, name: "bloom_levels", kind: "enum", T: proto3.getEnumType(BloomLevelEnum), repeated: true },
    { no: 4, name: "avg_difficulty_level", kind: "enum", T: proto3.getEnumType(DifficultyLevelEnum), opt: true },
    { no: 5, name: "custom_prompt", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "teacher_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "assessment_creation_type", kind: "enum", T: proto3.getEnumType(AssessmentCreationEnum) },
    { no: 8, name: "question_section_info", kind: "message", T: QuestionSection, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CheckValidPromptRequest {
    return new CheckValidPromptRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CheckValidPromptRequest {
    return new CheckValidPromptRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CheckValidPromptRequest {
    return new CheckValidPromptRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CheckValidPromptRequest | PlainMessage<CheckValidPromptRequest> | undefined, b: CheckValidPromptRequest | PlainMessage<CheckValidPromptRequest> | undefined): boolean {
    return proto3.util.equals(CheckValidPromptRequest, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.CheckValidPromptResponse
 */
export class CheckValidPromptResponse extends Message<CheckValidPromptResponse> {
  /**
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * @generated from field: bool is_validated = 3;
   */
  isValidated = false;

  /**
   * @generated from field: string message = 4;
   */
  message = "";

  constructor(data?: PartialMessage<CheckValidPromptResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.CheckValidPromptResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "is_validated", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CheckValidPromptResponse {
    return new CheckValidPromptResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CheckValidPromptResponse {
    return new CheckValidPromptResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CheckValidPromptResponse {
    return new CheckValidPromptResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CheckValidPromptResponse | PlainMessage<CheckValidPromptResponse> | undefined, b: CheckValidPromptResponse | PlainMessage<CheckValidPromptResponse> | undefined): boolean {
    return proto3.util.equals(CheckValidPromptResponse, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.SubmitQuestionFeedbackRequest
 */
export class SubmitQuestionFeedbackRequest extends Message<SubmitQuestionFeedbackRequest> {
  /**
   * The unique identifier for the question being flagged
   *
   * @generated from field: string question_id = 1;
   */
  questionId = "";

  /**
   * Corresponds to "Type Your Feedback..."
   *
   * @generated from field: string text_feedback = 2;
   */
  textFeedback = "";

  /**
   * A list of one or more categories selected from the checkboxes.
   *
   * @generated from field: repeated string categories = 3;
   */
  categories: string[] = [];

  /**
   * @generated from field: string teacher_id = 4;
   */
  teacherId = "";

  constructor(data?: PartialMessage<SubmitQuestionFeedbackRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.SubmitQuestionFeedbackRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "question_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "text_feedback", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "categories", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "teacher_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SubmitQuestionFeedbackRequest {
    return new SubmitQuestionFeedbackRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SubmitQuestionFeedbackRequest {
    return new SubmitQuestionFeedbackRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SubmitQuestionFeedbackRequest {
    return new SubmitQuestionFeedbackRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SubmitQuestionFeedbackRequest | PlainMessage<SubmitQuestionFeedbackRequest> | undefined, b: SubmitQuestionFeedbackRequest | PlainMessage<SubmitQuestionFeedbackRequest> | undefined): boolean {
    return proto3.util.equals(SubmitQuestionFeedbackRequest, a, b);
  }
}

/**
 * The response message after feedback is successfully submitted.
 *
 * @generated from message geneo.lms.assessment.teacher.apis.SubmitQuestionFeedbackResponse
 */
export class SubmitQuestionFeedbackResponse extends Message<SubmitQuestionFeedbackResponse> {
  /**
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * e.g., "Feedback submitted successfully"
   *
   * @generated from field: string message = 3;
   */
  message = "";

  constructor(data?: PartialMessage<SubmitQuestionFeedbackResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.SubmitQuestionFeedbackResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SubmitQuestionFeedbackResponse {
    return new SubmitQuestionFeedbackResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SubmitQuestionFeedbackResponse {
    return new SubmitQuestionFeedbackResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SubmitQuestionFeedbackResponse {
    return new SubmitQuestionFeedbackResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SubmitQuestionFeedbackResponse | PlainMessage<SubmitQuestionFeedbackResponse> | undefined, b: SubmitQuestionFeedbackResponse | PlainMessage<SubmitQuestionFeedbackResponse> | undefined): boolean {
    return proto3.util.equals(SubmitQuestionFeedbackResponse, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.ModuleFilteredQuestionsV3
 */
export class ModuleFilteredQuestionsV3 extends Message<ModuleFilteredQuestionsV3> {
  /**
   * @generated from field: repeated geneo.content.db.Question questions = 1;
   */
  questions: Question[] = [];

  /**
   * @generated from field: geneo.lms.db.TaskMetaInfo task_meta_info = 2;
   */
  taskMetaInfo?: TaskMetaInfo;

  /**
   * @generated from field: geneo.content.db.DifficultyLevelEnum avg_difficulty_level = 3;
   */
  avgDifficultyLevel = DifficultyLevelEnum.DIFFICULTY_LEVEL_UNDEFINED;

  /**
   * @generated from field: int32 approximate_time = 4;
   */
  approximateTime = 0;

  /**
   * @generated from field: optional geneo.lms.db.ModeOfConductionEnum mode_of_conduction = 5;
   */
  modeOfConduction?: ModeOfConductionEnum;

  /**
   * @generated from field: geneo.lms.assessment.teacher.apis.PaginationInfo pagination = 6;
   */
  pagination?: PaginationInfo;

  /**
   * @generated from field: repeated geneo.lms.db.QuestionSectionMeta question_section_meta_info = 7;
   */
  questionSectionMetaInfo: QuestionSectionMeta[] = [];

  /**
   * @generated from field: repeated geneo.lms.db.QuestionModuleMap question_module_map = 8;
   */
  questionModuleMap: QuestionModuleMap[] = [];

  /**
   * @generated from field: repeated geneo.lms.db.MultiSubjectSection multi_subject_section_meta_info = 9;
   */
  multiSubjectSectionMetaInfo: MultiSubjectSection[] = [];

  constructor(data?: PartialMessage<ModuleFilteredQuestionsV3>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.ModuleFilteredQuestionsV3";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "questions", kind: "message", T: Question, repeated: true },
    { no: 2, name: "task_meta_info", kind: "message", T: TaskMetaInfo },
    { no: 3, name: "avg_difficulty_level", kind: "enum", T: proto3.getEnumType(DifficultyLevelEnum) },
    { no: 4, name: "approximate_time", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "mode_of_conduction", kind: "enum", T: proto3.getEnumType(ModeOfConductionEnum), opt: true },
    { no: 6, name: "pagination", kind: "message", T: PaginationInfo },
    { no: 7, name: "question_section_meta_info", kind: "message", T: QuestionSectionMeta, repeated: true },
    { no: 8, name: "question_module_map", kind: "message", T: QuestionModuleMap, repeated: true },
    { no: 9, name: "multi_subject_section_meta_info", kind: "message", T: MultiSubjectSection, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ModuleFilteredQuestionsV3 {
    return new ModuleFilteredQuestionsV3().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ModuleFilteredQuestionsV3 {
    return new ModuleFilteredQuestionsV3().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ModuleFilteredQuestionsV3 {
    return new ModuleFilteredQuestionsV3().fromJsonString(jsonString, options);
  }

  static equals(a: ModuleFilteredQuestionsV3 | PlainMessage<ModuleFilteredQuestionsV3> | undefined, b: ModuleFilteredQuestionsV3 | PlainMessage<ModuleFilteredQuestionsV3> | undefined): boolean {
    return proto3.util.equals(ModuleFilteredQuestionsV3, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.GetModuleFilteredQuestionsV6Response
 */
export class GetModuleFilteredQuestionsV6Response extends Message<GetModuleFilteredQuestionsV6Response> {
  /**
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * @generated from field: geneo.lms.assessment.teacher.apis.ModuleFilteredQuestionsV3 data = 4;
   */
  data?: ModuleFilteredQuestionsV3;

  constructor(data?: PartialMessage<GetModuleFilteredQuestionsV6Response>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.GetModuleFilteredQuestionsV6Response";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "data", kind: "message", T: ModuleFilteredQuestionsV3 },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetModuleFilteredQuestionsV6Response {
    return new GetModuleFilteredQuestionsV6Response().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetModuleFilteredQuestionsV6Response {
    return new GetModuleFilteredQuestionsV6Response().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetModuleFilteredQuestionsV6Response {
    return new GetModuleFilteredQuestionsV6Response().fromJsonString(jsonString, options);
  }

  static equals(a: GetModuleFilteredQuestionsV6Response | PlainMessage<GetModuleFilteredQuestionsV6Response> | undefined, b: GetModuleFilteredQuestionsV6Response | PlainMessage<GetModuleFilteredQuestionsV6Response> | undefined): boolean {
    return proto3.util.equals(GetModuleFilteredQuestionsV6Response, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.GetModuleFilteredQuestionsV7Request
 */
export class GetModuleFilteredQuestionsV7Request extends Message<GetModuleFilteredQuestionsV7Request> {
  /**
   * @generated from field: int64 teacher_id = 1;
   */
  teacherId = protoInt64.zero;

  /**
   * @generated from field: int32 subject_id = 2;
   */
  subjectId = 0;

  /**
   * @generated from field: repeated int32 module_ids = 3;
   */
  moduleIds: number[] = [];

  /**
   * @generated from field: repeated geneo.content.db.Question.QuestionEnum required_question_types = 4;
   */
  requiredQuestionTypes: Question_QuestionEnum[] = [];

  /**
   * @generated from field: repeated geneo.content.db.DifficultyLevelEnum required_difficulty_types = 5;
   */
  requiredDifficultyTypes: DifficultyLevelEnum[] = [];

  /**
   * @generated from field: optional geneo.lms.hw.teacher.apis.RequiredQuestionCountInfoForDifficultyLevel required_difficulty_levels_count_info = 6;
   */
  requiredDifficultyLevelsCountInfo?: RequiredQuestionCountInfoForDifficultyLevel;

  /**
   * @generated from field: repeated string qIdsToBeIgnored = 7;
   */
  qIdsToBeIgnored: string[] = [];

  /**
   * @generated from field: repeated geneo.content.db.BloomLevelEnum bloom_levels = 8;
   */
  bloomLevels: BloomLevelEnum[] = [];

  /**
   * @generated from field: optional int32 no_of_questions = 9;
   */
  noOfQuestions?: number;

  /**
   * @generated from field: optional int32 approximate_time = 10;
   */
  approximateTime?: number;

  /**
   * @generated from field: optional geneo.content.db.DifficultyLevelEnum avg_difficulty_level = 11;
   */
  avgDifficultyLevel?: DifficultyLevelEnum;

  /**
   * @generated from field: geneo.lms.assessment.teacher.apis.AssessmentCreationEnum assessment_creation_type = 12;
   */
  assessmentCreationType = AssessmentCreationEnum.ASSESSMENT_CREATION_UNDEFINED;

  /**
   * @generated from field: optional geneo.lms.db.ModeOfConductionEnum mode_of_conduction = 13;
   */
  modeOfConduction?: ModeOfConductionEnum;

  /**
   * @generated from field: optional int32 page_number = 14;
   */
  pageNumber?: number;

  /**
   * @generated from field: repeated geneo.lms.db.QuestionSection question_section_info = 15;
   */
  questionSectionInfo: QuestionSection[] = [];

  /**
   * @generated from field: repeated string ai_question_prompts = 16;
   */
  aiQuestionPrompts: string[] = [];

  /**
   * @generated from field: bool allow_ai_questions = 17;
   */
  allowAiQuestions = false;

  /**
   * @generated from field: optional string current_question_id = 18;
   */
  currentQuestionId?: string;

  /**
   * @generated from field: optional bool is_ai_assessment = 19;
   */
  isAiAssessment?: boolean;

  /**
   * @generated from field: optional int64 created_by_user_id = 20;
   */
  createdByUserId?: bigint;

  /**
   * @generated from field: optional int32 school_id = 21;
   */
  schoolId?: number;

  /**
   * @generated from field: repeated geneo.lms.assessment.teacher.apis.SubSectionType sub_section_request = 22;
   */
  subSectionRequest: SubSectionType[] = [];

  /**
   * @generated from field: optional int32 subject_section_no = 23;
   */
  subjectSectionNo?: number;

  /**
   * @generated from field: optional int64 section_id = 24;
   */
  sectionId?: bigint;

  /**
   * @generated from field: optional string search_text = 25;
   */
  searchText?: string;

  /**
   * @generated from field: optional bool filter_by_previously_used = 27;
   */
  filterByPreviouslyUsed?: boolean;

  /**
   * true -> only textbook questions, false -> exclude textbook questions, unset -> all questions
   *
   * @generated from field: optional bool textbook_questions = 28;
   */
  textbookQuestions?: boolean;

  constructor(data?: PartialMessage<GetModuleFilteredQuestionsV7Request>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.GetModuleFilteredQuestionsV7Request";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "teacher_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "subject_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "module_ids", kind: "scalar", T: 5 /* ScalarType.INT32 */, repeated: true },
    { no: 4, name: "required_question_types", kind: "enum", T: proto3.getEnumType(Question_QuestionEnum), repeated: true },
    { no: 5, name: "required_difficulty_types", kind: "enum", T: proto3.getEnumType(DifficultyLevelEnum), repeated: true },
    { no: 6, name: "required_difficulty_levels_count_info", kind: "message", T: RequiredQuestionCountInfoForDifficultyLevel, opt: true },
    { no: 7, name: "qIdsToBeIgnored", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 8, name: "bloom_levels", kind: "enum", T: proto3.getEnumType(BloomLevelEnum), repeated: true },
    { no: 9, name: "no_of_questions", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 10, name: "approximate_time", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 11, name: "avg_difficulty_level", kind: "enum", T: proto3.getEnumType(DifficultyLevelEnum), opt: true },
    { no: 12, name: "assessment_creation_type", kind: "enum", T: proto3.getEnumType(AssessmentCreationEnum) },
    { no: 13, name: "mode_of_conduction", kind: "enum", T: proto3.getEnumType(ModeOfConductionEnum), opt: true },
    { no: 14, name: "page_number", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 15, name: "question_section_info", kind: "message", T: QuestionSection, repeated: true },
    { no: 16, name: "ai_question_prompts", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 17, name: "allow_ai_questions", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 18, name: "current_question_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 19, name: "is_ai_assessment", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 20, name: "created_by_user_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 21, name: "school_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 22, name: "sub_section_request", kind: "message", T: SubSectionType, repeated: true },
    { no: 23, name: "subject_section_no", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 24, name: "section_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 25, name: "search_text", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 27, name: "filter_by_previously_used", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 28, name: "textbook_questions", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetModuleFilteredQuestionsV7Request {
    return new GetModuleFilteredQuestionsV7Request().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetModuleFilteredQuestionsV7Request {
    return new GetModuleFilteredQuestionsV7Request().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetModuleFilteredQuestionsV7Request {
    return new GetModuleFilteredQuestionsV7Request().fromJsonString(jsonString, options);
  }

  static equals(a: GetModuleFilteredQuestionsV7Request | PlainMessage<GetModuleFilteredQuestionsV7Request> | undefined, b: GetModuleFilteredQuestionsV7Request | PlainMessage<GetModuleFilteredQuestionsV7Request> | undefined): boolean {
    return proto3.util.equals(GetModuleFilteredQuestionsV7Request, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.GetModuleFilteredQuestionsV7Response
 */
export class GetModuleFilteredQuestionsV7Response extends Message<GetModuleFilteredQuestionsV7Response> {
  /**
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * @generated from field: geneo.lms.assessment.teacher.apis.ModuleFilteredQuestionsV3 data = 4;
   */
  data?: ModuleFilteredQuestionsV3;

  constructor(data?: PartialMessage<GetModuleFilteredQuestionsV7Response>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.GetModuleFilteredQuestionsV7Response";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "data", kind: "message", T: ModuleFilteredQuestionsV3 },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetModuleFilteredQuestionsV7Response {
    return new GetModuleFilteredQuestionsV7Response().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetModuleFilteredQuestionsV7Response {
    return new GetModuleFilteredQuestionsV7Response().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetModuleFilteredQuestionsV7Response {
    return new GetModuleFilteredQuestionsV7Response().fromJsonString(jsonString, options);
  }

  static equals(a: GetModuleFilteredQuestionsV7Response | PlainMessage<GetModuleFilteredQuestionsV7Response> | undefined, b: GetModuleFilteredQuestionsV7Response | PlainMessage<GetModuleFilteredQuestionsV7Response> | undefined): boolean {
    return proto3.util.equals(GetModuleFilteredQuestionsV7Response, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.MultiSubjectFormateInfo
 */
export class MultiSubjectFormateInfo extends Message<MultiSubjectFormateInfo> {
  /**
   * @generated from field: int32 subject_id = 1;
   */
  subjectId = 0;

  /**
   * @generated from field: geneo.common.db.Subject.SubjectEnum subject = 2;
   */
  subject = Subject_SubjectEnum.UNDEFINED;

  /**
   * @generated from field: int32 preferred_marks = 3;
   */
  preferredMarks = 0;

  /**
   * @generated from field: int32 section_no = 4;
   */
  sectionNo = 0;

  /**
   * @generated from field: optional int32 template_id = 5;
   */
  templateId?: number;

  /**
   * @generated from field: optional geneo.lms.db.MarkingSchemeEnum marking_scheme_type = 6;
   */
  markingSchemeType?: MarkingSchemeEnum;

  constructor(data?: PartialMessage<MultiSubjectFormateInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.MultiSubjectFormateInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "subject_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "subject", kind: "enum", T: proto3.getEnumType(Subject_SubjectEnum) },
    { no: 3, name: "preferred_marks", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "section_no", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "template_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 6, name: "marking_scheme_type", kind: "enum", T: proto3.getEnumType(MarkingSchemeEnum), opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MultiSubjectFormateInfo {
    return new MultiSubjectFormateInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MultiSubjectFormateInfo {
    return new MultiSubjectFormateInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MultiSubjectFormateInfo {
    return new MultiSubjectFormateInfo().fromJsonString(jsonString, options);
  }

  static equals(a: MultiSubjectFormateInfo | PlainMessage<MultiSubjectFormateInfo> | undefined, b: MultiSubjectFormateInfo | PlainMessage<MultiSubjectFormateInfo> | undefined): boolean {
    return proto3.util.equals(MultiSubjectFormateInfo, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.GetProjectResourcesByChapterRequest
 */
export class GetProjectResourcesByChapterRequest extends Message<GetProjectResourcesByChapterRequest> {
  /**
   * course.courseId of the subject.
   *
   * @generated from field: int32 subject_id = 1;
   */
  subjectId = 0;

  /**
   * @generated from field: int64 school_class_section_id = 2;
   */
  schoolClassSectionId = protoInt64.zero;

  constructor(data?: PartialMessage<GetProjectResourcesByChapterRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.GetProjectResourcesByChapterRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "subject_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "school_class_section_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetProjectResourcesByChapterRequest {
    return new GetProjectResourcesByChapterRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetProjectResourcesByChapterRequest {
    return new GetProjectResourcesByChapterRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetProjectResourcesByChapterRequest {
    return new GetProjectResourcesByChapterRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetProjectResourcesByChapterRequest | PlainMessage<GetProjectResourcesByChapterRequest> | undefined, b: GetProjectResourcesByChapterRequest | PlainMessage<GetProjectResourcesByChapterRequest> | undefined): boolean {
    return proto3.util.equals(GetProjectResourcesByChapterRequest, a, b);
  }
}

/**
 * One selectable resource inside a lesson plan.
 *
 * @generated from message geneo.lms.assessment.teacher.apis.ProjectSelectableResource
 */
export class ProjectSelectableResource extends Message<ProjectSelectableResource> {
  /**
   * @generated from field: string resource_id = 1;
   */
  resourceId = "";

  /**
   * @generated from field: string title = 2;
   */
  title = "";

  /**
   * @generated from field: optional string poster_image_url = 3;
   */
  posterImageUrl?: string;

  /**
   * @generated from field: float estimated_time_in_min = 4;
   */
  estimatedTimeInMin = 0;

  /**
   * @generated from field: geneo.content.db.Resource.ResourceEnum resource_type = 5;
   */
  resourceType = Resource_ResourceEnum.RESOURCE_TYPE_UNDEFINED;

  /**
   * @generated from field: geneo.content.db.ResourceCategoryEnum resource_category_type = 6;
   */
  resourceCategoryType = ResourceCategoryEnum.RESOURCE_CATEGORY_UNDEFINED;

  constructor(data?: PartialMessage<ProjectSelectableResource>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.ProjectSelectableResource";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "resource_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "poster_image_url", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "estimated_time_in_min", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 5, name: "resource_type", kind: "enum", T: proto3.getEnumType(Resource_ResourceEnum) },
    { no: 6, name: "resource_category_type", kind: "enum", T: proto3.getEnumType(ResourceCategoryEnum) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ProjectSelectableResource {
    return new ProjectSelectableResource().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ProjectSelectableResource {
    return new ProjectSelectableResource().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ProjectSelectableResource {
    return new ProjectSelectableResource().fromJsonString(jsonString, options);
  }

  static equals(a: ProjectSelectableResource | PlainMessage<ProjectSelectableResource> | undefined, b: ProjectSelectableResource | PlainMessage<ProjectSelectableResource> | undefined): boolean {
    return proto3.util.equals(ProjectSelectableResource, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.ProjectSelectableTopic
 */
export class ProjectSelectableTopic extends Message<ProjectSelectableTopic> {
  /**
   * @generated from field: int32 topic_id = 1;
   */
  topicId = 0;

  /**
   * @generated from field: optional string topic_name = 2;
   */
  topicName?: string;

  /**
   * @generated from field: optional string poster_image_url = 3;
   */
  posterImageUrl?: string;

  /**
   * module.rank
   *
   * @generated from field: int32 topic_no = 4;
   */
  topicNo = 0;

  /**
   * First-created lesson plan of the topic visible to this teacher.
   *
   * @generated from field: string lesson_id = 5;
   */
  lessonId = "";

  /**
   * @generated from field: repeated geneo.lms.assessment.teacher.apis.ProjectSelectableResource resources = 6;
   */
  resources: ProjectSelectableResource[] = [];

  constructor(data?: PartialMessage<ProjectSelectableTopic>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.ProjectSelectableTopic";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "topic_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "topic_name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "poster_image_url", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "topic_no", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "lesson_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "resources", kind: "message", T: ProjectSelectableResource, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ProjectSelectableTopic {
    return new ProjectSelectableTopic().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ProjectSelectableTopic {
    return new ProjectSelectableTopic().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ProjectSelectableTopic {
    return new ProjectSelectableTopic().fromJsonString(jsonString, options);
  }

  static equals(a: ProjectSelectableTopic | PlainMessage<ProjectSelectableTopic> | undefined, b: ProjectSelectableTopic | PlainMessage<ProjectSelectableTopic> | undefined): boolean {
    return proto3.util.equals(ProjectSelectableTopic, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.ProjectSelectableChapter
 */
export class ProjectSelectableChapter extends Message<ProjectSelectableChapter> {
  /**
   * @generated from field: int32 chapter_id = 1;
   */
  chapterId = 0;

  /**
   * @generated from field: optional string chapter_name = 2;
   */
  chapterName?: string;

  /**
   * Position of the chapter within the book (module.rank).
   *
   * @generated from field: int32 chapter_no = 3;
   */
  chapterNo = 0;

  /**
   * Distinct resources across the chapter's topics.
   *
   * @generated from field: int32 total_resource_count = 5;
   */
  totalResourceCount = 0;

  /**
   * The chapter's cover image (module.poster_image_url).
   *
   * @generated from field: optional string poster_image_url = 6;
   */
  posterImageUrl?: string;

  /**
   * Only topics with a lesson plan, ordered by topic_no.
   *
   * @generated from field: repeated geneo.lms.assessment.teacher.apis.ProjectSelectableTopic topics = 7;
   */
  topics: ProjectSelectableTopic[] = [];

  constructor(data?: PartialMessage<ProjectSelectableChapter>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.ProjectSelectableChapter";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "chapter_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "chapter_name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "chapter_no", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "total_resource_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "poster_image_url", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 7, name: "topics", kind: "message", T: ProjectSelectableTopic, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ProjectSelectableChapter {
    return new ProjectSelectableChapter().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ProjectSelectableChapter {
    return new ProjectSelectableChapter().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ProjectSelectableChapter {
    return new ProjectSelectableChapter().fromJsonString(jsonString, options);
  }

  static equals(a: ProjectSelectableChapter | PlainMessage<ProjectSelectableChapter> | undefined, b: ProjectSelectableChapter | PlainMessage<ProjectSelectableChapter> | undefined): boolean {
    return proto3.util.equals(ProjectSelectableChapter, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.GetProjectResourcesByChapterData
 */
export class GetProjectResourcesByChapterData extends Message<GetProjectResourcesByChapterData> {
  /**
   * @generated from field: int32 subject_id = 1;
   */
  subjectId = 0;

  /**
   * Only chapters with a lesson plan, ordered by chapter_no.
   *
   * @generated from field: repeated geneo.lms.assessment.teacher.apis.ProjectSelectableChapter chapters = 2;
   */
  chapters: ProjectSelectableChapter[] = [];

  /**
   * Distinct resources across every chapter of the subject.
   *
   * @generated from field: int32 total_resource_count = 3;
   */
  totalResourceCount = 0;

  constructor(data?: PartialMessage<GetProjectResourcesByChapterData>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.GetProjectResourcesByChapterData";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "subject_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "chapters", kind: "message", T: ProjectSelectableChapter, repeated: true },
    { no: 3, name: "total_resource_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetProjectResourcesByChapterData {
    return new GetProjectResourcesByChapterData().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetProjectResourcesByChapterData {
    return new GetProjectResourcesByChapterData().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetProjectResourcesByChapterData {
    return new GetProjectResourcesByChapterData().fromJsonString(jsonString, options);
  }

  static equals(a: GetProjectResourcesByChapterData | PlainMessage<GetProjectResourcesByChapterData> | undefined, b: GetProjectResourcesByChapterData | PlainMessage<GetProjectResourcesByChapterData> | undefined): boolean {
    return proto3.util.equals(GetProjectResourcesByChapterData, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.GetProjectResourcesByChapterResponse
 */
export class GetProjectResourcesByChapterResponse extends Message<GetProjectResourcesByChapterResponse> {
  /**
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * @generated from field: geneo.lms.assessment.teacher.apis.GetProjectResourcesByChapterData data = 4;
   */
  data?: GetProjectResourcesByChapterData;

  constructor(data?: PartialMessage<GetProjectResourcesByChapterResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.GetProjectResourcesByChapterResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "data", kind: "message", T: GetProjectResourcesByChapterData },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetProjectResourcesByChapterResponse {
    return new GetProjectResourcesByChapterResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetProjectResourcesByChapterResponse {
    return new GetProjectResourcesByChapterResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetProjectResourcesByChapterResponse {
    return new GetProjectResourcesByChapterResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetProjectResourcesByChapterResponse | PlainMessage<GetProjectResourcesByChapterResponse> | undefined, b: GetProjectResourcesByChapterResponse | PlainMessage<GetProjectResourcesByChapterResponse> | undefined): boolean {
    return proto3.util.equals(GetProjectResourcesByChapterResponse, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.SelectedResourceInfo
 */
export class SelectedResourceInfo extends Message<SelectedResourceInfo> {
  /**
   * @generated from field: string resource_id = 1;
   */
  resourceId = "";

  /**
   * @generated from field: optional string lesson_id = 2;
   */
  lessonId?: string;

  /**
   * @generated from field: optional int32 module_id = 3;
   */
  moduleId?: number;

  /**
   * @generated from field: int32 sequence = 4;
   */
  sequence = 0;

  /**
   * Extra information the teacher supplies for this resource at assignment
   * time, e.g. the worked solution for a practical. The variant must match the
   * resource's type; creation rejects a mismatch.
   *
   * Omitting it on an EDIT means "leave whatever is stored alone", not "clear
   * it" - unlike every other field of this request, which is a full replace.
   * Creation carries the stored value forward, because the read side does not
   * return it, so a client editing anything else cannot send it back.
   *
   * To REMOVE what is stored, send this set but with no variant chosen ({}).
   * That is the only way to clear it, precisely because omission cannot mean
   * clear.
   *
   * @generated from field: optional geneo.lms.db.TaskResourceInfoMetaData meta_data = 5;
   */
  metaData?: TaskResourceInfoMetaData;

  constructor(data?: PartialMessage<SelectedResourceInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.SelectedResourceInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "resource_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "lesson_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "module_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 4, name: "sequence", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "meta_data", kind: "message", T: TaskResourceInfoMetaData, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SelectedResourceInfo {
    return new SelectedResourceInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SelectedResourceInfo {
    return new SelectedResourceInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SelectedResourceInfo {
    return new SelectedResourceInfo().fromJsonString(jsonString, options);
  }

  static equals(a: SelectedResourceInfo | PlainMessage<SelectedResourceInfo> | undefined, b: SelectedResourceInfo | PlainMessage<SelectedResourceInfo> | undefined): boolean {
    return proto3.util.equals(SelectedResourceInfo, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.AssessmentCreationSubmitV6Request
 */
export class AssessmentCreationSubmitV6Request extends Message<AssessmentCreationSubmitV6Request> {
  /**
   * ID of the teacher
   *
   * @generated from field: int64 teacher_id = 1;
   */
  teacherId = protoInt64.zero;

  /**
   * ID of the course
   *
   * @generated from field: optional int32 subject_id = 2;
   */
  subjectId?: number;

  /**
   * ID of the school class section
   *
   * @generated from field: int64 section_id = 3;
   */
  sectionId = protoInt64.zero;

  /**
   * Name of the task
   *
   * @generated from field: string task_name = 4;
   */
  taskName = "";

  /**
   * @generated from field: optional int32 module_id = 5;
   */
  moduleId?: number;

  /**
   * ID of the topic
   *
   * @generated from field: optional geneo.content.db.Module.ModuleCategoryEnum category = 6;
   */
  category?: Module_ModuleCategoryEnum;

  /**
   * Information about selected tasks
   *
   * @generated from field: repeated geneo.lms.assessment.teacher.apis.TaskInfoModel selected_tasks_info = 7;
   */
  selectedTasksInfo: TaskInfoModel[] = [];

  /**
   * ID of the homework (optional)
   *
   * @generated from field: optional int64 assessment_id = 8;
   */
  assessmentId?: bigint;

  /**
   * Instructions for the homework (optional)
   *
   * @generated from field: repeated string instructions = 9;
   */
  instructions: string[] = [];

  /**
   * Status of the creation process
   *
   * @generated from field: geneo.lms.db.TaskCreationStatusEnum creation_status = 10;
   */
  creationStatus = TaskCreationStatusEnum.TASK_CREATION_STATUS_UNDEFINED;

  /**
   * @generated from field: geneo.lms.db.TaskEnum task_type = 11;
   */
  taskType = TaskEnum.TASK_UNDEFINED;

  /**
   * @generated from field: repeated geneo.lms.db.CloudUpload task_uploads = 12;
   */
  taskUploads: CloudUpload[] = [];

  /**
   * @generated from field: optional float max_marks = 13;
   */
  maxMarks?: number;

  /**
   * Only for teacher created CUSTOM hws
   *
   * @generated from field: optional geneo.lms.db.SubmissionType submission_type = 14;
   */
  submissionType?: SubmissionType;

  /**
   * @generated from field: optional int64 source_geneo_assessment_id = 15;
   */
  sourceGeneoAssessmentId?: bigint;

  /**
   * @generated from field: repeated geneo.lms.db.ChapterIdsInfo chapter_ids_info = 16;
   */
  chapterIdsInfo: ChapterIdsInfo[] = [];

  /**
   * @generated from field: optional geneo.lms.db.ModeOfConductionEnum mode_of_conduction = 17;
   */
  modeOfConduction?: ModeOfConductionEnum;

  /**
   * @generated from field: repeated geneo.lms.db.QuestionSectionMeta question_section_meta_info = 18;
   */
  questionSectionMetaInfo: QuestionSectionMeta[] = [];

  /**
   * @generated from field: optional geneo.lms.db.MarkingSchemeEnum marking_scheme_type = 19;
   */
  markingSchemeType?: MarkingSchemeEnum;

  /**
   * @generated from field: repeated geneo.lms.db.QuestionModuleMap question_module_map = 20;
   */
  questionModuleMap: QuestionModuleMap[] = [];

  /**
   * @generated from field: repeated geneo.lms.db.QuestionTypeMarks question_type_and_marks = 21;
   */
  questionTypeAndMarks: QuestionTypeMarks[] = [];

  /**
   * @generated from field: optional bool is_ai_assessment = 22;
   */
  isAiAssessment?: boolean;

  /**
   * @generated from field: repeated geneo.lms.db.MultiSubjectSection multi_subject_section_meta_info = 23;
   */
  multiSubjectSectionMetaInfo: MultiSubjectSection[] = [];

  /**
   * @generated from field: repeated int32 subject_ids = 24;
   */
  subjectIds: number[] = [];

  /**
   * @generated from field: repeated geneo.lms.assessment.teacher.apis.MultiSubjectFormateInfo multi_subject_formate_info = 25;
   */
  multiSubjectFormateInfo: MultiSubjectFormateInfo[] = [];

  /**
   * @generated from field: optional int32 class_id = 26;
   */
  classId?: number;

  /**
   * @generated from field: optional int32 marks_per_question = 27;
   */
  marksPerQuestion?: number;

  /**
   * project tasks only
   *
   * @generated from field: repeated geneo.lms.assessment.teacher.apis.SelectedResourceInfo selected_resources_info = 28;
   */
  selectedResourcesInfo: SelectedResourceInfo[] = [];

  /**
   * @generated from field: repeated string resource_ids = 29;
   */
  resourceIds: string[] = [];

  constructor(data?: PartialMessage<AssessmentCreationSubmitV6Request>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.AssessmentCreationSubmitV6Request";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "teacher_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "subject_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 3, name: "section_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "task_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "module_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 6, name: "category", kind: "enum", T: proto3.getEnumType(Module_ModuleCategoryEnum), opt: true },
    { no: 7, name: "selected_tasks_info", kind: "message", T: TaskInfoModel, repeated: true },
    { no: 8, name: "assessment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 9, name: "instructions", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 10, name: "creation_status", kind: "enum", T: proto3.getEnumType(TaskCreationStatusEnum) },
    { no: 11, name: "task_type", kind: "enum", T: proto3.getEnumType(TaskEnum) },
    { no: 12, name: "task_uploads", kind: "message", T: CloudUpload, repeated: true },
    { no: 13, name: "max_marks", kind: "scalar", T: 2 /* ScalarType.FLOAT */, opt: true },
    { no: 14, name: "submission_type", kind: "enum", T: proto3.getEnumType(SubmissionType), opt: true },
    { no: 15, name: "source_geneo_assessment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 16, name: "chapter_ids_info", kind: "message", T: ChapterIdsInfo, repeated: true },
    { no: 17, name: "mode_of_conduction", kind: "enum", T: proto3.getEnumType(ModeOfConductionEnum), opt: true },
    { no: 18, name: "question_section_meta_info", kind: "message", T: QuestionSectionMeta, repeated: true },
    { no: 19, name: "marking_scheme_type", kind: "enum", T: proto3.getEnumType(MarkingSchemeEnum), opt: true },
    { no: 20, name: "question_module_map", kind: "message", T: QuestionModuleMap, repeated: true },
    { no: 21, name: "question_type_and_marks", kind: "message", T: QuestionTypeMarks, repeated: true },
    { no: 22, name: "is_ai_assessment", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 23, name: "multi_subject_section_meta_info", kind: "message", T: MultiSubjectSection, repeated: true },
    { no: 24, name: "subject_ids", kind: "scalar", T: 5 /* ScalarType.INT32 */, repeated: true },
    { no: 25, name: "multi_subject_formate_info", kind: "message", T: MultiSubjectFormateInfo, repeated: true },
    { no: 26, name: "class_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 27, name: "marks_per_question", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 28, name: "selected_resources_info", kind: "message", T: SelectedResourceInfo, repeated: true },
    { no: 29, name: "resource_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AssessmentCreationSubmitV6Request {
    return new AssessmentCreationSubmitV6Request().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AssessmentCreationSubmitV6Request {
    return new AssessmentCreationSubmitV6Request().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AssessmentCreationSubmitV6Request {
    return new AssessmentCreationSubmitV6Request().fromJsonString(jsonString, options);
  }

  static equals(a: AssessmentCreationSubmitV6Request | PlainMessage<AssessmentCreationSubmitV6Request> | undefined, b: AssessmentCreationSubmitV6Request | PlainMessage<AssessmentCreationSubmitV6Request> | undefined): boolean {
    return proto3.util.equals(AssessmentCreationSubmitV6Request, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.CreateQuestionPaperTemplateV2Request
 */
export class CreateQuestionPaperTemplateV2Request extends Message<CreateQuestionPaperTemplateV2Request> {
  /**
   * @generated from field: string template_title = 1;
   */
  templateTitle = "";

  /**
   * @generated from field: repeated geneo.lms.db.QuestionSection question_section_info = 2;
   */
  questionSectionInfo: QuestionSection[] = [];

  /**
   * @generated from field: int64 teacher_id = 3;
   */
  teacherId = protoInt64.zero;

  /**
   * @generated from field: optional int32 subject_id = 4;
   */
  subjectId?: number;

  /**
   * @generated from field: bool include_ai_questions = 5;
   */
  includeAiQuestions = false;

  /**
   * @generated from field: optional geneo.lms.db.MultiSubjectSectionTemplate multi_subject_section_template = 6;
   */
  multiSubjectSectionTemplate?: MultiSubjectSectionTemplate;

  /**
   * @generated from field: optional geneo.lms.db.TaskEnum task_type = 7;
   */
  taskType?: TaskEnum;

  constructor(data?: PartialMessage<CreateQuestionPaperTemplateV2Request>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.CreateQuestionPaperTemplateV2Request";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "template_title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "question_section_info", kind: "message", T: QuestionSection, repeated: true },
    { no: 3, name: "teacher_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "subject_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 5, name: "include_ai_questions", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "multi_subject_section_template", kind: "message", T: MultiSubjectSectionTemplate, opt: true },
    { no: 7, name: "task_type", kind: "enum", T: proto3.getEnumType(TaskEnum), opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateQuestionPaperTemplateV2Request {
    return new CreateQuestionPaperTemplateV2Request().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateQuestionPaperTemplateV2Request {
    return new CreateQuestionPaperTemplateV2Request().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateQuestionPaperTemplateV2Request {
    return new CreateQuestionPaperTemplateV2Request().fromJsonString(jsonString, options);
  }

  static equals(a: CreateQuestionPaperTemplateV2Request | PlainMessage<CreateQuestionPaperTemplateV2Request> | undefined, b: CreateQuestionPaperTemplateV2Request | PlainMessage<CreateQuestionPaperTemplateV2Request> | undefined): boolean {
    return proto3.util.equals(CreateQuestionPaperTemplateV2Request, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.GetQuestionPaperTemplateV2Request
 */
export class GetQuestionPaperTemplateV2Request extends Message<GetQuestionPaperTemplateV2Request> {
  /**
   * @generated from field: int64 person_id = 1;
   */
  personId = protoInt64.zero;

  /**
   * @generated from field: geneo.ums.db.ProfileRolesEnum person_type = 2;
   */
  personType = ProfileRolesEnum.PROFILE_ROLE_UNDEFINED;

  /**
   * @generated from field: optional int32 subject_id = 3;
   */
  subjectId?: number;

  /**
   * @generated from field: optional geneo.lms.db.TaskEnum task_type = 4;
   */
  taskType?: TaskEnum;

  constructor(data?: PartialMessage<GetQuestionPaperTemplateV2Request>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.GetQuestionPaperTemplateV2Request";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "person_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "person_type", kind: "enum", T: proto3.getEnumType(ProfileRolesEnum) },
    { no: 3, name: "subject_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 4, name: "task_type", kind: "enum", T: proto3.getEnumType(TaskEnum), opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetQuestionPaperTemplateV2Request {
    return new GetQuestionPaperTemplateV2Request().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetQuestionPaperTemplateV2Request {
    return new GetQuestionPaperTemplateV2Request().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetQuestionPaperTemplateV2Request {
    return new GetQuestionPaperTemplateV2Request().fromJsonString(jsonString, options);
  }

  static equals(a: GetQuestionPaperTemplateV2Request | PlainMessage<GetQuestionPaperTemplateV2Request> | undefined, b: GetQuestionPaperTemplateV2Request | PlainMessage<GetQuestionPaperTemplateV2Request> | undefined): boolean {
    return proto3.util.equals(GetQuestionPaperTemplateV2Request, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.TeacherAssessmentClassStatsV3Request
 */
export class TeacherAssessmentClassStatsV3Request extends Message<TeacherAssessmentClassStatsV3Request> {
  /**
   * @generated from field: int64 teacher_id = 1;
   */
  teacherId = protoInt64.zero;

  /**
   * @generated from field: int64 assessment_id = 2;
   */
  assessmentId = protoInt64.zero;

  /**
   * @generated from field: optional int32 attempt_number = 3;
   */
  attemptNumber?: number;

  /**
   * @generated from field: optional geneo.lms.db.AttemptTypeEnum attempt_type = 4;
   */
  attemptType?: AttemptTypeEnum;

  /**
   * @generated from field: optional geneo.lms.assessment.teacher.apis.MultiSubjectSectionRequest multi_subject_section_request = 5;
   */
  multiSubjectSectionRequest?: MultiSubjectSectionRequest;

  constructor(data?: PartialMessage<TeacherAssessmentClassStatsV3Request>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.TeacherAssessmentClassStatsV3Request";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "teacher_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "assessment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "attempt_number", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 4, name: "attempt_type", kind: "enum", T: proto3.getEnumType(AttemptTypeEnum), opt: true },
    { no: 5, name: "multi_subject_section_request", kind: "message", T: MultiSubjectSectionRequest, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TeacherAssessmentClassStatsV3Request {
    return new TeacherAssessmentClassStatsV3Request().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TeacherAssessmentClassStatsV3Request {
    return new TeacherAssessmentClassStatsV3Request().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TeacherAssessmentClassStatsV3Request {
    return new TeacherAssessmentClassStatsV3Request().fromJsonString(jsonString, options);
  }

  static equals(a: TeacherAssessmentClassStatsV3Request | PlainMessage<TeacherAssessmentClassStatsV3Request> | undefined, b: TeacherAssessmentClassStatsV3Request | PlainMessage<TeacherAssessmentClassStatsV3Request> | undefined): boolean {
    return proto3.util.equals(TeacherAssessmentClassStatsV3Request, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.MultiSubjectSectionRequest
 */
export class MultiSubjectSectionRequest extends Message<MultiSubjectSectionRequest> {
  /**
   * @generated from field: int32 subject_id = 1;
   */
  subjectId = 0;

  /**
   * @generated from field: int32 section_no = 2;
   */
  sectionNo = 0;

  constructor(data?: PartialMessage<MultiSubjectSectionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.MultiSubjectSectionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "subject_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "section_no", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MultiSubjectSectionRequest {
    return new MultiSubjectSectionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MultiSubjectSectionRequest {
    return new MultiSubjectSectionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MultiSubjectSectionRequest {
    return new MultiSubjectSectionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: MultiSubjectSectionRequest | PlainMessage<MultiSubjectSectionRequest> | undefined, b: MultiSubjectSectionRequest | PlainMessage<MultiSubjectSectionRequest> | undefined): boolean {
    return proto3.util.equals(MultiSubjectSectionRequest, a, b);
  }
}

/**
 * Assessment-level aggregation of client/server clock mismatches across all
 * students (sent regardless of whether proctoring is enabled).
 *
 * @generated from message geneo.lms.assessment.teacher.apis.AssessmentTimeMismatchSummary
 */
export class AssessmentTimeMismatchSummary extends Message<AssessmentTimeMismatchSummary> {
  /**
   * students that had at least one clock mismatch
   *
   * @generated from field: int32 students_with_time_mismatch = 1;
   */
  studentsWithTimeMismatch = 0;

  /**
   * total mismatch events across all students
   *
   * @generated from field: int32 total_time_mismatches = 2;
   */
  totalTimeMismatches = 0;

  /**
   * all mismatch entries, flattened
   *
   * @generated from field: repeated geneo.lms.db.TimeStampWithKey time_mismatches = 3;
   */
  timeMismatches: TimeStampWithKey[] = [];

  constructor(data?: PartialMessage<AssessmentTimeMismatchSummary>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.AssessmentTimeMismatchSummary";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "students_with_time_mismatch", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "total_time_mismatches", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "time_mismatches", kind: "message", T: TimeStampWithKey, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AssessmentTimeMismatchSummary {
    return new AssessmentTimeMismatchSummary().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AssessmentTimeMismatchSummary {
    return new AssessmentTimeMismatchSummary().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AssessmentTimeMismatchSummary {
    return new AssessmentTimeMismatchSummary().fromJsonString(jsonString, options);
  }

  static equals(a: AssessmentTimeMismatchSummary | PlainMessage<AssessmentTimeMismatchSummary> | undefined, b: AssessmentTimeMismatchSummary | PlainMessage<AssessmentTimeMismatchSummary> | undefined): boolean {
    return proto3.util.equals(AssessmentTimeMismatchSummary, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.TeacherAssessmentClassStatsV3
 */
export class TeacherAssessmentClassStatsV3 extends Message<TeacherAssessmentClassStatsV3> {
  /**
   * @generated from field: geneo.lms.assessment.common.apis.AssessmentTask assessment = 1;
   */
  assessment?: AssessmentTask;

  /**
   * @generated from field: repeated geneo.lms.assessment.teacher.apis.StudentPerformanceInfo student_performance_info = 2;
   */
  studentPerformanceInfo: StudentPerformanceInfo[] = [];

  /**
   * @generated from field: int32 assigned_students_count = 3;
   */
  assignedStudentsCount = 0;

  /**
   * @generated from field: int32 students_submission_count = 4;
   */
  studentsSubmissionCount = 0;

  /**
   * @generated from field: optional geneo.lms.assessment.teacher.apis.AssessmentReportInfo assessment_report_info = 5;
   */
  assessmentReportInfo?: AssessmentReportInfo;

  /**
   * @generated from field: repeated geneo.lms.db.AttemptStats attempt_info = 6;
   */
  attemptInfo: AttemptStats[] = [];

  /**
   * @generated from field: repeated geneo.lms.assessment.student.apis.MultiSubjectMetrics multi_subject_metrics = 7;
   */
  multiSubjectMetrics: MultiSubjectMetrics[] = [];

  /**
   * @generated from field: optional geneo.lms.assessment.teacher.apis.AssessmentTimeMismatchSummary time_mismatch_summary = 8;
   */
  timeMismatchSummary?: AssessmentTimeMismatchSummary;

  constructor(data?: PartialMessage<TeacherAssessmentClassStatsV3>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.TeacherAssessmentClassStatsV3";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "assessment", kind: "message", T: AssessmentTask },
    { no: 2, name: "student_performance_info", kind: "message", T: StudentPerformanceInfo, repeated: true },
    { no: 3, name: "assigned_students_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "students_submission_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "assessment_report_info", kind: "message", T: AssessmentReportInfo, opt: true },
    { no: 6, name: "attempt_info", kind: "message", T: AttemptStats, repeated: true },
    { no: 7, name: "multi_subject_metrics", kind: "message", T: MultiSubjectMetrics, repeated: true },
    { no: 8, name: "time_mismatch_summary", kind: "message", T: AssessmentTimeMismatchSummary, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TeacherAssessmentClassStatsV3 {
    return new TeacherAssessmentClassStatsV3().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TeacherAssessmentClassStatsV3 {
    return new TeacherAssessmentClassStatsV3().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TeacherAssessmentClassStatsV3 {
    return new TeacherAssessmentClassStatsV3().fromJsonString(jsonString, options);
  }

  static equals(a: TeacherAssessmentClassStatsV3 | PlainMessage<TeacherAssessmentClassStatsV3> | undefined, b: TeacherAssessmentClassStatsV3 | PlainMessage<TeacherAssessmentClassStatsV3> | undefined): boolean {
    return proto3.util.equals(TeacherAssessmentClassStatsV3, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.TeacherAssessmentClassStatsV3Response
 */
export class TeacherAssessmentClassStatsV3Response extends Message<TeacherAssessmentClassStatsV3Response> {
  /**
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * @generated from field: geneo.lms.assessment.teacher.apis.TeacherAssessmentClassStatsV3 data = 4;
   */
  data?: TeacherAssessmentClassStatsV3;

  constructor(data?: PartialMessage<TeacherAssessmentClassStatsV3Response>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.TeacherAssessmentClassStatsV3Response";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "data", kind: "message", T: TeacherAssessmentClassStatsV3 },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TeacherAssessmentClassStatsV3Response {
    return new TeacherAssessmentClassStatsV3Response().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TeacherAssessmentClassStatsV3Response {
    return new TeacherAssessmentClassStatsV3Response().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TeacherAssessmentClassStatsV3Response {
    return new TeacherAssessmentClassStatsV3Response().fromJsonString(jsonString, options);
  }

  static equals(a: TeacherAssessmentClassStatsV3Response | PlainMessage<TeacherAssessmentClassStatsV3Response> | undefined, b: TeacherAssessmentClassStatsV3Response | PlainMessage<TeacherAssessmentClassStatsV3Response> | undefined): boolean {
    return proto3.util.equals(TeacherAssessmentClassStatsV3Response, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.TeacherOmrAssessmentClassStatsRequest
 */
export class TeacherOmrAssessmentClassStatsRequest extends Message<TeacherOmrAssessmentClassStatsRequest> {
  /**
   * @generated from field: int64 assessment_id = 1;
   */
  assessmentId = protoInt64.zero;

  constructor(data?: PartialMessage<TeacherOmrAssessmentClassStatsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.TeacherOmrAssessmentClassStatsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "assessment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TeacherOmrAssessmentClassStatsRequest {
    return new TeacherOmrAssessmentClassStatsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TeacherOmrAssessmentClassStatsRequest {
    return new TeacherOmrAssessmentClassStatsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TeacherOmrAssessmentClassStatsRequest {
    return new TeacherOmrAssessmentClassStatsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: TeacherOmrAssessmentClassStatsRequest | PlainMessage<TeacherOmrAssessmentClassStatsRequest> | undefined, b: TeacherOmrAssessmentClassStatsRequest | PlainMessage<TeacherOmrAssessmentClassStatsRequest> | undefined): boolean {
    return proto3.util.equals(TeacherOmrAssessmentClassStatsRequest, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.TeacherOmrAssessmentClassStatsResponse
 */
export class TeacherOmrAssessmentClassStatsResponse extends Message<TeacherOmrAssessmentClassStatsResponse> {
  /**
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * @generated from field: geneo.lms.assessment.teacher.apis.TeacherOmrAssessmentClassStats data = 4;
   */
  data?: TeacherOmrAssessmentClassStats;

  constructor(data?: PartialMessage<TeacherOmrAssessmentClassStatsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.TeacherOmrAssessmentClassStatsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "data", kind: "message", T: TeacherOmrAssessmentClassStats },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TeacherOmrAssessmentClassStatsResponse {
    return new TeacherOmrAssessmentClassStatsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TeacherOmrAssessmentClassStatsResponse {
    return new TeacherOmrAssessmentClassStatsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TeacherOmrAssessmentClassStatsResponse {
    return new TeacherOmrAssessmentClassStatsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: TeacherOmrAssessmentClassStatsResponse | PlainMessage<TeacherOmrAssessmentClassStatsResponse> | undefined, b: TeacherOmrAssessmentClassStatsResponse | PlainMessage<TeacherOmrAssessmentClassStatsResponse> | undefined): boolean {
    return proto3.util.equals(TeacherOmrAssessmentClassStatsResponse, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.TeacherOmrAssessmentClassStats
 */
export class TeacherOmrAssessmentClassStats extends Message<TeacherOmrAssessmentClassStats> {
  /**
   * @generated from field: repeated geneo.lms.assessment.teacher.apis.StudentOmrPerformanceInfo student_performance_info = 1;
   */
  studentPerformanceInfo: StudentOmrPerformanceInfo[] = [];

  /**
   * @generated from field: optional float class_score = 2;
   */
  classScore?: number;

  /**
   * @generated from field: optional geneo.lms.assessment.teacher.apis.AssessmentReportInfo assessment_report_info = 3;
   */
  assessmentReportInfo?: AssessmentReportInfo;

  constructor(data?: PartialMessage<TeacherOmrAssessmentClassStats>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.TeacherOmrAssessmentClassStats";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "student_performance_info", kind: "message", T: StudentOmrPerformanceInfo, repeated: true },
    { no: 2, name: "class_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */, opt: true },
    { no: 3, name: "assessment_report_info", kind: "message", T: AssessmentReportInfo, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TeacherOmrAssessmentClassStats {
    return new TeacherOmrAssessmentClassStats().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TeacherOmrAssessmentClassStats {
    return new TeacherOmrAssessmentClassStats().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TeacherOmrAssessmentClassStats {
    return new TeacherOmrAssessmentClassStats().fromJsonString(jsonString, options);
  }

  static equals(a: TeacherOmrAssessmentClassStats | PlainMessage<TeacherOmrAssessmentClassStats> | undefined, b: TeacherOmrAssessmentClassStats | PlainMessage<TeacherOmrAssessmentClassStats> | undefined): boolean {
    return proto3.util.equals(TeacherOmrAssessmentClassStats, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.StudentOmrPerformanceInfo
 */
export class StudentOmrPerformanceInfo extends Message<StudentOmrPerformanceInfo> {
  /**
   * @generated from field: string student_id = 1;
   */
  studentId = "";

  /**
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * @generated from field: float score_percent = 4;
   */
  scorePercent = 0;

  /**
   * @generated from field: float response_score = 5;
   */
  responseScore = 0;

  /**
   * @generated from field: optional bool is_submitted = 6;
   */
  isSubmitted?: boolean;

  /**
   * @generated from field: optional bool is_evaluated = 7;
   */
  isEvaluated?: boolean;

  constructor(data?: PartialMessage<StudentOmrPerformanceInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.StudentOmrPerformanceInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "student_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "score_percent", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 5, name: "response_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 6, name: "is_submitted", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 7, name: "is_evaluated", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StudentOmrPerformanceInfo {
    return new StudentOmrPerformanceInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StudentOmrPerformanceInfo {
    return new StudentOmrPerformanceInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StudentOmrPerformanceInfo {
    return new StudentOmrPerformanceInfo().fromJsonString(jsonString, options);
  }

  static equals(a: StudentOmrPerformanceInfo | PlainMessage<StudentOmrPerformanceInfo> | undefined, b: StudentOmrPerformanceInfo | PlainMessage<StudentOmrPerformanceInfo> | undefined): boolean {
    return proto3.util.equals(StudentOmrPerformanceInfo, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.TeacherStudentOmrResponseFetchRequest
 */
export class TeacherStudentOmrResponseFetchRequest extends Message<TeacherStudentOmrResponseFetchRequest> {
  /**
   * @generated from field: string student_id = 1;
   */
  studentId = "";

  /**
   * @generated from field: int64 assessment_id = 2;
   */
  assessmentId = protoInt64.zero;

  constructor(data?: PartialMessage<TeacherStudentOmrResponseFetchRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.TeacherStudentOmrResponseFetchRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "student_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "assessment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TeacherStudentOmrResponseFetchRequest {
    return new TeacherStudentOmrResponseFetchRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TeacherStudentOmrResponseFetchRequest {
    return new TeacherStudentOmrResponseFetchRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TeacherStudentOmrResponseFetchRequest {
    return new TeacherStudentOmrResponseFetchRequest().fromJsonString(jsonString, options);
  }

  static equals(a: TeacherStudentOmrResponseFetchRequest | PlainMessage<TeacherStudentOmrResponseFetchRequest> | undefined, b: TeacherStudentOmrResponseFetchRequest | PlainMessage<TeacherStudentOmrResponseFetchRequest> | undefined): boolean {
    return proto3.util.equals(TeacherStudentOmrResponseFetchRequest, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.TeacherStudentOmrResponseFetchResponse
 */
export class TeacherStudentOmrResponseFetchResponse extends Message<TeacherStudentOmrResponseFetchResponse> {
  /**
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * @generated from field: string student_id = 4;
   */
  studentId = "";

  /**
   * @generated from field: int64 assessment_id = 5;
   */
  assessmentId = protoInt64.zero;

  /**
   * @generated from field: string set_name = 6;
   */
  setName = "";

  /**
   * @generated from field: int32 total_marks = 7;
   */
  totalMarks = 0;

  /**
   * @generated from field: int32 total_obtained_marks = 8;
   */
  totalObtainedMarks = 0;

  /**
   * @generated from field: repeated geneo.lms.assessment.teacher.apis.StudentOmrResponse student_responses = 9;
   */
  studentResponses: StudentOmrResponse[] = [];

  /**
   * @generated from field: repeated geneo.lms.assessment.teacher.apis.OmrMultiSubjectMetrics omr_multi_subject_metrics = 10;
   */
  omrMultiSubjectMetrics: OmrMultiSubjectMetrics[] = [];

  constructor(data?: PartialMessage<TeacherStudentOmrResponseFetchResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.TeacherStudentOmrResponseFetchResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "student_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "assessment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "set_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "total_marks", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "total_obtained_marks", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "student_responses", kind: "message", T: StudentOmrResponse, repeated: true },
    { no: 10, name: "omr_multi_subject_metrics", kind: "message", T: OmrMultiSubjectMetrics, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TeacherStudentOmrResponseFetchResponse {
    return new TeacherStudentOmrResponseFetchResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TeacherStudentOmrResponseFetchResponse {
    return new TeacherStudentOmrResponseFetchResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TeacherStudentOmrResponseFetchResponse {
    return new TeacherStudentOmrResponseFetchResponse().fromJsonString(jsonString, options);
  }

  static equals(a: TeacherStudentOmrResponseFetchResponse | PlainMessage<TeacherStudentOmrResponseFetchResponse> | undefined, b: TeacherStudentOmrResponseFetchResponse | PlainMessage<TeacherStudentOmrResponseFetchResponse> | undefined): boolean {
    return proto3.util.equals(TeacherStudentOmrResponseFetchResponse, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.OmrMultiSubjectMetrics
 */
export class OmrMultiSubjectMetrics extends Message<OmrMultiSubjectMetrics> {
  /**
   * @generated from field: int32 section_no = 1;
   */
  sectionNo = 0;

  /**
   * @generated from field: float time_duration_in_min = 2;
   */
  timeDurationInMin = 0;

  /**
   * @generated from field: int32 number_of_questions = 3;
   */
  numberOfQuestions = 0;

  /**
   * @generated from field: int32 number_of_correct_questions = 4;
   */
  numberOfCorrectQuestions = 0;

  /**
   * @generated from field: float class_subject_score = 5;
   */
  classSubjectScore = 0;

  /**
   * @generated from field: int32 subject_id = 6;
   */
  subjectId = 0;

  /**
   * @generated from field: int32 class_subject_max_score = 9;
   */
  classSubjectMaxScore = 0;

  /**
   * @generated from field: geneo.common.db.Subject.SubjectEnum subject = 10;
   */
  subject = Subject_SubjectEnum.UNDEFINED;

  constructor(data?: PartialMessage<OmrMultiSubjectMetrics>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.OmrMultiSubjectMetrics";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "section_no", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "time_duration_in_min", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 3, name: "number_of_questions", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "number_of_correct_questions", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "class_subject_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 6, name: "subject_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "class_subject_max_score", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 10, name: "subject", kind: "enum", T: proto3.getEnumType(Subject_SubjectEnum) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): OmrMultiSubjectMetrics {
    return new OmrMultiSubjectMetrics().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): OmrMultiSubjectMetrics {
    return new OmrMultiSubjectMetrics().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): OmrMultiSubjectMetrics {
    return new OmrMultiSubjectMetrics().fromJsonString(jsonString, options);
  }

  static equals(a: OmrMultiSubjectMetrics | PlainMessage<OmrMultiSubjectMetrics> | undefined, b: OmrMultiSubjectMetrics | PlainMessage<OmrMultiSubjectMetrics> | undefined): boolean {
    return proto3.util.equals(OmrMultiSubjectMetrics, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.StudentOmrResponse
 */
export class StudentOmrResponse extends Message<StudentOmrResponse> {
  /**
   * @generated from field: int32 question_number = 1;
   */
  questionNumber = 0;

  /**
   * @generated from field: string question_id = 2;
   */
  questionId = "";

  /**
   * @generated from field: string student_response = 3;
   */
  studentResponse = "";

  /**
   * @generated from field: bool is_submitted = 4;
   */
  isSubmitted = false;

  /**
   * @generated from field: bool is_correct = 5;
   */
  isCorrect = false;

  /**
   * @generated from field: int32 marks_obtained = 6;
   */
  marksObtained = 0;

  /**
   * @generated from field: float max_marks = 7;
   */
  maxMarks = 0;

  constructor(data?: PartialMessage<StudentOmrResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.StudentOmrResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "question_number", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "question_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "student_response", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "is_submitted", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "is_correct", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "marks_obtained", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "max_marks", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StudentOmrResponse {
    return new StudentOmrResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StudentOmrResponse {
    return new StudentOmrResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StudentOmrResponse {
    return new StudentOmrResponse().fromJsonString(jsonString, options);
  }

  static equals(a: StudentOmrResponse | PlainMessage<StudentOmrResponse> | undefined, b: StudentOmrResponse | PlainMessage<StudentOmrResponse> | undefined): boolean {
    return proto3.util.equals(StudentOmrResponse, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.SubSectionTypeV2
 */
export class SubSectionTypeV2 extends Message<SubSectionTypeV2> {
  /**
   * @generated from field: string sub_section_name = 1;
   */
  subSectionName = "";

  /**
   * @generated from field: int32 section_number = 2;
   */
  sectionNumber = 0;

  /**
   * @generated from field: repeated string passage_text = 3;
   */
  passageText: string[] = [];

  /**
   * @generated from field: repeated geneo.lms.db.CloudUpload passage_images_upload = 4;
   */
  passageImagesUpload: CloudUpload[] = [];

  /**
   * @generated from field: optional int32 attempt_any_count = 5;
   */
  attemptAnyCount?: number;

  /**
   * @generated from field: repeated geneo.lms.assessment.teacher.apis.SubSectionQuestionType sub_section_questions = 6;
   */
  subSectionQuestions: SubSectionQuestionType[] = [];

  /**
   * @generated from field: optional geneo.lms.db.QpgSubsectionTypeEnum sub_section_type = 7;
   */
  subSectionType?: QpgSubsectionTypeEnum;

  /**
   * @generated from field: optional bool is_ai_generated_passage = 8;
   */
  isAiGeneratedPassage?: boolean;

  /**
   * @generated from field: repeated int32 passage_module_ids = 9;
   */
  passageModuleIds: number[] = [];

  constructor(data?: PartialMessage<SubSectionTypeV2>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.SubSectionTypeV2";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "sub_section_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "section_number", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "passage_text", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "passage_images_upload", kind: "message", T: CloudUpload, repeated: true },
    { no: 5, name: "attempt_any_count", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 6, name: "sub_section_questions", kind: "message", T: SubSectionQuestionType, repeated: true },
    { no: 7, name: "sub_section_type", kind: "enum", T: proto3.getEnumType(QpgSubsectionTypeEnum), opt: true },
    { no: 8, name: "is_ai_generated_passage", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 9, name: "passage_module_ids", kind: "scalar", T: 5 /* ScalarType.INT32 */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SubSectionTypeV2 {
    return new SubSectionTypeV2().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SubSectionTypeV2 {
    return new SubSectionTypeV2().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SubSectionTypeV2 {
    return new SubSectionTypeV2().fromJsonString(jsonString, options);
  }

  static equals(a: SubSectionTypeV2 | PlainMessage<SubSectionTypeV2> | undefined, b: SubSectionTypeV2 | PlainMessage<SubSectionTypeV2> | undefined): boolean {
    return proto3.util.equals(SubSectionTypeV2, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.GetModuleFilteredQuestionsV8Request
 */
export class GetModuleFilteredQuestionsV8Request extends Message<GetModuleFilteredQuestionsV8Request> {
  /**
   * @generated from field: int64 teacher_id = 1;
   */
  teacherId = protoInt64.zero;

  /**
   * @generated from field: int32 subject_id = 2;
   */
  subjectId = 0;

  /**
   * @generated from field: repeated int32 module_ids = 3;
   */
  moduleIds: number[] = [];

  /**
   * @generated from field: repeated geneo.content.db.Question.QuestionEnum required_question_types = 4;
   */
  requiredQuestionTypes: Question_QuestionEnum[] = [];

  /**
   * @generated from field: repeated geneo.content.db.DifficultyLevelEnum required_difficulty_types = 5;
   */
  requiredDifficultyTypes: DifficultyLevelEnum[] = [];

  /**
   * @generated from field: optional geneo.lms.hw.teacher.apis.RequiredQuestionCountInfoForDifficultyLevel required_difficulty_levels_count_info = 6;
   */
  requiredDifficultyLevelsCountInfo?: RequiredQuestionCountInfoForDifficultyLevel;

  /**
   * @generated from field: repeated string qIdsToBeIgnored = 7;
   */
  qIdsToBeIgnored: string[] = [];

  /**
   * @generated from field: repeated geneo.content.db.BloomLevelEnum bloom_levels = 8;
   */
  bloomLevels: BloomLevelEnum[] = [];

  /**
   * @generated from field: optional int32 no_of_questions = 9;
   */
  noOfQuestions?: number;

  /**
   * @generated from field: optional int32 approximate_time = 10;
   */
  approximateTime?: number;

  /**
   * @generated from field: optional geneo.content.db.DifficultyLevelEnum avg_difficulty_level = 11;
   */
  avgDifficultyLevel?: DifficultyLevelEnum;

  /**
   * @generated from field: geneo.lms.assessment.teacher.apis.AssessmentCreationEnum assessment_creation_type = 12;
   */
  assessmentCreationType = AssessmentCreationEnum.ASSESSMENT_CREATION_UNDEFINED;

  /**
   * @generated from field: optional geneo.lms.db.ModeOfConductionEnum mode_of_conduction = 13;
   */
  modeOfConduction?: ModeOfConductionEnum;

  /**
   * @generated from field: optional int32 page_number = 14;
   */
  pageNumber?: number;

  /**
   * @generated from field: repeated geneo.lms.db.QuestionSection question_section_info = 15;
   */
  questionSectionInfo: QuestionSection[] = [];

  /**
   * @generated from field: repeated string ai_question_prompts = 16;
   */
  aiQuestionPrompts: string[] = [];

  /**
   * @generated from field: bool allow_ai_questions = 17;
   */
  allowAiQuestions = false;

  /**
   * @generated from field: optional string current_question_id = 18;
   */
  currentQuestionId?: string;

  /**
   * @generated from field: optional bool is_ai_assessment = 19;
   */
  isAiAssessment?: boolean;

  /**
   * @generated from field: optional int64 created_by_user_id = 20;
   */
  createdByUserId?: bigint;

  /**
   * @generated from field: optional int32 school_id = 21;
   */
  schoolId?: number;

  /**
   * @generated from field: repeated geneo.lms.assessment.teacher.apis.SubSectionTypeV2 sub_section_request = 22;
   */
  subSectionRequest: SubSectionTypeV2[] = [];

  /**
   * @generated from field: optional int32 subject_section_no = 23;
   */
  subjectSectionNo?: number;

  /**
   * @generated from field: optional int64 section_id = 24;
   */
  sectionId?: bigint;

  /**
   * @generated from field: optional string search_text = 25;
   */
  searchText?: string;

  /**
   * @generated from field: optional bool filter_by_previously_used = 27;
   */
  filterByPreviouslyUsed?: boolean;

  /**
   * true -> only textbook questions, false -> exclude textbook questions, unset -> all questions
   *
   * @generated from field: optional bool textbook_questions = 28;
   */
  textbookQuestions?: boolean;

  /**
   * @generated from field: optional geneo.lms.db.QpgSubsectionTypeEnum sub_section_type = 29;
   */
  subSectionType?: QpgSubsectionTypeEnum;

  constructor(data?: PartialMessage<GetModuleFilteredQuestionsV8Request>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.GetModuleFilteredQuestionsV8Request";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "teacher_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "subject_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "module_ids", kind: "scalar", T: 5 /* ScalarType.INT32 */, repeated: true },
    { no: 4, name: "required_question_types", kind: "enum", T: proto3.getEnumType(Question_QuestionEnum), repeated: true },
    { no: 5, name: "required_difficulty_types", kind: "enum", T: proto3.getEnumType(DifficultyLevelEnum), repeated: true },
    { no: 6, name: "required_difficulty_levels_count_info", kind: "message", T: RequiredQuestionCountInfoForDifficultyLevel, opt: true },
    { no: 7, name: "qIdsToBeIgnored", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 8, name: "bloom_levels", kind: "enum", T: proto3.getEnumType(BloomLevelEnum), repeated: true },
    { no: 9, name: "no_of_questions", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 10, name: "approximate_time", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 11, name: "avg_difficulty_level", kind: "enum", T: proto3.getEnumType(DifficultyLevelEnum), opt: true },
    { no: 12, name: "assessment_creation_type", kind: "enum", T: proto3.getEnumType(AssessmentCreationEnum) },
    { no: 13, name: "mode_of_conduction", kind: "enum", T: proto3.getEnumType(ModeOfConductionEnum), opt: true },
    { no: 14, name: "page_number", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 15, name: "question_section_info", kind: "message", T: QuestionSection, repeated: true },
    { no: 16, name: "ai_question_prompts", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 17, name: "allow_ai_questions", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 18, name: "current_question_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 19, name: "is_ai_assessment", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 20, name: "created_by_user_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 21, name: "school_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 22, name: "sub_section_request", kind: "message", T: SubSectionTypeV2, repeated: true },
    { no: 23, name: "subject_section_no", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 24, name: "section_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 25, name: "search_text", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 27, name: "filter_by_previously_used", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 28, name: "textbook_questions", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 29, name: "sub_section_type", kind: "enum", T: proto3.getEnumType(QpgSubsectionTypeEnum), opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetModuleFilteredQuestionsV8Request {
    return new GetModuleFilteredQuestionsV8Request().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetModuleFilteredQuestionsV8Request {
    return new GetModuleFilteredQuestionsV8Request().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetModuleFilteredQuestionsV8Request {
    return new GetModuleFilteredQuestionsV8Request().fromJsonString(jsonString, options);
  }

  static equals(a: GetModuleFilteredQuestionsV8Request | PlainMessage<GetModuleFilteredQuestionsV8Request> | undefined, b: GetModuleFilteredQuestionsV8Request | PlainMessage<GetModuleFilteredQuestionsV8Request> | undefined): boolean {
    return proto3.util.equals(GetModuleFilteredQuestionsV8Request, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.GetModuleFilteredQuestionsV8Response
 */
export class GetModuleFilteredQuestionsV8Response extends Message<GetModuleFilteredQuestionsV8Response> {
  /**
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * @generated from field: geneo.lms.assessment.teacher.apis.ModuleFilteredQuestionsV3 data = 4;
   */
  data?: ModuleFilteredQuestionsV3;

  constructor(data?: PartialMessage<GetModuleFilteredQuestionsV8Response>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.GetModuleFilteredQuestionsV8Response";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "data", kind: "message", T: ModuleFilteredQuestionsV3 },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetModuleFilteredQuestionsV8Response {
    return new GetModuleFilteredQuestionsV8Response().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetModuleFilteredQuestionsV8Response {
    return new GetModuleFilteredQuestionsV8Response().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetModuleFilteredQuestionsV8Response {
    return new GetModuleFilteredQuestionsV8Response().fromJsonString(jsonString, options);
  }

  static equals(a: GetModuleFilteredQuestionsV8Response | PlainMessage<GetModuleFilteredQuestionsV8Response> | undefined, b: GetModuleFilteredQuestionsV8Response | PlainMessage<GetModuleFilteredQuestionsV8Response> | undefined): boolean {
    return proto3.util.equals(GetModuleFilteredQuestionsV8Response, a, b);
  }
}

/**
 * One student's individual project mark.
 *
 * @generated from message geneo.lms.assessment.teacher.apis.ProjectStudentMarkInput
 */
export class ProjectStudentMarkInput extends Message<ProjectStudentMarkInput> {
  /**
   * @generated from field: int64 student_id = 1;
   */
  studentId = protoInt64.zero;

  /**
   * Must be between 0 and the project's max_marks.
   *
   * @generated from field: float obtained_marks = 2;
   */
  obtainedMarks = 0;

  /**
   * Replaces this student's stored remarks. Omit to leave them untouched.
   *
   * @generated from field: repeated string remarks = 3;
   */
  remarks: string[] = [];

  constructor(data?: PartialMessage<ProjectStudentMarkInput>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.ProjectStudentMarkInput";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "student_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "obtained_marks", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 3, name: "remarks", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ProjectStudentMarkInput {
    return new ProjectStudentMarkInput().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ProjectStudentMarkInput {
    return new ProjectStudentMarkInput().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ProjectStudentMarkInput {
    return new ProjectStudentMarkInput().fromJsonString(jsonString, options);
  }

  static equals(a: ProjectStudentMarkInput | PlainMessage<ProjectStudentMarkInput> | undefined, b: ProjectStudentMarkInput | PlainMessage<ProjectStudentMarkInput> | undefined): boolean {
    return proto3.util.equals(ProjectStudentMarkInput, a, b);
  }
}

/**
 * Award ONE mark to an entire collaboration group. The mark is written to every
 * active member individually, exactly as if it had been sent per student.
 *
 * @generated from message geneo.lms.assessment.teacher.apis.UpdateProjectGroupMarksRequest
 */
export class UpdateProjectGroupMarksRequest extends Message<UpdateProjectGroupMarksRequest> {
  /**
   * @generated from field: int64 assessment_id = 1;
   */
  assessmentId = protoInt64.zero;

  /**
   * @generated from field: int64 student_group_id = 2;
   */
  studentGroupId = protoInt64.zero;

  /**
   * @generated from field: float obtained_marks = 3;
   */
  obtainedMarks = 0;

  /**
   * Applied to every member of the group. Omit to leave existing remarks alone.
   *
   * @generated from field: repeated string remarks = 4;
   */
  remarks: string[] = [];

  constructor(data?: PartialMessage<UpdateProjectGroupMarksRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.UpdateProjectGroupMarksRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "assessment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "student_group_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "obtained_marks", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 4, name: "remarks", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateProjectGroupMarksRequest {
    return new UpdateProjectGroupMarksRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateProjectGroupMarksRequest {
    return new UpdateProjectGroupMarksRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateProjectGroupMarksRequest {
    return new UpdateProjectGroupMarksRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateProjectGroupMarksRequest | PlainMessage<UpdateProjectGroupMarksRequest> | undefined, b: UpdateProjectGroupMarksRequest | PlainMessage<UpdateProjectGroupMarksRequest> | undefined): boolean {
    return proto3.util.equals(UpdateProjectGroupMarksRequest, a, b);
  }
}

/**
 * Award different marks to individual students. The group mark becomes the
 * average of all its active members' marks.
 *
 * @generated from message geneo.lms.assessment.teacher.apis.UpdateProjectStudentMarksRequest
 */
export class UpdateProjectStudentMarksRequest extends Message<UpdateProjectStudentMarksRequest> {
  /**
   * @generated from field: int64 assessment_id = 1;
   */
  assessmentId = protoInt64.zero;

  /**
   * @generated from field: repeated geneo.lms.assessment.teacher.apis.ProjectStudentMarkInput student_marks = 2;
   */
  studentMarks: ProjectStudentMarkInput[] = [];

  /**
   * The group being graded. Optional, but when supplied every listed student
   * must belong to it - the server rejects the request otherwise.
   *
   * @generated from field: optional int64 student_group_id = 3;
   */
  studentGroupId?: bigint;

  constructor(data?: PartialMessage<UpdateProjectStudentMarksRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.UpdateProjectStudentMarksRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "assessment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "student_marks", kind: "message", T: ProjectStudentMarkInput, repeated: true },
    { no: 3, name: "student_group_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateProjectStudentMarksRequest {
    return new UpdateProjectStudentMarksRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateProjectStudentMarksRequest {
    return new UpdateProjectStudentMarksRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateProjectStudentMarksRequest {
    return new UpdateProjectStudentMarksRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateProjectStudentMarksRequest | PlainMessage<UpdateProjectStudentMarksRequest> | undefined, b: UpdateProjectStudentMarksRequest | PlainMessage<UpdateProjectStudentMarksRequest> | undefined): boolean {
    return proto3.util.equals(UpdateProjectStudentMarksRequest, a, b);
  }
}

/**
 * One member's individual mark.
 *
 * @generated from message geneo.lms.assessment.teacher.apis.ProjectStudentMarkResult
 */
export class ProjectStudentMarkResult extends Message<ProjectStudentMarkResult> {
  /**
   * @generated from field: int64 student_id = 1;
   */
  studentId = protoInt64.zero;

  /**
   * @generated from field: float obtained_marks = 2;
   */
  obtainedMarks = 0;

  /**
   * False for a member who has never been marked. Such a member still counts
   * in the group average, contributing zero.
   *
   * @generated from field: bool is_graded = 3;
   */
  isGraded = false;

  /**
   * @generated from field: repeated string remarks = 4;
   */
  remarks: string[] = [];

  /**
   * Display name, so a grading screen needs no second call to resolve students.
   *
   * @generated from field: optional string student_name = 5;
   */
  studentName?: string;

  /**
   * @generated from field: optional string roll_number = 6;
   */
  rollNumber?: string;

  constructor(data?: PartialMessage<ProjectStudentMarkResult>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.ProjectStudentMarkResult";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "student_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "obtained_marks", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 3, name: "is_graded", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "remarks", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 5, name: "student_name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 6, name: "roll_number", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ProjectStudentMarkResult {
    return new ProjectStudentMarkResult().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ProjectStudentMarkResult {
    return new ProjectStudentMarkResult().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ProjectStudentMarkResult {
    return new ProjectStudentMarkResult().fromJsonString(jsonString, options);
  }

  static equals(a: ProjectStudentMarkResult | PlainMessage<ProjectStudentMarkResult> | undefined, b: ProjectStudentMarkResult | PlainMessage<ProjectStudentMarkResult> | undefined): boolean {
    return proto3.util.equals(ProjectStudentMarkResult, a, b);
  }
}

/**
 * State of one group after marking. A project assigned without collaboration
 * groups reports a single entry holding just the students that were marked.
 *
 * @generated from message geneo.lms.assessment.teacher.apis.ProjectGroupMarkSummary
 */
export class ProjectGroupMarkSummary extends Message<ProjectGroupMarkSummary> {
  /**
   * @generated from field: int64 student_group_id = 1;
   */
  studentGroupId = protoInt64.zero;

  /**
   * @generated from field: optional string group_name = 2;
   */
  groupName?: string;

  /**
   * Every active member of the group, marked or not.
   *
   * @generated from field: repeated geneo.lms.assessment.teacher.apis.ProjectStudentMarkResult student_marks = 3;
   */
  studentMarks: ProjectStudentMarkResult[] = [];

  /**
   * Server-calculated: sum of the members' marks over the active member count,
   * where an unmarked member contributes zero. Unrounded.
   *
   * @generated from field: float group_average_marks = 4;
   */
  groupAverageMarks = 0;

  /**
   * @generated from field: float group_max_marks = 5;
   */
  groupMaxMarks = 0;

  /**
   * @generated from field: int32 graded_student_count = 6;
   */
  gradedStudentCount = 0;

  /**
   * @generated from field: int32 active_student_count = 7;
   */
  activeStudentCount = 0;

  /**
   * True only once every active member has been marked.
   *
   * @generated from field: bool is_group_grade_final = 8;
   */
  isGroupGradeFinal = false;

  /**
   * Whether the group has submitted the project. Marking is REJECTED while this
   * is false, so a grading screen should use it to enable/disable its inputs.
   *
   * @generated from field: bool is_submitted = 9;
   */
  isSubmitted = false;

  /**
   * @generated from field: repeated geneo.lms.db.CloudUpload user_uploads = 10;
   */
  userUploads: CloudUpload[] = [];

  /**
   * @generated from field: repeated geneo.lms.db.StudentPracticalResponse practical_responses = 11;
   */
  practicalResponses: StudentPracticalResponse[] = [];

  /**
   * Submitted after the end time; only possible when late submission was allowed.
   *
   * @generated from field: bool is_submitted_late = 12;
   */
  isSubmittedLate = false;

  constructor(data?: PartialMessage<ProjectGroupMarkSummary>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.ProjectGroupMarkSummary";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "student_group_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "group_name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "student_marks", kind: "message", T: ProjectStudentMarkResult, repeated: true },
    { no: 4, name: "group_average_marks", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 5, name: "group_max_marks", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 6, name: "graded_student_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "active_student_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "is_group_grade_final", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 9, name: "is_submitted", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 10, name: "user_uploads", kind: "message", T: CloudUpload, repeated: true },
    { no: 11, name: "practical_responses", kind: "message", T: StudentPracticalResponse, repeated: true },
    { no: 12, name: "is_submitted_late", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ProjectGroupMarkSummary {
    return new ProjectGroupMarkSummary().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ProjectGroupMarkSummary {
    return new ProjectGroupMarkSummary().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ProjectGroupMarkSummary {
    return new ProjectGroupMarkSummary().fromJsonString(jsonString, options);
  }

  static equals(a: ProjectGroupMarkSummary | PlainMessage<ProjectGroupMarkSummary> | undefined, b: ProjectGroupMarkSummary | PlainMessage<ProjectGroupMarkSummary> | undefined): boolean {
    return proto3.util.equals(ProjectGroupMarkSummary, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.UpdateProjectMarksData
 */
export class UpdateProjectMarksData extends Message<UpdateProjectMarksData> {
  /**
   * @generated from field: repeated geneo.lms.assessment.teacher.apis.ProjectGroupMarkSummary groups = 1;
   */
  groups: ProjectGroupMarkSummary[] = [];

  constructor(data?: PartialMessage<UpdateProjectMarksData>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.UpdateProjectMarksData";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "groups", kind: "message", T: ProjectGroupMarkSummary, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateProjectMarksData {
    return new UpdateProjectMarksData().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateProjectMarksData {
    return new UpdateProjectMarksData().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateProjectMarksData {
    return new UpdateProjectMarksData().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateProjectMarksData | PlainMessage<UpdateProjectMarksData> | undefined, b: UpdateProjectMarksData | PlainMessage<UpdateProjectMarksData> | undefined): boolean {
    return proto3.util.equals(UpdateProjectMarksData, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.UpdateProjectMarksResponse
 */
export class UpdateProjectMarksResponse extends Message<UpdateProjectMarksResponse> {
  /**
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * @generated from field: geneo.lms.assessment.teacher.apis.UpdateProjectMarksData data = 4;
   */
  data?: UpdateProjectMarksData;

  constructor(data?: PartialMessage<UpdateProjectMarksResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.UpdateProjectMarksResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "data", kind: "message", T: UpdateProjectMarksData },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateProjectMarksResponse {
    return new UpdateProjectMarksResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateProjectMarksResponse {
    return new UpdateProjectMarksResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateProjectMarksResponse {
    return new UpdateProjectMarksResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateProjectMarksResponse | PlainMessage<UpdateProjectMarksResponse> | undefined, b: UpdateProjectMarksResponse | PlainMessage<UpdateProjectMarksResponse> | undefined): boolean {
    return proto3.util.equals(UpdateProjectMarksResponse, a, b);
  }
}

/**
 * Read the whole grading screen for a project: every group, every member, their
 * individual marks and the derived group mark. Writes nothing.
 *
 * @generated from message geneo.lms.assessment.teacher.apis.GetProjectMarksRequest
 */
export class GetProjectMarksRequest extends Message<GetProjectMarksRequest> {
  /**
   * @generated from field: int64 assessment_id = 1;
   */
  assessmentId = protoInt64.zero;

  /**
   * Restrict the response to one group. Omit for every group of the project.
   *
   * @generated from field: optional int64 student_group_id = 2;
   */
  studentGroupId?: bigint;

  constructor(data?: PartialMessage<GetProjectMarksRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.GetProjectMarksRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "assessment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "student_group_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetProjectMarksRequest {
    return new GetProjectMarksRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetProjectMarksRequest {
    return new GetProjectMarksRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetProjectMarksRequest {
    return new GetProjectMarksRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetProjectMarksRequest | PlainMessage<GetProjectMarksRequest> | undefined, b: GetProjectMarksRequest | PlainMessage<GetProjectMarksRequest> | undefined): boolean {
    return proto3.util.equals(GetProjectMarksRequest, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.GetProjectMarksData
 */
export class GetProjectMarksData extends Message<GetProjectMarksData> {
  /**
   * @generated from field: int64 assessment_id = 1;
   */
  assessmentId = protoInt64.zero;

  /**
   * @generated from field: string assessment_name = 2;
   */
  assessmentName = "";

  /**
   * The common maximum every student of this project is marked out of.
   *
   * @generated from field: float max_marks = 3;
   */
  maxMarks = 0;

  /**
   * False when the project was assigned without collaboration groups; the single
   * entry in `groups` is then the section-wide all-members group, not a team.
   *
   * @generated from field: bool is_collaborative = 4;
   */
  isCollaborative = false;

  /**
   * @generated from field: repeated geneo.lms.assessment.teacher.apis.ProjectGroupMarkSummary groups = 5;
   */
  groups: ProjectGroupMarkSummary[] = [];

  constructor(data?: PartialMessage<GetProjectMarksData>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.GetProjectMarksData";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "assessment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "assessment_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "max_marks", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 4, name: "is_collaborative", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "groups", kind: "message", T: ProjectGroupMarkSummary, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetProjectMarksData {
    return new GetProjectMarksData().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetProjectMarksData {
    return new GetProjectMarksData().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetProjectMarksData {
    return new GetProjectMarksData().fromJsonString(jsonString, options);
  }

  static equals(a: GetProjectMarksData | PlainMessage<GetProjectMarksData> | undefined, b: GetProjectMarksData | PlainMessage<GetProjectMarksData> | undefined): boolean {
    return proto3.util.equals(GetProjectMarksData, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.GetProjectMarksResponse
 */
export class GetProjectMarksResponse extends Message<GetProjectMarksResponse> {
  /**
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * @generated from field: geneo.lms.assessment.teacher.apis.GetProjectMarksData data = 4;
   */
  data?: GetProjectMarksData;

  constructor(data?: PartialMessage<GetProjectMarksResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.GetProjectMarksResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "data", kind: "message", T: GetProjectMarksData },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetProjectMarksResponse {
    return new GetProjectMarksResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetProjectMarksResponse {
    return new GetProjectMarksResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetProjectMarksResponse {
    return new GetProjectMarksResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetProjectMarksResponse | PlainMessage<GetProjectMarksResponse> | undefined, b: GetProjectMarksResponse | PlainMessage<GetProjectMarksResponse> | undefined): boolean {
    return proto3.util.equals(GetProjectMarksResponse, a, b);
  }
}

/**
 * List the collaboration groups the LOGGED-IN teacher has already created in one
 * class section, so an assignment screen can offer them for reuse. The teacher is
 * resolved from the session cookie - there is deliberately no teacher_id field,
 * so one teacher can never read another teacher's groups.
 *
 * @generated from message geneo.lms.assessment.teacher.apis.GetTeacherSectionGroupsRequest
 */
export class GetTeacherSectionGroupsRequest extends Message<GetTeacherSectionGroupsRequest> {
  /**
   * @generated from field: int64 section_id = 1;
   */
  sectionId = protoInt64.zero;

  /**
   * Page size. Defaults to 10, capped at 50.
   *
   * @generated from field: optional int32 limit = 2;
   */
  limit?: number;

  /**
   * 1-based page number. Defaults to 1; anything below 1 is treated as 1.
   *
   * @generated from field: optional int32 page = 3;
   */
  page?: number;

  constructor(data?: PartialMessage<GetTeacherSectionGroupsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.GetTeacherSectionGroupsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "section_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 3, name: "page", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetTeacherSectionGroupsRequest {
    return new GetTeacherSectionGroupsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetTeacherSectionGroupsRequest {
    return new GetTeacherSectionGroupsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetTeacherSectionGroupsRequest {
    return new GetTeacherSectionGroupsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetTeacherSectionGroupsRequest | PlainMessage<GetTeacherSectionGroupsRequest> | undefined, b: GetTeacherSectionGroupsRequest | PlainMessage<GetTeacherSectionGroupsRequest> | undefined): boolean {
    return proto3.util.equals(GetTeacherSectionGroupsRequest, a, b);
  }
}

/**
 * One member of a saved group, resolved here so the client needs no second call.
 *
 * @generated from message geneo.lms.assessment.teacher.apis.SectionStudentGroupMember
 */
export class SectionStudentGroupMember extends Message<SectionStudentGroupMember> {
  /**
   * @generated from field: int64 student_id = 1;
   */
  studentId = protoInt64.zero;

  /**
   * @generated from field: optional string student_name = 2;
   */
  studentName?: string;

  /**
   * @generated from field: optional string roll_number = 3;
   */
  rollNumber?: string;

  constructor(data?: PartialMessage<SectionStudentGroupMember>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.SectionStudentGroupMember";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "student_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "student_name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "roll_number", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SectionStudentGroupMember {
    return new SectionStudentGroupMember().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SectionStudentGroupMember {
    return new SectionStudentGroupMember().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SectionStudentGroupMember {
    return new SectionStudentGroupMember().fromJsonString(jsonString, options);
  }

  static equals(a: SectionStudentGroupMember | PlainMessage<SectionStudentGroupMember> | undefined, b: SectionStudentGroupMember | PlainMessage<SectionStudentGroupMember> | undefined): boolean {
    return proto3.util.equals(SectionStudentGroupMember, a, b);
  }
}

/**
 * One saved collaboration group. A group name is reused across assessments and
 * every reuse writes its own student_group row, so only the most recent row of a
 * name is reported: student_group_id is that latest row, and students is the
 * membership it was last saved with.
 *
 * @generated from message geneo.lms.assessment.teacher.apis.SectionStudentGroup
 */
export class SectionStudentGroup extends Message<SectionStudentGroup> {
  /**
   * @generated from field: int64 student_group_id = 1;
   */
  studentGroupId = protoInt64.zero;

  /**
   * @generated from field: string group_name = 2;
   */
  groupName = "";

  /**
   * @generated from field: int64 section_id = 3;
   */
  sectionId = protoInt64.zero;

  /**
   * @generated from field: repeated geneo.lms.assessment.teacher.apis.SectionStudentGroupMember students = 4;
   */
  students: SectionStudentGroupMember[] = [];

  /**
   * @generated from field: google.protobuf.Timestamp created_on = 5;
   */
  createdOn?: Timestamp;

  constructor(data?: PartialMessage<SectionStudentGroup>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.SectionStudentGroup";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "student_group_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "group_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "section_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "students", kind: "message", T: SectionStudentGroupMember, repeated: true },
    { no: 5, name: "created_on", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SectionStudentGroup {
    return new SectionStudentGroup().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SectionStudentGroup {
    return new SectionStudentGroup().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SectionStudentGroup {
    return new SectionStudentGroup().fromJsonString(jsonString, options);
  }

  static equals(a: SectionStudentGroup | PlainMessage<SectionStudentGroup> | undefined, b: SectionStudentGroup | PlainMessage<SectionStudentGroup> | undefined): boolean {
    return proto3.util.equals(SectionStudentGroup, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.GetTeacherSectionGroupsData
 */
export class GetTeacherSectionGroupsData extends Message<GetTeacherSectionGroupsData> {
  /**
   * @generated from field: repeated geneo.lms.assessment.teacher.apis.SectionStudentGroup groups = 1;
   */
  groups: SectionStudentGroup[] = [];

  /**
   * True when at least one more group exists past this page.
   *
   * @generated from field: bool has_more = 2;
   */
  hasMore = false;

  constructor(data?: PartialMessage<GetTeacherSectionGroupsData>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.GetTeacherSectionGroupsData";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "groups", kind: "message", T: SectionStudentGroup, repeated: true },
    { no: 2, name: "has_more", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetTeacherSectionGroupsData {
    return new GetTeacherSectionGroupsData().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetTeacherSectionGroupsData {
    return new GetTeacherSectionGroupsData().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetTeacherSectionGroupsData {
    return new GetTeacherSectionGroupsData().fromJsonString(jsonString, options);
  }

  static equals(a: GetTeacherSectionGroupsData | PlainMessage<GetTeacherSectionGroupsData> | undefined, b: GetTeacherSectionGroupsData | PlainMessage<GetTeacherSectionGroupsData> | undefined): boolean {
    return proto3.util.equals(GetTeacherSectionGroupsData, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.GetTeacherSectionGroupsResponse
 */
export class GetTeacherSectionGroupsResponse extends Message<GetTeacherSectionGroupsResponse> {
  /**
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * @generated from field: geneo.lms.assessment.teacher.apis.GetTeacherSectionGroupsData data = 4;
   */
  data?: GetTeacherSectionGroupsData;

  constructor(data?: PartialMessage<GetTeacherSectionGroupsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.GetTeacherSectionGroupsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "data", kind: "message", T: GetTeacherSectionGroupsData },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetTeacherSectionGroupsResponse {
    return new GetTeacherSectionGroupsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetTeacherSectionGroupsResponse {
    return new GetTeacherSectionGroupsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetTeacherSectionGroupsResponse {
    return new GetTeacherSectionGroupsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetTeacherSectionGroupsResponse | PlainMessage<GetTeacherSectionGroupsResponse> | undefined, b: GetTeacherSectionGroupsResponse | PlainMessage<GetTeacherSectionGroupsResponse> | undefined): boolean {
    return proto3.util.equals(GetTeacherSectionGroupsResponse, a, b);
  }
}

/**
 * Dashboard 3 - one group, one project.
 *
 * @generated from message geneo.lms.assessment.teacher.apis.GetGilTeacherProjectGroupReportRequest
 */
export class GetGilTeacherProjectGroupReportRequest extends Message<GetGilTeacherProjectGroupReportRequest> {
  /**
   * @generated from field: int64 assessment_id = 1;
   */
  assessmentId = protoInt64.zero;

  /**
   * @generated from field: int64 student_group_id = 2;
   */
  studentGroupId = protoInt64.zero;

  constructor(data?: PartialMessage<GetGilTeacherProjectGroupReportRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.GetGilTeacherProjectGroupReportRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "assessment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "student_group_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetGilTeacherProjectGroupReportRequest {
    return new GetGilTeacherProjectGroupReportRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetGilTeacherProjectGroupReportRequest {
    return new GetGilTeacherProjectGroupReportRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetGilTeacherProjectGroupReportRequest {
    return new GetGilTeacherProjectGroupReportRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetGilTeacherProjectGroupReportRequest | PlainMessage<GetGilTeacherProjectGroupReportRequest> | undefined, b: GetGilTeacherProjectGroupReportRequest | PlainMessage<GetGilTeacherProjectGroupReportRequest> | undefined): boolean {
    return proto3.util.equals(GetGilTeacherProjectGroupReportRequest, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.GilGroupMemberRow
 */
export class GilGroupMemberRow extends Message<GilGroupMemberRow> {
  /**
   * @generated from field: int64 student_id = 1;
   */
  studentId = protoInt64.zero;

  /**
   * @generated from field: string student_name = 2;
   */
  studentName = "";

  /**
   * @generated from field: optional string roll_number = 3;
   */
  rollNumber?: string;

  /**
   * @generated from field: geneo.lms.assessment.student.apis.GilTimeSpent time_spent = 4;
   */
  timeSpent?: GilTimeSpent;

  /**
   * @generated from field: geneo.lms.assessment.student.apis.GilProjectScore project_score = 5;
   */
  projectScore?: GilProjectScore;

  /**
   * @generated from field: geneo.lms.assessment.student.apis.GilProjectStatusEnum status = 6;
   */
  status = GilProjectStatusEnum.GIL_PROJECT_STATUS_UNDEFINED;

  /**
   * @generated from field: optional geneo.lms.assessment.student.apis.GilCodingActivity coding_activity = 7;
   */
  codingActivity?: GilCodingActivity;

  constructor(data?: PartialMessage<GilGroupMemberRow>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.GilGroupMemberRow";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "student_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "student_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "roll_number", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "time_spent", kind: "message", T: GilTimeSpent },
    { no: 5, name: "project_score", kind: "message", T: GilProjectScore },
    { no: 6, name: "status", kind: "enum", T: proto3.getEnumType(GilProjectStatusEnum) },
    { no: 7, name: "coding_activity", kind: "message", T: GilCodingActivity, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GilGroupMemberRow {
    return new GilGroupMemberRow().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GilGroupMemberRow {
    return new GilGroupMemberRow().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GilGroupMemberRow {
    return new GilGroupMemberRow().fromJsonString(jsonString, options);
  }

  static equals(a: GilGroupMemberRow | PlainMessage<GilGroupMemberRow> | undefined, b: GilGroupMemberRow | PlainMessage<GilGroupMemberRow> | undefined): boolean {
    return proto3.util.equals(GilGroupMemberRow, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.GilTeacherProjectGroupReport
 */
export class GilTeacherProjectGroupReport extends Message<GilTeacherProjectGroupReport> {
  /**
   * @generated from field: geneo.lms.assessment.student.apis.GilProjectInfo project = 1;
   */
  project?: GilProjectInfo;

  /**
   * @generated from field: geneo.lms.assessment.student.apis.GilClassSectionInfo class_section = 2;
   */
  classSection?: GilClassSectionInfo;

  /**
   * @generated from field: string teacher_name = 3;
   */
  teacherName = "";

  /**
   * @generated from field: int64 student_group_id = 4;
   */
  studentGroupId = protoInt64.zero;

  /**
   * @generated from field: optional string group_name = 5;
   */
  groupName?: string;

  /**
   * @generated from field: int32 student_count = 6;
   */
  studentCount = 0;

  /**
   * @generated from field: geneo.lms.assessment.student.apis.GilProjectStatusEnum status = 7;
   */
  status = GilProjectStatusEnum.GIL_PROJECT_STATUS_UNDEFINED;

  /**
   * @generated from field: repeated geneo.lms.assessment.teacher.apis.GilGroupMemberRow members = 8;
   */
  members: GilGroupMemberRow[] = [];

  /**
   * @generated from field: repeated geneo.lms.db.CloudUpload user_uploads = 9;
   */
  userUploads: CloudUpload[] = [];

  /**
   * The group's coding work, rolled up over its members. Login-based: its
   * active_student_count counts members who were logged in.
   *
   * @generated from field: optional geneo.lms.assessment.student.apis.GilCodingSummary coding_summary = 10;
   */
  codingSummary?: GilCodingSummary;

  /**
   * The shared device's work: every member's sittings summed, and every
   * member's editor telemetry merged into one activity.
   *
   * @generated from field: geneo.lms.assessment.student.apis.GilTimeSpent group_time_spent = 11;
   */
  groupTimeSpent?: GilTimeSpent;

  /**
   * @generated from field: optional geneo.lms.assessment.student.apis.GilCodingActivity group_coding_activity = 12;
   */
  groupCodingActivity?: GilCodingActivity;

  /**
   * @generated from field: optional google.protobuf.Timestamp first_activity_at = 13;
   */
  firstActivityAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp last_activity_at = 14;
   */
  lastActivityAt?: Timestamp;

  /**
   * @generated from field: geneo.lms.assessment.student.apis.GilDataStatus data_status = 15;
   */
  dataStatus?: GilDataStatus;

  /**
   * Inferred learning outcome performance of the group's members on this
   * project; see GilLearningOutcomeScore.
   *
   * @generated from field: repeated geneo.lms.assessment.student.apis.GilLearningOutcomeScore learning_outcomes = 16;
   */
  learningOutcomes: GilLearningOutcomeScore[] = [];

  constructor(data?: PartialMessage<GilTeacherProjectGroupReport>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.GilTeacherProjectGroupReport";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "project", kind: "message", T: GilProjectInfo },
    { no: 2, name: "class_section", kind: "message", T: GilClassSectionInfo },
    { no: 3, name: "teacher_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "student_group_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "group_name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 6, name: "student_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "status", kind: "enum", T: proto3.getEnumType(GilProjectStatusEnum) },
    { no: 8, name: "members", kind: "message", T: GilGroupMemberRow, repeated: true },
    { no: 9, name: "user_uploads", kind: "message", T: CloudUpload, repeated: true },
    { no: 10, name: "coding_summary", kind: "message", T: GilCodingSummary, opt: true },
    { no: 11, name: "group_time_spent", kind: "message", T: GilTimeSpent },
    { no: 12, name: "group_coding_activity", kind: "message", T: GilCodingActivity, opt: true },
    { no: 13, name: "first_activity_at", kind: "message", T: Timestamp, opt: true },
    { no: 14, name: "last_activity_at", kind: "message", T: Timestamp, opt: true },
    { no: 15, name: "data_status", kind: "message", T: GilDataStatus },
    { no: 16, name: "learning_outcomes", kind: "message", T: GilLearningOutcomeScore, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GilTeacherProjectGroupReport {
    return new GilTeacherProjectGroupReport().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GilTeacherProjectGroupReport {
    return new GilTeacherProjectGroupReport().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GilTeacherProjectGroupReport {
    return new GilTeacherProjectGroupReport().fromJsonString(jsonString, options);
  }

  static equals(a: GilTeacherProjectGroupReport | PlainMessage<GilTeacherProjectGroupReport> | undefined, b: GilTeacherProjectGroupReport | PlainMessage<GilTeacherProjectGroupReport> | undefined): boolean {
    return proto3.util.equals(GilTeacherProjectGroupReport, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.GetGilTeacherProjectGroupReportResponse
 */
export class GetGilTeacherProjectGroupReportResponse extends Message<GetGilTeacherProjectGroupReportResponse> {
  /**
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * @generated from field: geneo.lms.assessment.teacher.apis.GilTeacherProjectGroupReport data = 4;
   */
  data?: GilTeacherProjectGroupReport;

  constructor(data?: PartialMessage<GetGilTeacherProjectGroupReportResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.GetGilTeacherProjectGroupReportResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "data", kind: "message", T: GilTeacherProjectGroupReport },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetGilTeacherProjectGroupReportResponse {
    return new GetGilTeacherProjectGroupReportResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetGilTeacherProjectGroupReportResponse {
    return new GetGilTeacherProjectGroupReportResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetGilTeacherProjectGroupReportResponse {
    return new GetGilTeacherProjectGroupReportResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetGilTeacherProjectGroupReportResponse | PlainMessage<GetGilTeacherProjectGroupReportResponse> | undefined, b: GetGilTeacherProjectGroupReportResponse | PlainMessage<GetGilTeacherProjectGroupReportResponse> | undefined): boolean {
    return proto3.util.equals(GetGilTeacherProjectGroupReportResponse, a, b);
  }
}

/**
 * Dashboard 4 - one project, all groups.
 *
 * @generated from message geneo.lms.assessment.teacher.apis.GetGilTeacherProjectReportRequest
 */
export class GetGilTeacherProjectReportRequest extends Message<GetGilTeacherProjectReportRequest> {
  /**
   * @generated from field: int64 assessment_id = 1;
   */
  assessmentId = protoInt64.zero;

  constructor(data?: PartialMessage<GetGilTeacherProjectReportRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.GetGilTeacherProjectReportRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "assessment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetGilTeacherProjectReportRequest {
    return new GetGilTeacherProjectReportRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetGilTeacherProjectReportRequest {
    return new GetGilTeacherProjectReportRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetGilTeacherProjectReportRequest {
    return new GetGilTeacherProjectReportRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetGilTeacherProjectReportRequest | PlainMessage<GetGilTeacherProjectReportRequest> | undefined, b: GetGilTeacherProjectReportRequest | PlainMessage<GetGilTeacherProjectReportRequest> | undefined): boolean {
    return proto3.util.equals(GetGilTeacherProjectReportRequest, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.GilProjectGroupRow
 */
export class GilProjectGroupRow extends Message<GilProjectGroupRow> {
  /**
   * @generated from field: int64 student_group_id = 1;
   */
  studentGroupId = protoInt64.zero;

  /**
   * @generated from field: optional string group_name = 2;
   */
  groupName?: string;

  /**
   * @generated from field: int32 student_count = 3;
   */
  studentCount = 0;

  /**
   * Mean of the members' individual total time.
   *
   * @generated from field: float avg_time_in_sec = 4;
   */
  avgTimeInSec = 0;

  /**
   * The group mark, identical to the grading screen: mean of the members'
   * marks with an unmarked member counting as zero. Show it only when
   * graded_student_count > 0.
   *
   * @generated from field: float group_average_marks = 5;
   */
  groupAverageMarks = 0;

  /**
   * @generated from field: float max_marks = 6;
   */
  maxMarks = 0;

  /**
   * @generated from field: int32 graded_student_count = 7;
   */
  gradedStudentCount = 0;

  /**
   * @generated from field: geneo.lms.assessment.student.apis.GilProjectStatusEnum status = 8;
   */
  status = GilProjectStatusEnum.GIL_PROJECT_STATUS_UNDEFINED;

  /**
   * @generated from field: optional geneo.lms.assessment.student.apis.GilCodingSummary coding_summary = 9;
   */
  codingSummary?: GilCodingSummary;

  /**
   * The work unit's total: every member's sittings summed. On a shared device
   * this, not avg_time_in_sec, is how long the group worked.
   *
   * @generated from field: geneo.lms.assessment.student.apis.GilTimeSpent time_spent = 10;
   */
  timeSpent?: GilTimeSpent;

  /**
   * @generated from field: optional google.protobuf.Timestamp first_activity_at = 11;
   */
  firstActivityAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp last_activity_at = 12;
   */
  lastActivityAt?: Timestamp;

  constructor(data?: PartialMessage<GilProjectGroupRow>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.GilProjectGroupRow";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "student_group_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "group_name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "student_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "avg_time_in_sec", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 5, name: "group_average_marks", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 6, name: "max_marks", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 7, name: "graded_student_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "status", kind: "enum", T: proto3.getEnumType(GilProjectStatusEnum) },
    { no: 9, name: "coding_summary", kind: "message", T: GilCodingSummary, opt: true },
    { no: 10, name: "time_spent", kind: "message", T: GilTimeSpent },
    { no: 11, name: "first_activity_at", kind: "message", T: Timestamp, opt: true },
    { no: 12, name: "last_activity_at", kind: "message", T: Timestamp, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GilProjectGroupRow {
    return new GilProjectGroupRow().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GilProjectGroupRow {
    return new GilProjectGroupRow().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GilProjectGroupRow {
    return new GilProjectGroupRow().fromJsonString(jsonString, options);
  }

  static equals(a: GilProjectGroupRow | PlainMessage<GilProjectGroupRow> | undefined, b: GilProjectGroupRow | PlainMessage<GilProjectGroupRow> | undefined): boolean {
    return proto3.util.equals(GilProjectGroupRow, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.GilProjectOverview
 */
export class GilProjectOverview extends Message<GilProjectOverview> {
  /**
   * @generated from field: int32 student_count = 1;
   */
  studentCount = 0;

  /**
   * @generated from field: int32 group_count = 2;
   */
  groupCount = 0;

  /**
   * @generated from field: int32 completed_group_count = 3;
   */
  completedGroupCount = 0;

  /**
   * Mean of the students' individual total time, over students who spent any.
   *
   * @generated from field: float avg_time_in_sec = 4;
   */
  avgTimeInSec = 0;

  /**
   * Mean of obtained/max over graded students only. Absent when none is graded.
   *
   * @generated from field: optional float avg_project_score_percent = 5;
   */
  avgProjectScorePercent?: number;

  /**
   * Every student of the project, whichever group they are in.
   *
   * @generated from field: optional geneo.lms.assessment.student.apis.GilCodingSummary coding_summary = 6;
   */
  codingSummary?: GilCodingSummary;

  /**
   * Mean total time per work unit (group, or student on an individual
   * project), over units that spent any. The shared-device-safe average;
   * avg_time_in_sec above is login-based.
   *
   * @generated from field: float avg_time_per_group_in_sec = 7;
   */
  avgTimePerGroupInSec = 0;

  /**
   * @generated from field: geneo.lms.assessment.student.apis.GilProgressMetrics progress_metrics = 8;
   */
  progressMetrics?: GilProgressMetrics;

  constructor(data?: PartialMessage<GilProjectOverview>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.GilProjectOverview";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "student_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "group_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "completed_group_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "avg_time_in_sec", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 5, name: "avg_project_score_percent", kind: "scalar", T: 2 /* ScalarType.FLOAT */, opt: true },
    { no: 6, name: "coding_summary", kind: "message", T: GilCodingSummary, opt: true },
    { no: 7, name: "avg_time_per_group_in_sec", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 8, name: "progress_metrics", kind: "message", T: GilProgressMetrics },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GilProjectOverview {
    return new GilProjectOverview().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GilProjectOverview {
    return new GilProjectOverview().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GilProjectOverview {
    return new GilProjectOverview().fromJsonString(jsonString, options);
  }

  static equals(a: GilProjectOverview | PlainMessage<GilProjectOverview> | undefined, b: GilProjectOverview | PlainMessage<GilProjectOverview> | undefined): boolean {
    return proto3.util.equals(GilProjectOverview, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.GilTeacherProjectReport
 */
export class GilTeacherProjectReport extends Message<GilTeacherProjectReport> {
  /**
   * @generated from field: geneo.lms.assessment.student.apis.GilProjectInfo project = 1;
   */
  project?: GilProjectInfo;

  /**
   * @generated from field: geneo.lms.assessment.student.apis.GilClassSectionInfo class_section = 2;
   */
  classSection?: GilClassSectionInfo;

  /**
   * @generated from field: string teacher_name = 3;
   */
  teacherName = "";

  /**
   * False when the project was assigned without collaboration groups; `groups`
   * then holds the single section-wide group.
   *
   * @generated from field: bool is_collaborative = 4;
   */
  isCollaborative = false;

  /**
   * @generated from field: geneo.lms.assessment.teacher.apis.GilProjectOverview overview = 5;
   */
  overview?: GilProjectOverview;

  /**
   * @generated from field: repeated geneo.lms.assessment.teacher.apis.GilProjectGroupRow groups = 6;
   */
  groups: GilProjectGroupRow[] = [];

  /**
   * @generated from field: repeated geneo.lms.assessment.student.apis.GilGalleryItem gallery = 7;
   */
  gallery: GilGalleryItem[] = [];

  /**
   * What the teacher can act on, most urgent type first.
   *
   * @generated from field: repeated geneo.lms.assessment.student.apis.GilAttentionItem needs_attention = 8;
   */
  needsAttention: GilAttentionItem[] = [];

  /**
   * @generated from field: geneo.lms.assessment.student.apis.GilDataStatus data_status = 9;
   */
  dataStatus?: GilDataStatus;

  /**
   * Inferred learning outcome performance of every student of the project;
   * see GilLearningOutcomeScore.
   *
   * @generated from field: repeated geneo.lms.assessment.student.apis.GilLearningOutcomeScore learning_outcomes = 10;
   */
  learningOutcomes: GilLearningOutcomeScore[] = [];

  constructor(data?: PartialMessage<GilTeacherProjectReport>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.GilTeacherProjectReport";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "project", kind: "message", T: GilProjectInfo },
    { no: 2, name: "class_section", kind: "message", T: GilClassSectionInfo },
    { no: 3, name: "teacher_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "is_collaborative", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "overview", kind: "message", T: GilProjectOverview },
    { no: 6, name: "groups", kind: "message", T: GilProjectGroupRow, repeated: true },
    { no: 7, name: "gallery", kind: "message", T: GilGalleryItem, repeated: true },
    { no: 8, name: "needs_attention", kind: "message", T: GilAttentionItem, repeated: true },
    { no: 9, name: "data_status", kind: "message", T: GilDataStatus },
    { no: 10, name: "learning_outcomes", kind: "message", T: GilLearningOutcomeScore, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GilTeacherProjectReport {
    return new GilTeacherProjectReport().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GilTeacherProjectReport {
    return new GilTeacherProjectReport().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GilTeacherProjectReport {
    return new GilTeacherProjectReport().fromJsonString(jsonString, options);
  }

  static equals(a: GilTeacherProjectReport | PlainMessage<GilTeacherProjectReport> | undefined, b: GilTeacherProjectReport | PlainMessage<GilTeacherProjectReport> | undefined): boolean {
    return proto3.util.equals(GilTeacherProjectReport, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.GetGilTeacherProjectReportResponse
 */
export class GetGilTeacherProjectReportResponse extends Message<GetGilTeacherProjectReportResponse> {
  /**
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * @generated from field: geneo.lms.assessment.teacher.apis.GilTeacherProjectReport data = 4;
   */
  data?: GilTeacherProjectReport;

  constructor(data?: PartialMessage<GetGilTeacherProjectReportResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.GetGilTeacherProjectReportResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "data", kind: "message", T: GilTeacherProjectReport },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetGilTeacherProjectReportResponse {
    return new GetGilTeacherProjectReportResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetGilTeacherProjectReportResponse {
    return new GetGilTeacherProjectReportResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetGilTeacherProjectReportResponse {
    return new GetGilTeacherProjectReportResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetGilTeacherProjectReportResponse | PlainMessage<GetGilTeacherProjectReportResponse> | undefined, b: GetGilTeacherProjectReportResponse | PlainMessage<GetGilTeacherProjectReportResponse> | undefined): boolean {
    return proto3.util.equals(GetGilTeacherProjectReportResponse, a, b);
  }
}

/**
 * Dashboard 5 - one class section, all projects.
 *
 * @generated from message geneo.lms.assessment.teacher.apis.GetGilTeacherClassReportRequest
 */
export class GetGilTeacherClassReportRequest extends Message<GetGilTeacherClassReportRequest> {
  /**
   * school_class_section_id
   *
   * @generated from field: int64 section_id = 1;
   */
  sectionId = protoInt64.zero;

  constructor(data?: PartialMessage<GetGilTeacherClassReportRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.GetGilTeacherClassReportRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "section_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetGilTeacherClassReportRequest {
    return new GetGilTeacherClassReportRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetGilTeacherClassReportRequest {
    return new GetGilTeacherClassReportRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetGilTeacherClassReportRequest {
    return new GetGilTeacherClassReportRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetGilTeacherClassReportRequest | PlainMessage<GetGilTeacherClassReportRequest> | undefined, b: GetGilTeacherClassReportRequest | PlainMessage<GetGilTeacherClassReportRequest> | undefined): boolean {
    return proto3.util.equals(GetGilTeacherClassReportRequest, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.GilClassSummary
 */
export class GilClassSummary extends Message<GilClassSummary> {
  /**
   * "8/10" on the dashboard is projects_completed / projects_assigned. A
   * project is completed once every assigned student has submitted it.
   *
   * @generated from field: int32 projects_assigned = 1;
   */
  projectsAssigned = 0;

  /**
   * @generated from field: int32 projects_completed = 2;
   */
  projectsCompleted = 0;

  /**
   * @generated from field: geneo.lms.assessment.student.apis.GilTimeSpent total_time_spent = 3;
   */
  totalTimeSpent?: GilTimeSpent;

  /**
   * Mean of obtained/max over graded students of every project.
   *
   * @generated from field: optional float avg_project_score_percent = 4;
   */
  avgProjectScorePercent?: number;

  /**
   * The section's coding work across every project it has been assigned.
   *
   * @generated from field: optional geneo.lms.assessment.student.apis.GilCodingSummary coding_summary = 5;
   */
  codingSummary?: GilCodingSummary;

  /**
   * @generated from field: geneo.lms.assessment.student.apis.GilProgressMetrics progress_metrics = 6;
   */
  progressMetrics?: GilProgressMetrics;

  constructor(data?: PartialMessage<GilClassSummary>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.GilClassSummary";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "projects_assigned", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "projects_completed", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "total_time_spent", kind: "message", T: GilTimeSpent },
    { no: 4, name: "avg_project_score_percent", kind: "scalar", T: 2 /* ScalarType.FLOAT */, opt: true },
    { no: 5, name: "coding_summary", kind: "message", T: GilCodingSummary, opt: true },
    { no: 6, name: "progress_metrics", kind: "message", T: GilProgressMetrics },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GilClassSummary {
    return new GilClassSummary().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GilClassSummary {
    return new GilClassSummary().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GilClassSummary {
    return new GilClassSummary().fromJsonString(jsonString, options);
  }

  static equals(a: GilClassSummary | PlainMessage<GilClassSummary> | undefined, b: GilClassSummary | PlainMessage<GilClassSummary> | undefined): boolean {
    return proto3.util.equals(GilClassSummary, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.GilClassProjectRow
 */
export class GilClassProjectRow extends Message<GilClassProjectRow> {
  /**
   * @generated from field: geneo.lms.assessment.student.apis.GilProjectInfo project = 1;
   */
  project?: GilProjectInfo;

  /**
   * @generated from field: geneo.lms.assessment.student.apis.GilProjectStatusEnum status = 2;
   */
  status = GilProjectStatusEnum.GIL_PROJECT_STATUS_UNDEFINED;

  /**
   * Submitted students / assigned students, 0-100.
   *
   * @generated from field: float completion_percent = 3;
   */
  completionPercent = 0;

  /**
   * Mean of the students' individual total time, over students who spent any.
   *
   * @generated from field: float avg_time_in_sec = 4;
   */
  avgTimeInSec = 0;

  /**
   * @generated from field: optional float avg_project_score_percent = 5;
   */
  avgProjectScorePercent?: number;

  /**
   * @generated from field: optional geneo.lms.assessment.student.apis.GilCodingSummary coding_summary = 6;
   */
  codingSummary?: GilCodingSummary;

  /**
   * Mean total time per work unit, over units that spent any. avg_time_in_sec
   * above is login-based.
   *
   * @generated from field: float avg_time_per_group_in_sec = 7;
   */
  avgTimePerGroupInSec = 0;

  /**
   * @generated from field: geneo.lms.assessment.student.apis.GilProgressMetrics progress_metrics = 8;
   */
  progressMetrics?: GilProgressMetrics;

  constructor(data?: PartialMessage<GilClassProjectRow>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.GilClassProjectRow";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "project", kind: "message", T: GilProjectInfo },
    { no: 2, name: "status", kind: "enum", T: proto3.getEnumType(GilProjectStatusEnum) },
    { no: 3, name: "completion_percent", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 4, name: "avg_time_in_sec", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 5, name: "avg_project_score_percent", kind: "scalar", T: 2 /* ScalarType.FLOAT */, opt: true },
    { no: 6, name: "coding_summary", kind: "message", T: GilCodingSummary, opt: true },
    { no: 7, name: "avg_time_per_group_in_sec", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 8, name: "progress_metrics", kind: "message", T: GilProgressMetrics },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GilClassProjectRow {
    return new GilClassProjectRow().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GilClassProjectRow {
    return new GilClassProjectRow().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GilClassProjectRow {
    return new GilClassProjectRow().fromJsonString(jsonString, options);
  }

  static equals(a: GilClassProjectRow | PlainMessage<GilClassProjectRow> | undefined, b: GilClassProjectRow | PlainMessage<GilClassProjectRow> | undefined): boolean {
    return proto3.util.equals(GilClassProjectRow, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.GilTeacherClassReport
 */
export class GilTeacherClassReport extends Message<GilTeacherClassReport> {
  /**
   * @generated from field: string teacher_name = 1;
   */
  teacherName = "";

  /**
   * @generated from field: geneo.lms.assessment.student.apis.GilClassSectionInfo class_section = 2;
   */
  classSection?: GilClassSectionInfo;

  /**
   * @generated from field: int32 student_count = 3;
   */
  studentCount = 0;

  /**
   * Distinct collaboration group names used across the section's projects.
   *
   * @generated from field: int32 group_count = 4;
   */
  groupCount = 0;

  /**
   * @generated from field: geneo.lms.assessment.teacher.apis.GilClassSummary summary = 5;
   */
  summary?: GilClassSummary;

  /**
   * Ordered by chapter number, then assignment date.
   *
   * @generated from field: repeated geneo.lms.assessment.teacher.apis.GilClassProjectRow projects = 6;
   */
  projects: GilClassProjectRow[] = [];

  /**
   * Uploads of every group (or student) that has submitted its project.
   *
   * @generated from field: repeated geneo.lms.assessment.student.apis.GilGalleryItem gallery = 7;
   */
  gallery: GilGalleryItem[] = [];

  /**
   * What the teacher can act on across every project, most urgent type first.
   *
   * @generated from field: repeated geneo.lms.assessment.student.apis.GilAttentionItem needs_attention = 8;
   */
  needsAttention: GilAttentionItem[] = [];

  /**
   * Up to the last 26 weeks, oldest first; enrolled_students is student_count.
   *
   * @generated from field: repeated geneo.lms.assessment.student.apis.GilWeeklyPoint weekly_trend = 9;
   */
  weeklyTrend: GilWeeklyPoint[] = [];

  /**
   * @generated from field: geneo.lms.assessment.student.apis.GilDataStatus data_status = 10;
   */
  dataStatus?: GilDataStatus;

  /**
   * Inferred learning outcome performance across every project of the
   * section; see GilLearningOutcomeScore.
   *
   * @generated from field: repeated geneo.lms.assessment.student.apis.GilLearningOutcomeScore learning_outcomes = 11;
   */
  learningOutcomes: GilLearningOutcomeScore[] = [];

  constructor(data?: PartialMessage<GilTeacherClassReport>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.GilTeacherClassReport";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "teacher_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "class_section", kind: "message", T: GilClassSectionInfo },
    { no: 3, name: "student_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "group_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "summary", kind: "message", T: GilClassSummary },
    { no: 6, name: "projects", kind: "message", T: GilClassProjectRow, repeated: true },
    { no: 7, name: "gallery", kind: "message", T: GilGalleryItem, repeated: true },
    { no: 8, name: "needs_attention", kind: "message", T: GilAttentionItem, repeated: true },
    { no: 9, name: "weekly_trend", kind: "message", T: GilWeeklyPoint, repeated: true },
    { no: 10, name: "data_status", kind: "message", T: GilDataStatus },
    { no: 11, name: "learning_outcomes", kind: "message", T: GilLearningOutcomeScore, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GilTeacherClassReport {
    return new GilTeacherClassReport().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GilTeacherClassReport {
    return new GilTeacherClassReport().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GilTeacherClassReport {
    return new GilTeacherClassReport().fromJsonString(jsonString, options);
  }

  static equals(a: GilTeacherClassReport | PlainMessage<GilTeacherClassReport> | undefined, b: GilTeacherClassReport | PlainMessage<GilTeacherClassReport> | undefined): boolean {
    return proto3.util.equals(GilTeacherClassReport, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.teacher.apis.GetGilTeacherClassReportResponse
 */
export class GetGilTeacherClassReportResponse extends Message<GetGilTeacherClassReportResponse> {
  /**
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * @generated from field: geneo.lms.assessment.teacher.apis.GilTeacherClassReport data = 4;
   */
  data?: GilTeacherClassReport;

  constructor(data?: PartialMessage<GetGilTeacherClassReportResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.teacher.apis.GetGilTeacherClassReportResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "data", kind: "message", T: GilTeacherClassReport },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetGilTeacherClassReportResponse {
    return new GetGilTeacherClassReportResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetGilTeacherClassReportResponse {
    return new GetGilTeacherClassReportResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetGilTeacherClassReportResponse {
    return new GetGilTeacherClassReportResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetGilTeacherClassReportResponse | PlainMessage<GetGilTeacherClassReportResponse> | undefined, b: GetGilTeacherClassReportResponse | PlainMessage<GetGilTeacherClassReportResponse> | undefined): boolean {
    return proto3.util.equals(GetGilTeacherClassReportResponse, a, b);
  }
}

